<template>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：絞り込み条件画面(STDSDC01C09)                                                                     _/
         _/                                                                                                                    _/
         _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
  <BaseModal :show="isShow">
    <div class="popup" style="width: 1160px">
      <div class="popup-head">絞り込み条件</div>
      <div class="popup-body blue">
        <!--
          ****  メッセージ表示領域 ****
          -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p :style="{ 'margin-top': errors.length > 0 ? '20px' : '' }">
          絞り込み条件を設定してください。
        </p>
        <div style="height: 360px; overflow-y: scroll">
          <div class="frm-row">
            <span
              class="frm-label"
              :class="pageId != 'STDSDC03C03' ? 'w-160px' : 'w-140px'"
              >検索キーワード</span
            >
            <div class="frm-search frm-size-keyword">
              <span class="frm-label">
                &nbsp;
                <img src="@/assets/images/TDSDC/icon_search.png" />
              </span>
              <input
                type="search"
                id="search"
                ref="search"
                name="searchBox"
                v-model.trim="searchKey"
                placeholder="検索キーワード"
                maxlength="255"
                size="84"
                class="frm-search-text"
              />
            </div>
          </div>
          <br v-if="filterViewsDisplay.DisplayFlagsBusiness?.title != false" />
          <div v-if="filterViewsDisplay.ClassificationControlBusinessInfo">
            <p v-if="filterViewsDisplay.DisplayFlagsBusiness?.title">
              <strong>事業者情報</strong>
            </p>
            <div
              :class="[
                filterViewsDisplay.DisplayFlagsBusiness?.title ? 'para' : '',
              ]"
            >
              <div
                class="frm-row"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.BusinessCode"
              >
                <span class="frm-label w-140px">事業者コード</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.CompanyCodeCondition"
                  @change="handleBopCodeChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  class="frm-text frm-size-xxml"
                  maxlength="10"
                  v-model.trim="businessInfoArea.CompanyCode"
                  :disabled="isBopCodeDisabled"
                  :class="{ error: businessInfoArea.isErrorBopCode }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="businessInfoArea.isErrorBopCodeMsg != ''"
              >
                <ErrorMessageCase
                  :errors="businessInfoArea.isErrorBopCodeMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.BusinessName"
              >
                <span class="frm-label w-140px">事業者名</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.CompanyNameCondition"
                  @change="handleBopNameChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="100"
                  v-model.trim="businessInfoArea.CompanyName"
                  :disabled="isBopNameDisabled"
                  :class="{ error: businessInfoArea.isErrorBopName }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="businessInfoArea.isErrorBopNameMsg != ''"
              >
                <ErrorMessageCase
                  :errors="businessInfoArea.isErrorBopNameMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="
                  filterViewsDisplay.DisplayFlagsBusiness
                    .CorporateIndividualClassification
                "
              >
                <span class="frm-label w-140px">法人個人区分</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.BusinessOperatorType"
                  @change="handleCorproationDivisionChange"
                  :class="{
                    error: businessInfoArea.isErrorCorproationDivision,
                  }"
                >
                  <option
                    v-for="item in corproationDivisionList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <!-- <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="52"
                  v-show="this.businessInfoArea.corproationDivisionFlag"
                  v-model="businessInfoArea.corproationDivision"
                  :disabled="isCorproationDivisionDisabled"
                  :class="{
                    error: businessInfoArea.isErrorCorproationDivision,
                  }"
                /> -->
              </div>
              <div
                class="frm-row"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.SettlementDate"
              >
                <span class="frm-label w-140px">決算日</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.KessanDateCondition"
                  @change="handleDetailDesignatedDateChange"
                >
                  <option
                    v-for="item in detailDesignatedDateList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailDesignatedDateStartDisabled"
                  v-model="businessInfoArea.KessanDateFromMonth"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :class="{
                    error: businessInfoArea.isErrorKessanDateFromMonth,
                  }"
                />
                <span class="frm-unit">月</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailDesignatedDateStartDisabled"
                  v-model="businessInfoArea.KessanDateFromDay"
                  v-show="isShowKessanDateFromDay"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :class="{ error: businessInfoArea.isErrorKessanDateFromDay }"
                />
                <span class="frm-unit" v-show="isShowKessanDateFromDay"
                  >日</span
                >
                <span class="frm-unit" v-show="detailDesignatedDateEndFlag"
                  >～</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  v-show="detailDesignatedDateEndFlag"
                  v-model="businessInfoArea.KessanDateToMonth"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :class="{ error: businessInfoArea.isErrorKessanDateToMonth }"
                />
                <span class="frm-unit" v-show="detailDesignatedDateEndFlag"
                  >月</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  v-show="detailDesignatedDateEndFlag"
                  v-model="businessInfoArea.KessanDateToDay"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :class="{ error: businessInfoArea.isErrorKessanDateToDay }"
                />
                <span class="frm-unit" v-show="detailDesignatedDateEndFlag"
                  >日</span
                >
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="businessInfoArea.isErrorKessanDateMsg != ''"
              >
                <ErrorMessageCase
                  :errors="businessInfoArea.isErrorKessanDateMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.MainCharge"
              >
                <span class="frm-label w-140px">主担当者</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.managerSelected"
                  @change="handleManagerChange"
                >
                  <option
                    v-for="item in managerSelectedCondition"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="100"
                  v-model.trim="businessInfoArea.manager"
                  :disabled="isManagerDisabled"
                  :class="{ error: businessInfoArea.isErrorManager }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="businessInfoArea.isErrorManagerMsg != ''"
              >
                <ErrorMessageCase
                  :errors="businessInfoArea.isErrorManagerMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.BusinessAccount"
              >
                <span class="frm-label w-140px">事業者アカウント</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.BopAccountCondition"
                  @change="handleBusinessAccountChange"
                >
                  <option
                    v-for="item in businessAccountList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <!-- <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  v-show="this.businessInfoArea.businessAccountFlag"
                  maxlength="52"
                  v-model="businessInfoArea.businessAccount"
                  :disabled="isBusinessAccountDisabled"
                  :class="{ error: businessInfoArea.isErrorBusinessAccount }"
                /> -->
              </div>
              <div
                class="frm-row frm-row-margin-top"
                v-if="
                  filterViewsDisplay.DisplayFlagsBusiness
                    .BusinessFunctionRelease
                "
              >
                <span class="frm-label w-140px"
                  >事業者に対する機能利用権限</span
                >
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.BopOpenFunctionCondition"
                  @change="handleBusinessFunctionReleaseChange"
                >
                  <option
                    v-for="item in businessFunctionReleaseList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <!-- <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  v-show="this.businessInfoArea.businessFunctionReleaseFlag"
                  maxlength="52"
                  v-model="businessInfoArea.businessFunctionRelease"
                  :disabled="isBusinessFunctionReleaseDisabled"
                  :class="{
                    error: businessInfoArea.isErrorBusinessFunctionRelease,
                  }"
                /> -->
              </div>
              <div
                class="frm-row frm-row-margin-top"
                v-if="true"
              >
                <span class="frm-label w-140px"
                  >事業者機能利用権限(電帳法)</span
                >
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.BopOpenFunctionCondition"
                  @change="handleBusinessFunctionReleaseChange"
                >
                  <option
                    v-for="item in businessFunctionReleaseList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <!-- <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  v-show="this.businessInfoArea.businessFunctionReleaseFlag"
                  maxlength="52"
                  v-model="businessInfoArea.businessFunctionRelease"
                  :disabled="isBusinessFunctionReleaseDisabled"
                  :class="{
                    error: businessInfoArea.isErrorBusinessFunctionRelease,
                  }"
                /> -->
              </div>
              <div
                class="frm-row"
                v-if="
                  filterViewsDisplay.DisplayFlagsBusiness
                    .BusinessNotificationDestination
                "
              >
                <span class="frm-label w-140px">事業者からの通知先</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.NotificationFromBopCondition"
                  @change="handleNotificationDestinationChange"
                >
                  <option
                    v-for="item in notificationDestinationList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="filterViewsDisplay.ClassificationControlDeclarationInfo">
            <p v-if="filterViewsDisplay.DisplayFlagsDeclaration?.title">
              <strong>申告書等情報</strong>
            </p>
            <div class="para">
              <div class="frm-row">
                <span class="frm-label w-140px">申告書等</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="declarationFormInfoArea.TaxCategoryListCondition"
                  @change="handleTaxCategoryListChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  type="text"
                  maxlength="100"
                  class="frm-text frm-size-xxml"
                  v-model.trim="declarationFormInfoArea.TaxCategoryList"
                  :disabled="isTaxCategoryListDisabled"
                  :class="{
                    error: declarationFormInfoArea.isErrorTaxCategoryList,
                  }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="declarationFormInfoArea.isErrorTaxCategoryListMsg != ''"
              >
                <ErrorMessageCase
                  :errors="declarationFormInfoArea.isErrorTaxCategoryListMsg"
                ></ErrorMessageCase>
              </p>
              <div class="frm-row frm-row-margin-top">
                <span class="frm-label w-140px">法人データ</span>
              </div>
              <div
                class="frm-row"
                v-if="
                  filterViewsDisplay.DisplayFlagsDeclaration?.FiscalYearStart
                "
              >
                <span class="frm-label w-140px">　事業年度等（開始）</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="declarationFormInfoArea.fiscalYearStartCondition"
                  @change="handleDetailBusinessYearStartChange"
                >
                  <option
                    v-for="item in detailBusinessYearStartEndList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <select
                  class="frm-select"
                  :disabled="isDetailBusinessYearStartFirDisabled"
                  v-model="declarationFormInfoArea.fiscalYearStartFromGengo"
                  @change="handleDetailBusinessYearStartFirChange"
                >
                  <option
                    v-for="item in yearList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailBusinessYearStartFirDisabled"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartFromYear,
                  }"
                  v-model="declarationFormInfoArea.fiscalYearStartFromYear"
                />
                <span class="frm-unit">年</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailBusinessYearStartFirDisabled"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartFromMonth,
                  }"
                  v-model="declarationFormInfoArea.fiscalYearStartFromMonth"
                />
                <span class="frm-unit">月</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailBusinessYearStartFirDisabled"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartFromDay,
                  }"
                  v-model="declarationFormInfoArea.fiscalYearStartFromDay"
                  v-show="isShowfiscalYearStartFromDay"
                />
                <span class="frm-unit" v-show="isShowfiscalYearStartFromDay"
                  >日</span
                >
                <span class="frm-unit" v-show="detailBusinessYearStartSecFlag"
                  >～</span
                >
                <select
                  class="frm-select"
                  v-show="detailBusinessYearStartSecFlag"
                  v-model="declarationFormInfoArea.fiscalYearStartToGengo"
                  @change="handleDetailBusinessYearStartSecChange"
                >
                  <option
                    v-for="item in yearList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorFiscalYearStartToYear,
                  }"
                  v-show="detailBusinessYearStartSecFlag"
                  v-model="declarationFormInfoArea.fiscalYearStartToYear"
                />
                <span class="frm-unit" v-show="detailBusinessYearStartSecFlag"
                  >年</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartToMonth,
                  }"
                  v-show="detailBusinessYearStartSecFlag"
                  v-model="declarationFormInfoArea.fiscalYearStartToMonth"
                />
                <span class="frm-unit" v-show="detailBusinessYearStartSecFlag"
                  >月</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorFiscalYearStartToDay,
                  }"
                  v-show="detailBusinessYearStartSecFlag"
                  v-model="declarationFormInfoArea.fiscalYearStartToDay"
                />
                <span class="frm-unit" v-show="detailBusinessYearStartSecFlag"
                  >日</span
                >
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="declarationFormInfoArea.isErrorFiscalYearStartMsg != ''"
              >
                <ErrorMessageCase
                  :errors="declarationFormInfoArea.isErrorFiscalYearStartMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsDeclaration?.FiscalYearEnd"
              >
                <span class="frm-label w-140px">　事業年度等（終了）</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="declarationFormInfoArea.JigyoNendoToCondition"
                  @change="handleDetailBusinessYearEndChange"
                >
                  <option
                    v-for="item in detailBusinessYearStartEndList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <select
                  class="frm-select"
                  :disabled="isDetailBusinessYearEndFirDisabled"
                  v-model="declarationFormInfoArea.JigyoNendoToGengo"
                  @change="handleDetailBusinessYearEndFirChange"
                >
                  <option
                    v-for="item in yearList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorJigyoNendoToYear,
                  }"
                  :disabled="isDetailBusinessYearEndFirDisabled"
                  v-model="declarationFormInfoArea.JigyoNendoToYear"
                />
                <span class="frm-unit">年</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorJigyoNendoToMonth,
                  }"
                  :disabled="isDetailBusinessYearEndFirDisabled"
                  v-model="declarationFormInfoArea.JigyoNendoToMonth"
                />
                <span class="frm-unit">月</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorJigyoNendoToDay,
                  }"
                  :disabled="isDetailBusinessYearEndFirDisabled"
                  v-model="declarationFormInfoArea.JigyoNendoToDay"
                  v-show="isShowJigyoNendoToDay"
                />
                <span class="frm-unit" v-show="isShowJigyoNendoToDay">日</span>
                <span class="frm-unit" v-show="detailBusinessYearEndSecFlag"
                  >～</span
                >
                <select
                  class="frm-select"
                  v-show="detailBusinessYearEndSecFlag"
                  v-model="declarationFormInfoArea.fiscalYearEndToGengo"
                  @change="handleDetailBusinessYearEndSecChange"
                >
                  <option
                    v-for="item in yearList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorFiscalYearEndToYear,
                  }"
                  v-show="detailBusinessYearEndSecFlag"
                  v-model="declarationFormInfoArea.fiscalYearEndToYear"
                />
                <span class="frm-unit" v-show="detailBusinessYearEndSecFlag"
                  >年</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorFiscalYearEndToMonth,
                  }"
                  v-show="detailBusinessYearEndSecFlag"
                  v-model="declarationFormInfoArea.fiscalYearEndToMonth"
                />
                <span class="frm-unit" v-show="detailBusinessYearEndSecFlag"
                  >月</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorFiscalYearEndToDay,
                  }"
                  v-show="detailBusinessYearEndSecFlag"
                  v-model="declarationFormInfoArea.fiscalYearEndToDay"
                />
                <span class="frm-unit" v-show="detailBusinessYearEndSecFlag"
                  >日</span
                >
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="declarationFormInfoArea.isErrorFiscalYearEndMsg != ''"
              >
                <ErrorMessageCase
                  :errors="declarationFormInfoArea.isErrorFiscalYearEndMsg"
                ></ErrorMessageCase>
              </p>
              <div class="frm-row frm-row-margin-top">
                <span class="frm-label w-140px">個人データ</span>
              </div>
              <div
                class="frm-row"
                v-if="
                  filterViewsDisplay.DisplayFlagsDeclaration?.FiscalYearStart
                "
              >
                <span class="frm-label w-140px">　事業年度等（開始）</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="
                    declarationFormInfoArea.fiscalYearStartConditionKojin
                  "
                  @change="handleDetailBusinessYearStartChangeKojin"
                >
                  <option
                    v-for="item in detailBusinessYearStartEndList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <select
                  class="frm-select"
                  :disabled="isDetailBusinessYearStartFirDisabledKojin"
                  v-model="
                    declarationFormInfoArea.fiscalYearStartFromGengoKojin
                  "
                  @change="handleDetailBusinessYearStartFirChangeKojin"
                >
                  <option
                    v-for="item in yearList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailBusinessYearStartFirDisabledKojin"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartFromYearKojin,
                  }"
                  v-model="declarationFormInfoArea.fiscalYearStartFromYearKojin"
                />
                <span class="frm-unit">年</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailBusinessYearStartFirDisabledKojin"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartFromMonthKojin,
                  }"
                  v-model="
                    declarationFormInfoArea.fiscalYearStartFromMonthKojin
                  "
                />
                <span class="frm-unit">月</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailBusinessYearStartFirDisabledKojin"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartFromDayKojin,
                  }"
                  v-model="declarationFormInfoArea.fiscalYearStartFromDayKojin"
                  v-show="isShowFiscalYearStartFromDayKojin"
                />
                <span
                  class="frm-unit"
                  v-show="isShowFiscalYearStartFromDayKojin"
                  >日</span
                >
                <span
                  class="frm-unit"
                  v-show="detailBusinessYearStartSecFlagKojin"
                  >～</span
                >
                <select
                  class="frm-select"
                  v-show="detailBusinessYearStartSecFlagKojin"
                  v-model="declarationFormInfoArea.fiscalYearStartToGengoKojin"
                  @change="handleDetailBusinessYearStartSecChangeKojin"
                >
                  <option
                    v-for="item in yearList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartToYearKojin,
                  }"
                  v-show="detailBusinessYearStartSecFlagKojin"
                  v-model="declarationFormInfoArea.fiscalYearStartToYearKojin"
                />
                <span
                  class="frm-unit"
                  v-show="detailBusinessYearStartSecFlagKojin"
                  >年</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartToMonthKojin,
                  }"
                  v-show="detailBusinessYearStartSecFlagKojin"
                  v-model="declarationFormInfoArea.fiscalYearStartToMonthKojin"
                />
                <span
                  class="frm-unit"
                  v-show="detailBusinessYearStartSecFlagKojin"
                  >月</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearStartToDayKojin,
                  }"
                  v-show="detailBusinessYearStartSecFlagKojin"
                  v-model="declarationFormInfoArea.fiscalYearStartToDayKojin"
                />
                <span
                  class="frm-unit"
                  v-show="detailBusinessYearStartSecFlagKojin"
                  >日</span
                >
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="
                  declarationFormInfoArea.isErrorFiscalYearStartMsgKojin != ''
                "
              >
                <ErrorMessageCase
                  :errors="
                    declarationFormInfoArea.isErrorFiscalYearStartMsgKojin
                  "
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsDeclaration?.FiscalYearEnd"
              >
                <span class="frm-label w-140px">　事業年度等（終了）</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="declarationFormInfoArea.JigyoNendoToConditionKojin"
                  @change="handleDetailBusinessYearEndChangeKojin"
                >
                  <option
                    v-for="item in detailBusinessYearStartEndList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <select
                  class="frm-select"
                  :disabled="isDetailBusinessYearEndFirDisabledKojin"
                  v-model="declarationFormInfoArea.JigyoNendoToGengoKojin"
                  @change="handleDetailBusinessYearEndFirChangeKojin"
                >
                  <option
                    v-for="item in yearList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorJigyoNendoToYearKojin,
                  }"
                  :disabled="isDetailBusinessYearEndFirDisabledKojin"
                  v-model="declarationFormInfoArea.JigyoNendoToYearKojin"
                />
                <span class="frm-unit">年</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorJigyoNendoToMonthKojin,
                  }"
                  :disabled="isDetailBusinessYearEndFirDisabledKojin"
                  v-model="declarationFormInfoArea.JigyoNendoToMonthKojin"
                />
                <span class="frm-unit">月</span>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error: declarationFormInfoArea.isErrorJigyoNendoToDayKojin,
                  }"
                  :disabled="isDetailBusinessYearEndFirDisabledKojin"
                  v-model="declarationFormInfoArea.JigyoNendoToDayKojin"
                  v-show="isShowJigyoNendoToDayKojin"
                />
                <span class="frm-unit" v-show="isShowJigyoNendoToDayKojin"
                  >日</span
                >
                <span
                  class="frm-unit"
                  v-show="detailBusinessYearEndSecFlagKojin"
                  >～</span
                >
                <select
                  class="frm-select"
                  v-show="detailBusinessYearEndSecFlagKojin"
                  v-model="declarationFormInfoArea.fiscalYearEndToGengoKojin"
                  @change="handleDetailBusinessYearEndSecChangeKojin"
                >
                  <option
                    v-for="item in yearList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearEndToYearKojin,
                  }"
                  v-show="detailBusinessYearEndSecFlagKojin"
                  v-model="declarationFormInfoArea.fiscalYearEndToYearKojin"
                />
                <span
                  class="frm-unit"
                  v-show="detailBusinessYearEndSecFlagKojin"
                  >年</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearEndToMonthKojin,
                  }"
                  v-show="detailBusinessYearEndSecFlagKojin"
                  v-model="declarationFormInfoArea.fiscalYearEndToMonthKojin"
                />
                <span
                  class="frm-unit"
                  v-show="detailBusinessYearEndSecFlagKojin"
                  >月</span
                >
                <input
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :class="{
                    error:
                      declarationFormInfoArea.isErrorFiscalYearEndToDayKojin,
                  }"
                  v-show="detailBusinessYearEndSecFlagKojin"
                  v-model="declarationFormInfoArea.fiscalYearEndToDayKojin"
                />
                <span
                  class="frm-unit"
                  v-show="detailBusinessYearEndSecFlagKojin"
                  >日</span
                >
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="
                  declarationFormInfoArea.isErrorFiscalYearEndMsgKojin != ''
                "
              >
                <ErrorMessageCase
                  :errors="declarationFormInfoArea.isErrorFiscalYearEndMsgKojin"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsDeclaration?.DataPartition"
                style="align-items: flex-start"
              >
                <div>
                  <span class="frm-label w-140px">データ区分</span>
                </div>
                <div style="width: 66%">
                  <label
                    class="frm-checkbox"
                    style="margin-left: 9.5px; width: 15%"
                    v-for="item in dataTypeArray"
                    :key="item.code"
                  >
                    <input
                      type="checkbox"
                      v-model="declarationFormInfoArea.DataKbn"
                      :value="item.code"
                      @click="handleClickDataType($event, item)"
                    />
                    <span
                      class="checkbox-item"
                      tabindex="0"
                      @keydown.space.stop.prevent="
                        handleClickDataType($event, item)
                      "
                    ></span>
                    <span class="checkbox-text">{{ item.name }}</span>
                  </label>
                </div>
              </div>
              <div
                class="frm-row"
                v-if="filterViewsDisplay.DisplayFlagsDeclaration?.DataName"
              >
                <span class="frm-label w-140px">データ名称</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="declarationFormInfoArea.DataNameCondition"
                  @change="handleDataNameChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="50"
                  v-model.trim="declarationFormInfoArea.DataName"
                  :disabled="isDataNameDisabled"
                  :class="{ error: declarationFormInfoArea.isErrorDataName }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="declarationFormInfoArea.isErrorDataNameMsg != ''"
              >
                <ErrorMessageCase
                  :errors="declarationFormInfoArea.isErrorDataNameMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="
                  filterViewsDisplay.DisplayFlagsDeclaration
                    ?.CollectedDocumentinfo
                "
              >
                <span class="frm-label w-140px">収集状況</span>
                <label
                  class="frm-checkbox"
                  style="margin-left: 7px"
                  v-for="item in documentStatusArray"
                  :key="item.code"
                >
                  <input
                    type="checkbox"
                    v-model="declarationFormInfoArea.Status"
                    :value="item.code"
                    @click="
                      handleClick($event, item, declarationFormInfoArea.Status)
                    "
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="
                      handleClick($event, item, declarationFormInfoArea.Status)
                    "
                  ></span>
                  <span class="checkbox-text">{{ item.name }}</span>
                </label>
              </div>
            </div>
            <br />
          </div>
          <div v-if="filterViewsDisplay.ClassificationControlAccessInfo">
            <p v-if="filterViewsDisplay.DisplayFlagsProcessing?.title">
              <strong>{{
                filterViewsDisplay.DisplayFlagsProcessing?.titleName
              }}</strong>
            </p>
            <div class="para">
              <div
                class="frm-row"
                v-if="filterViewsDisplay.DisplayFlagsProcessing?.ProcessingTime"
              >
                <span class="frm-label w-140px">{{
                  filterViewsDisplay.DisplayFlagsProcessing?.dateNameText
                }}</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="accessInfoArea.AccessDateCondition"
                  @change="handleProcessingDateTimeChange"
                >
                  <option
                    v-for="item in operationDateCondition"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  ref="accessDateFrom"
                  type="date"
                  style="width: 210px"
                  class="frm-text"
                  v-show="!isAccessDateTypeMonthShow"
                  :class="{
                    error:
                      accessInfoArea.isErrorAccessDateFromYear ||
                      accessInfoArea.isErrorAccessDateFromMonth ||
                      accessInfoArea.isErrorAccessDateFromDay,
                  }"
                  :disabled="isProcessingDateTimeStartDisabled"
                  v-model="accessInfoArea.AccessDateFromYMD"
                  @change="dateSplit"
                />
                <input
                  ref="accessDateFromMonth"
                  type="month"
                  style="width: 210px"
                  class="frm-text"
                  v-show="isAccessDateTypeMonthShow"
                  :class="{
                    error:
                      accessInfoArea.isErrorAccessDateFromYear ||
                      accessInfoArea.isErrorAccessDateFromMonth,
                  }"
                  :disabled="isProcessingDateTimeStartDisabled"
                  v-model="accessInfoArea.AccessDateFromYM"
                  @change="dateSplit"
                />
                <span class="frm-unit" v-show="processingDateTimeEndFlag"
                  >　～　</span
                >
                <input
                  ref="accessDateTo"
                  type="date"
                  style="width: 210px"
                  class="frm-text"
                  :class="{
                    error:
                      accessInfoArea.isErrorAccessDateToYear ||
                      accessInfoArea.isErrorAccessDateToMonth ||
                      accessInfoArea.isErrorAccessDateToDay,
                  }"
                  v-show="processingDateTimeEndFlag"
                  v-model="accessInfoArea.AccessDateToYMD"
                  @change="dateSplit"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="accessInfoArea.isErrorAccessDateMsg != ''"
              >
                <ErrorMessageCase
                  :errors="accessInfoArea.isErrorAccessDateMsg"
                ></ErrorMessageCase>
              </p>

              <div
                class="frm-row frm-row-margin-top"
                id="treatmentTarget"
                v-if="filterViewsDisplay.DisplayFlagsProcessing?.TreamTarget"
              >
                <span class="frm-label w-140px">処理対象</span>
                <label
                  class="frm-checkbox"
                  style="margin-left: 7px"
                  v-for="item in treatmentTargetArray"
                  :key="item.code"
                >
                  <input
                    type="checkbox"
                    checked="checkd"
                    v-model="accessInfoArea.treatmentTarget"
                    :value="item.code"
                    @click="
                      handleClick($event, item, accessInfoArea.treatmentTarget)
                    "
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="
                      handleClick($event, item, accessInfoArea.treatmentTarget)
                    "
                  ></span>
                  <span class="checkbox-text">{{ item.name }}</span>
                </label>
              </div>
              <div
                class="frm-row"
                v-if="filterViewsDisplay.DisplayFlagsProcessing?.ProcessingData"
              >
                <span class="frm-label w-140px">処理データ</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="accessInfoArea.processingDataCondition"
                  @change="handleProcessingDataChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="100"
                  v-model.trim="accessInfoArea.processingData"
                  :disabled="isProcessingDataDisabled"
                  :class="{ error: accessInfoArea.isErrorProcessingData }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="accessInfoArea.isErrorProcessingDataMsg != ''"
              >
                <ErrorMessageCase
                  :errors="accessInfoArea.isErrorProcessingDataMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                id="ProcessingPartition"
                v-if="
                  filterViewsDisplay.DisplayFlagsProcessing?.ProcessingPartition
                "
              >
                <span class="frm-label w-140px">処理区分</span>
                <label
                  class="frm-checkbox"
                  style="margin-left: 7px"
                  v-for="item in processingDivisionArray"
                  :key="item.code"
                >
                  <input
                    type="checkbox"
                    checked="checkd"
                    v-model="accessInfoArea.ProcessingDivision"
                    :value="item.code"
                    @click="
                      handleClick(
                        $event,
                        item,
                        accessInfoArea.ProcessingDivision
                      )
                    "
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="
                      handleClick(
                        $event,
                        item,
                        accessInfoArea.ProcessingDivision
                      )
                    "
                  ></span>
                  <span class="checkbox-text">{{ item.name }}</span>
                </label>
              </div>
              <div
                class="frm-row"
                v-if="filterViewsDisplay.DisplayFlagsProcessing?.BopUser"
                v-show="STDSDC05C08FilterInit.accountType == '2'"
              >
                <span class="frm-label w-140px">事業者情報</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="accessInfoArea.bopUserCondition"
                  @change="handleBopUserChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="50"
                  v-model.trim="accessInfoArea.bopUser"
                  :disabled="isBopUserDisabled"
                  :class="{ error: accessInfoArea.isErrorBopUser }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="accessInfoArea.isErrorBopUserMsg != ''"
              >
                <ErrorMessageCase
                  :errors="accessInfoArea.isErrorBopUserMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsProcessing?.LoginInID"
              >
                <span class="frm-label w-140px">ログインID</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="accessInfoArea.LoginIDCondition"
                  @change="handleLoginInIDChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="50"
                  v-model.trim="accessInfoArea.LoginID"
                  :disabled="isLoginInIDDisabled"
                  :class="{ error: accessInfoArea.isErrorLoginInID }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="accessInfoArea.isErrorLoginInIDMsg != ''"
              >
                <ErrorMessageCase
                  :errors="accessInfoArea.isErrorLoginInIDMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsProcessing?.UserNameID"
              >
                <span class="frm-label w-140px">利用者名</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="accessInfoArea.UserNameCondition"
                  @change="handleUserNameChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="100"
                  v-model.trim="accessInfoArea.UserName"
                  :disabled="isUserNameDisabled"
                  :class="{ error: accessInfoArea.isErrorUserName }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="accessInfoArea.isErrorUserNameMsg != ''"
              >
                <ErrorMessageCase
                  :errors="accessInfoArea.isErrorUserNameMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsProcessing?.IPIdress"
              >
                <span class="frm-label w-140px">IPアドレス</span>
                <select
                  class="frm-select frm-size-l"
                  v-model="accessInfoArea.IPAddressCondition"
                  @change="handleIPAddressChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  title=" "
                  type="url"
                  class="frm-text frm-size-xxml"
                  maxlength="15"
                  v-model.trim="accessInfoArea.IPAddress"
                  :disabled="isIPAddressDisabled"
                  :class="{ error: accessInfoArea.isErrorIPAddress }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="accessInfoArea.isErrorIPAddressMsg != ''"
              >
                <ErrorMessageCase
                  :errors="accessInfoArea.isErrorIPAddressMsg"
                ></ErrorMessageCase>
              </p>
            </div>
            <br />
          </div>
          <div v-if="filterViewsDisplay.ClassificationControlMemberInfo">
            <p v-if="filterViewsDisplay.DisplayFlagsMemberInfo?.title">
              <strong>社員情報</strong>
            </p>
            <div
              :class="[
                filterViewsDisplay.DisplayFlagsMemberInfo?.title ? 'para' : '',
              ]"
            >
              <STDSDC01C09SelectChangeForm
                ref="STDSDC01C09SelectChangeFormBelongingCode"
                v-if="filterViewsDisplay.DisplayFlagsMemberInfo?.BelongingCode"
                :maxLength="'10'"
                :textType="'url'"
                :initItemName="'所属コード'"
                v-model:initSelectItem="memberInfoArea.belongingCodeCondition"
                :initSelectItemList="managerSelectedCondition"
                v-model:initInputItem="memberInfoArea.belongingCode"
                :initUnCheckPattern="
                  managerSelectedCondition.filter((el) => el.code == 100)
                "
              ></STDSDC01C09SelectChangeForm>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="memberInfoArea.isErrorBelongingCodeMsg != ''"
              >
                <ErrorMessageCase
                  :errors="memberInfoArea.isErrorBelongingCodeMsg"
                ></ErrorMessageCase>
              </p>
              <STDSDC01C09SelectChangeForm
                class="frm-row frm-row-margin-top"
                ref="STDSDC01C09SelectChangeFormBelonging"
                v-if="filterViewsDisplay.DisplayFlagsMemberInfo?.Belonging"
                :maxLength="'100'"
                :initItemName="'所属'"
                v-model:initSelectItem="memberInfoArea.belongingCondition"
                :initSelectItemList="managerSelectedCondition"
                v-model:initInputItem="memberInfoArea.belonging"
                :initUnCheckPattern="
                  managerSelectedCondition.filter((el) => el.code == 100)
                "
              ></STDSDC01C09SelectChangeForm>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="memberInfoArea.isErrorBelongingMsg != ''"
              >
                <ErrorMessageCase
                  :errors="memberInfoArea.isErrorBelongingMsg"
                ></ErrorMessageCase>
              </p>
              <STDSDC01C09SelectChangeForm
                class="frm-row frm-row-margin-top"
                ref="STDSDC01C09SelectChangeFormMemberCode"
                v-if="filterViewsDisplay.DisplayFlagsMemberInfo?.EmployeeCode"
                :textType="'url'"
                :maxLength="'10'"
                :initItemName="'社員コード'"
                v-model:initSelectItem="memberInfoArea.memberCodeCondition"
                :initSelectItemList="detailBusinessCodeList"
                v-model:initInputItem="memberInfoArea.memberCode"
              ></STDSDC01C09SelectChangeForm>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="memberInfoArea.isErrorMemberCodeMsg != ''"
              >
                <ErrorMessageCase
                  :errors="memberInfoArea.isErrorMemberCodeMsg"
                ></ErrorMessageCase>
              </p>
              <STDSDC01C09SelectChangeForm
                class="frm-row frm-row-margin-top"
                ref="STDSDC01C09SelectChangeFormMemberName"
                v-if="filterViewsDisplay.DisplayFlagsMemberInfo?.EmployeeName"
                :maxLength="'100'"
                :initItemName="'社員名'"
                v-model:initSelectItem="memberInfoArea.memberNameCondition"
                :initSelectItemList="detailBusinessCodeList"
                v-model:initInputItem="memberInfoArea.memberName"
              ></STDSDC01C09SelectChangeForm>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="memberInfoArea.isErrorMemberNameMsg != ''"
              >
                <ErrorMessageCase
                  :errors="memberInfoArea.isErrorMemberNameMsg"
                ></ErrorMessageCase>
              </p>
              <STDSDC01C09SelectChangeForm
                class="frm-row frm-row-margin-top"
                ref="STDSDC01C09SelectChangeFormCurrentSituation"
                v-if="
                  filterViewsDisplay.DisplayFlagsMemberInfo?.CurrentSituation
                "
                :initItemName="'現況'"
                v-model:initSelectItem="
                  memberInfoArea.currentSituationCondition
                "
                :initSelectItemList="currentSituationsCondition"
                :isShowInputItem="false"
              ></STDSDC01C09SelectChangeForm>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="memberInfoArea.isErrorCurrentSituationMsg != ''"
              >
                <ErrorMessageCase
                  :errors="memberInfoArea.isErrorCurrentSituationMsg"
                ></ErrorMessageCase>
              </p>
              <STDSDC01C09SelectChangeForm
                class="frm-row frm-row-margin-top"
                ref="STDSDC01C09SelectChangeFormEmailAddress"
                v-if="filterViewsDisplay.DisplayFlagsMemberInfo?.EmailAddress"
                :maxLength="'255'"
                :initItemName="'メールアドレス'"
                v-model:initSelectItem="memberInfoArea.emailAddressCondition"
                :initSelectItemList="managerSelectedCondition"
                v-model:initInputItem="memberInfoArea.emailAddress"
                :initUnCheckPattern="
                  managerSelectedCondition.filter((el) => el.code == 100)
                "
              ></STDSDC01C09SelectChangeForm>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="memberInfoArea.isErrorEmailAddressMsg != ''"
              >
                <ErrorMessageCase
                  :errors="memberInfoArea.isErrorEmailAddressMsg"
                ></ErrorMessageCase>
              </p>
              <STDSDC01C09SelectChangeForm
                class="frm-row frm-row-margin-top"
                ref="STDSDC01C09SelectChangeFormAccountStatus"
                v-if="filterViewsDisplay.DisplayFlagsMemberInfo?.AccountStatus"
                :initItemName="'アカウント状態'"
                v-model:initSelectItem="memberInfoArea.accountStatusCondition"
                :initSelectItemList="accountStatusCondition"
                v-model:initInputItem="memberInfoArea.accountStatus"
                :isShowInputItem="false"
              ></STDSDC01C09SelectChangeForm>
              <p
                class="errMsg"
                style="margin-left: 160px"
                v-show="memberInfoArea.isErrorAccountStatusMsg != ''"
              >
                <ErrorMessageCase
                  :errors="memberInfoArea.isErrorAccountStatusMsg"
                ></ErrorMessageCase>
              </p>
            </div>
            <br />
          </div>
        </div>
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button
              class="frm-btn strong large"
              data-role="popup-open"
              data-target="#popup-process"
              ref="searchButton"
              @click="SearchBtn"
            >
              検索
            </button>
            <button
              class="frm-btn large"
              data-role="popup-close"
              @click="CancelBtn"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapMutations } from "vuex";
import Common from "@/util/common";
import moment from "moment";
import {
  ACCOUNT_STATUS_LIST,
  PRESENT_SITUATION_LIST,
  DATA_CLASSIFICATION_LIST,
  DETAIL_BUSINESS_CODE_LIST,
  CORPORATION_DIVISION_LIST,
  DETAIL_DESIGNATED_DATE_LIST,
  BUSINESS_ACCOUNT_LIST,
  FUNCTION_USAGE_AUTHORITY_LIST,
  NOTIFICATION_DESTINATION_LIST,
  DOCUMENT_STATUS_LIST,
  YEAR_LIST,
  PROCESSING_TYPE_LIST,
  FILTER_VIEWS_DISPLAY_FLAG_LIST,
  PROCESSING_DIVISION_LIST_FILEMANAGE,
  PROCESSING_DIVISION_LIST,
  PROCESSING_DIVISION_LIST_LOGIN,
  DATA_CLASSIFICATION_DETAIL,
  OBJECT_TYPE_LIST_FILEMANAGE,
} from "@/util/data.js";
import Validation from "@/util/validation.js";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import {
  warekiToYear,
  warekiYearChk,
  yearToWareki,
  verifyMonth,
  isDate,
  warekisikiiChk,
} from "@/util/dateFormat.js";
import { API_Initialize } from "@/api/Modules/DC02/STDSDC02C01.js";
import { API_DisplayEmployeeInfo } from "@/api/Modules/DC02/STDSDC02C10.js";
import { API_GetCollectDataHeaderList } from "@/api/Modules/DC03/STDSDC03C01.js";
import { API_DisplaySelectBopUserScreen } from "@/api/Modules/DC03/STDSDC03C03.js";
import { API_DisplayCollectionDocumentsEditScene } from "@/api/Modules/DC04/STDSDC04C01.js";
import { API_DisplayLoginHistory } from "@/api/Modules/DC05/STDSDC05C08.js";
import { API_DisplayAccessLog } from "@/api/Modules/DC05/STDSDC05C09.js";
import { API_SetFilter } from "@/api/Modules/CM04/STDSCM04C00.js";
import STDSDC01C09SelectChangeForm from "@/components/STDSDC01C09SelectChangeForm.vue";
import BaseModal from "@/components/Base/BaseModal.vue";
export default {
  name: "STDSDC01C09FilterCompleteModal",
  components: {
    ErrorMessage,
    ErrorMessageCase,
    STDSDC01C09SelectChangeForm,
    BaseModal,
  },
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: false,
    },
    pageId: {
      type: String,
      required: true,
    },
    loginSystem: {
      type: [String, Number],
      required: true,
    },
    yearendTaxAdjustment: {
      type: Boolean,
      required: true,
    },
    keyWordFilterInit: {
      type: String,
      required: true,
    },
    bopDataFilterInit: {
      type: Object,
      required: false,
    },
    documentFilterInit: {
      type: Object,
      required: false,
    },
    accessLogFilterInit: {
      type: Object,
      required: false,
    },
    employeeInfoFilterInit: {
      type: Object,
      required: false,
    },
    STDSDC02C01FilterInit: {
      type: Object,
      required: false,
    },
    STDSDC02C10FilterInit: {
      type: Object,
      required: false,
    },
    STDSDC03C01FilterInit: {
      type: Object,
      required: false,
    },
    STDSDC03C03FilterInit: {
      type: Object,
      required: false,
    },
    STDSDC04C01FilterInit: {
      type: Object,
      required: false,
    },
    STDSDC05C08FilterInit: {
      type: Object,
      required: false,
    },
    STDSDC05C09FilterInit: {
      type: Object,
      required: false,
    },
  },
  emits: ["SearchBtn", "CancelBtn"],
  data() {
    return {
      personInChargeList: [],
      belongingList: [], //所属
      currentSituationList: [], //現況
      dateTimeList: [],
      documentsDropdownList: [],
      personInChargeCopyPageId: [
        "STDSDC02C01",
        "STDSDC03C01",
        "STDSDC03C03",
        "STDSDC04C01",
      ],
      kessanDateCopyPageId: ["STDSDC02C01", "STDSDC03C03"],
      declarationyearCopyPageId: ["STDSDC03C01", "STDSDC04C01"],
      statusCopyPageId: ["STDSDC04C01"],
      accessDateCopyPageId: ["STDSDC05C08", "STDSDC05C09"],
      errors: [], //エラーメッセージ
      settingCode: "99", //設定中コード
      settingCodeCheckBox: 98, //設定中コード
      dateConnector: "-", //日付コネクタ"/"
      dateConnectorDash: "/", //日付コネクタ"-"
      //detailBusinessCodeList: DETAIL_BUSINESS_CODE_LIST, //事業者コード、事業者名、主担当者名,データ名称,処理データ,申告書等
      corproationDivisionList: CORPORATION_DIVISION_LIST, //法人、個人、区分
      detailDesignatedDateList: DETAIL_DESIGNATED_DATE_LIST, //決算日
      businessAccountList: BUSINESS_ACCOUNT_LIST, //事業者アカウント
      businessFunctionReleaseList: FUNCTION_USAGE_AUTHORITY_LIST, //事業者に対する機能利用権限
      notificationDestinationList: NOTIFICATION_DESTINATION_LIST, //事業者からの通知先
      detailBusinessYearStartEndList: DETAIL_DESIGNATED_DATE_LIST, //事業年度等（開始）,事業年度等（開始）,処理日時
      yearList: YEAR_LIST, //事業年度等（開始）,事業年度等（開始）
      filterViewsDisplay: {}, //画面項目制御
      searchKey: this.keyWordFilterInit,
      businessInfoAreaCopy: {},
      declarationFormInfoAreaCopy: {},
      accessInfoAreaCopy: {},
      businessInfoArea: {
        CompanyCodeCondition: 0,
        CompanyCode: "",
        isErrorBopCode: false,
        isErrorBopCodeMsg: [], //業者コード
        CompanyNameCondition: 0,
        CompanyName: "",
        isErrorBopName: false,
        isErrorBopNameMsg: [], //事業者名
        BusinessOperatorType: 0,
        corproationDivision: "",
        corproationDivisionFlag: true,
        isErrorCorproationDivision: false, //法人個人区分
        KessanDateCondition: 0,
        KessanDateFromMonth: "",
        KessanDateFromDay: "",
        KessanDateToMonth: "",
        KessanDateToDay: "",
        returnCodeKessanDate: 0,
        isErrorKessanDateFromMonth: false,
        isErrorKessanDateFromDay: false,
        isErrorKessanDateToMonth: false,
        isErrorKessanDateToDay: false,
        isErrorKessanDate: false,
        isErrorKessanDateMsg: [], //決算日
        managerSelected: 0,
        manager: "",
        returnCodeManager: 0,
        isErrorManager: false,
        isErrorManagerMsg: [], //主担当者名
        BopAccountCondition: 0,
        businessAccount: "",
        businessAccountFlag: true,
        isErrorBusinessAccount: false, //事業者アカウント
        BopOpenFunctionCondition: 0,
        businessFunctionRelease: "",
        businessFunctionReleaseFlag: true,
        isErrorBusinessFunctionRelease: false, //事業者に対する機能利用権限
        NotificationFromBopCondition: 0, //事業者からの通知先

      }, //画面項目設定_事業者情報エリア
      declarationFormInfoArea: {
        TaxCategoryListCondition: 0,
        TaxCategoryList: "",
        isErrorTaxCategoryList: false,
        isErrorTaxCategoryListMsg: [], //申告書等
        returnCodeDeclarationyear: "", //事業年度等
        fiscalYearStartCondition: 0,
        fiscalYearStartFromGengo: 0,
        fiscalYearStartFromYear: "",
        fiscalYearStartFromMonth: "",
        fiscalYearStartFromDay: "",
        fiscalYearStartToGengo: 0,
        fiscalYearStartToYear: "",
        fiscalYearStartToMonth: "",
        fiscalYearStartToDay: "",
        isErrorFiscalYearStartFromYear: false,
        isErrorFiscalYearStartFromMonth: false,
        isErrorFiscalYearStartFromDay: false,
        isErrorFiscalYearStartToYear: false,
        isErrorFiscalYearStartToMonth: false,
        isErrorFiscalYearStartToDay: false,
        isErrorFiscalYearStart: false,
        isErrorFiscalYearStartMsg: [], //事業年度等（開始）法人
        JigyoNendoToCondition: 0,
        JigyoNendoToGengo: 0,
        JigyoNendoToYear: "",
        JigyoNendoToMonth: "",
        JigyoNendoToDay: "",
        fiscalYearEndToGengo: 0,
        fiscalYearEndToYear: "",
        fiscalYearEndToMonth: "",
        fiscalYearEndToDay: "",
        isErrorJigyoNendoToYear: false,
        isErrorJigyoNendoToMonth: false,
        isErrorJigyoNendoToDay: false,
        isErrorFiscalYearEndToYear: false,
        isErrorFiscalYearEndToMonth: false,
        isErrorFiscalYearEndToDay: false,
        isErrorFiscalYearEnd: false,
        isErrorFiscalYearEndMsg: [], //事業年度等（終了）法人
        fiscalYearStartConditionKojin: 0,
        fiscalYearStartFromGengoKojin: 0,
        fiscalYearStartFromYearKojin: "",
        fiscalYearStartFromMonthKojin: "",
        fiscalYearStartFromDayKojin: "",
        fiscalYearStartToGengoKojin: 0,
        fiscalYearStartToYearKojin: "",
        fiscalYearStartToMonthKojin: "",
        fiscalYearStartToDayKojin: "",
        isErrorFiscalYearStartFromYearKojin: false,
        isErrorFiscalYearStartFromMonthKojin: false,
        isErrorFiscalYearStartFromDayKojin: false,
        isErrorFiscalYearStartToYearKojin: false,
        isErrorFiscalYearStartToMonthKojin: false,
        isErrorFiscalYearStartToDayKojin: false,
        isErrorFiscalYearStartKojin: false,
        isErrorFiscalYearStartMsgKojin: [], //事業年度等（開始）個人
        JigyoNendoToConditionKojin: 0,
        JigyoNendoToGengoKojin: 0,
        JigyoNendoToYearKojin: "",
        JigyoNendoToMonthKojin: "",
        JigyoNendoToDayKojin: "",
        fiscalYearEndToGengoKojin: 0,
        fiscalYearEndToYearKojin: "",
        fiscalYearEndToMonthKojin: "",
        fiscalYearEndToDayKojin: "",
        isErrorJigyoNendoToYearKojin: false,
        isErrorJigyoNendoToMonthKojin: false,
        isErrorJigyoNendoToDayKojin: false,
        isErrorFiscalYearEndToYearKojin: false,
        isErrorFiscalYearEndToMonthKojin: false,
        isErrorFiscalYearEndToDayKojin: false,
        isErrorFiscalYearEndKojin: false,
        isErrorFiscalYearEndMsgKojin: [], //事業年度等（終了）個人
        DataKbn: [
          0, 1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 4,
          24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 5, 6, 7, 8, 9,
          38, 39, 40, 41, 99,
        ],
        returnCodeDataKbn: 0, //データ区分
        DataNameCondition: 0,
        DataName: "",
        isErrorDataName: false,
        isErrorDataNameMsg: [], //データ名称
        Status: [0, 1, 2, 5, 7, 10, 100],
        returnCodeStatus: 0, //書類収集状況
      }, //画面項目設定_申告書等情報エリア
      accessInfoArea: {
        AccessDateCondition: 0,
        AccessDateFromGengo: 0,
        AccessDateFromYMD: "",
        AccessDateFromYM: "",
        AccessDateFromYear: "",
        AccessDateFromMonth: "",
        AccessDateFromDay: "",
        AccessDateToGengo: 0,
        AccessDateToYMD: "",
        AccessDateToYear: "",
        AccessDateToMonth: "",
        AccessDateToDay: "",
        returnCodeAccessDate: 0,
        isErrorAccessDateFromYear: false,
        isErrorAccessDateFromMonth: false,
        isErrorAccessDateFromDay: false,
        isErrorAccessDateToYear: false,
        isErrorAccessDateToMonth: false,
        isErrorAccessDateToDay: false,
        isErrorAccessDate: false,
        isErrorAccessDateMsg: [], //処理日時
        treatmentTarget: [2, 3, 99], //処理対象
        processingDataCondition: 0,
        processingData: "",
        isErrorProcessingData: false,
        isErrorProcessingDataMsg: [], //処理データ
        ProcessingDivision: [1, 2, 3, 4, 5, 99], //処理区分
        //ProcessingDivision: [99], //処理区分
        bopUserCondition: 0,
        bopUser: "",
        isErrorBopUser: false,
        isErrorBopUserMsg: [], //事業者情報
        LoginIDCondition: 0,
        LoginID: "",
        isErrorLoginInID: false,
        isErrorLoginInIDMsg: [], //ログインID
        UserNameCondition: 0,
        UserName: "",
        isErrorUserName: false,
        isErrorUserNameMsg: [], //利用者名ID
        IPAddressCondition: 0,
        IPAddress: "",
        isErrorIPAddress: false,
        isErrorIPAddressMsg: [], //IPアドレス
      }, //画面項目設定_アクセスログ情報エリア
      memberInfoArea: {
        motoPageHandleShowBtn: false, //
        belongingCodeCondition: 0,
        belongingCode: "",
        // isErrorBelongingCode: false,
        isErrorBelongingCodeMsg: [], //所属コード
        belongingCondition: 0,
        belonging: "",
        returnCodeBelonging: 0,
        // isErrorBelonging: false,
        isErrorBelongingMsg: [], //所属
        memberCodeCondition: 0,
        memberCode: "",
        // isErrorMemberCode: false,
        isErrorMemberCodeMsg: [], //社員コード
        memberNameCondition: 0,
        memberName: "",
        // isErrorMemberName: false,
        isErrorMemberNameMsg: [], //社員名
        currentSituationCondition: PRESENT_SITUATION_LIST[0].code,
        // currentSituation: "",
        returnCodeCurrentSituation: 0,
        // isErrorCurrentSituation: false,
        isErrorCurrentSituationMsg: [], //現況
        emailAddressCondition: 0,
        emailAddress: "",
        // isErrorEmailAddress: false,
        isErrorEmailAddressMsg: [], //メールアドレス
        accountStatusCondition: 0,
        accountStatus: "",
        // isErrorAccountStatus: false,
        isErrorAccountStatusMsg: [], //アカウント状態
      }, //画面項目設定_社員情報エリア
    };
  },
  created() {
    //this.filterViewsDisplayFlag(this.loginSystem);
    this.filterViewsDisplay = FILTER_VIEWS_DISPLAY_FLAG_LIST.filter(
      (el) => el.pageId == this.pageId
    )[0];
    if (!this.filterViewsDisplay) this.filterViewsDisplay = {};
    this.businessInfoAreaCopy = _.cloneDeep(this.businessInfoArea);
    this.declarationFormInfoAreaCopy = _.cloneDeep(
      this.declarationFormInfoArea
    );
    this.accessInfoAreaCopy = _.cloneDeep(this.accessInfoArea);
  },
  mounted() {
    //alert("109huamian");
    // this.businessInfoAreaCopy = _.cloneDeep(this.businessInfoArea);
    // this.declarationFormInfoAreaCopy = _.cloneDeep(this.declarationFormInfoArea);
    // this.accessInfoAreaCopy = _.cloneDeep(this.accessInfoArea);
  },
  watch: {
    isShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
    loginSystem: {
      handler: "filterViewsDisplayFlag",
      immediate: true,
    },
    keyWordFilterInit: {
      handler: "keyWordFilterInitWatch",
      immediate: true,
    },
    bopDataFilterInit: {
      handler: "bopDataFilterInitWatch",
      immediate: true,
      deep: true,
    },
    documentFilterInit: {
      handler: "documentFilterInitWatch",
      immediate: true,
      deep: true,
    },
    accessLogFilterInit: {
      handler: "accessLogFilterInitWatch",
      immediate: true,
      deep: true,
    },
    employeeInfoFilterInit: {
      handler: "employeeInfoFilterInitWatch",
      immediate: true,
      deep: true,
    },
    STDSDC02C01FilterInit: {
      handler: "STDSDC02C01FilterInitWatch",
      immediate: true,
      deep: true,
    },
    STDSDC02C10FilterInit: {
      handler: "STDSDC02C10FilterInitWatch",
      immediate: true,
      deep: true,
    },
    STDSDC03C01FilterInit: {
      handler: "STDSDC03C01FilterInitWatch",
      immediate: true,
      deep: true,
    },
    STDSDC03C03FilterInit: {
      handler: "STDSDC03C03FilterInitWatch",
      immediate: true,
      deep: true,
    },
    STDSDC04C01FilterInit: {
      handler: "STDSDC04C01FilterInitWatch",
      immediate: true,
      deep: true,
    },
    STDSDC05C08FilterInit: {
      handler: "STDSDC05C08FilterInitWatch",
      immediate: true,
      deep: true,
    },
    STDSDC05C09FilterInit: {
      handler: "STDSDC05C09FilterInitWatch",
      immediate: true,
      deep: true,
    },
  },
  computed: {
    //#region チェックボックスとドロップダウンリスト取得
    // **********************************************
    // 主担当者(ドロップダウンリスト)を取得
    // **********************************************
    managerSelectedCondition() {
      return DETAIL_BUSINESS_CODE_LIST;
    },
    // **********************************************
    // 現況(ドロップダウンリスト)を取得
    // **********************************************
    currentSituationsCondition() {
      return PRESENT_SITUATION_LIST;
    },
    // **********************************************
    // アカウント状態(ドロップダウンリスト)を取得
    // **********************************************
    accountStatusCondition() {
      return ACCOUNT_STATUS_LIST;
    },
    // **********************************************
    // 事業者コード、事業者名、主担当者名,データ名称,処理データ,申告書等(ドロップダウンリスト)を取得
    // **********************************************
    detailBusinessCodeList() {
      return DETAIL_BUSINESS_CODE_LIST.filter((el) => el.code != 100);
    },
    // **********************************************
    // データ区分(チェックボックス)を取得
    // **********************************************
    dataTypeArray() {
      return DATA_CLASSIFICATION_LIST.filter((el) => el.code != 99);
    },
    // **********************************************
    // 四半期試算(リスト)を取得
    // **********************************************
    dataTypeQuarterlyArray() {
      return DATA_CLASSIFICATION_DETAIL.filter((el) =>
        el.enumname.includes("Quarterly")
      ).map((item) => item.code);
    },
    // **********************************************
    // 予定申告(リスト)を取得
    // **********************************************
    dataTypeProvisionalArray() {
      return DATA_CLASSIFICATION_DETAIL.filter((el) =>
        el.enumname.includes("Provisional")
      ).map((item) => item.code);
    },
    // **********************************************
    // 中間申告(リスト)を取得
    // **********************************************
    dataTypeInterimArray() {
      return DATA_CLASSIFICATION_DETAIL.filter((el) =>
        el.enumname.includes("Interim")
      ).map((item) => item.code);
    },
    // **********************************************
    // 書類収集状況(チェックボックス)を取得
    // **********************************************
    documentStatusArray() {
      return DOCUMENT_STATUS_LIST.filter((el) => el.code != 99);
    },
    // **********************************************
    // 処理種別(チェックボックス)を取得
    // **********************************************
    processingTypeArray() {
      return PROCESSING_TYPE_LIST.filter((el) => el.code != 99);
    },
    // **********************************************
    // 操作日時(ドロップダウンリスト)を取得
    // **********************************************
    operationDateCondition() {
      let list = [];
      if (this.filterViewsDisplay?.DisplayFlagsProcessing?.DC05C08Model) {
        list = DETAIL_DESIGNATED_DATE_LIST.filter(
          (el) => el.code == 1 || el.code == 2
        );
      }
      if (this.filterViewsDisplay?.DisplayFlagsProcessing?.DC05C09Model) {
        list = DETAIL_DESIGNATED_DATE_LIST.filter((el) => el.code != 0);
      }
      return list;
    },
    // **********************************************
    // 処理対象(チェックボックス)を取得
    // **********************************************
    treatmentTargetArray() {
      return OBJECT_TYPE_LIST_FILEMANAGE;
    },

    // **********************************************
    // 処理区分(チェックボックス)を取得
    // **********************************************
    processingDivisionArray() {
      let list = PROCESSING_DIVISION_LIST_FILEMANAGE.filter((el) => el.code != 99);
      if (this.filterViewsDisplay.DisplayFlagsProcessing?.DC05C08Model) {
        list = PROCESSING_DIVISION_LIST_LOGIN;
      }
      return list;
    },

    // **********************************************
    // 処理日時(ドロップダウンリスト)を取得
    // **********************************************
    accessDateConditionList() {
      return DETAIL_DESIGNATED_DATE_LIST.filter((el) => el.code != 0);
    },
    //#endregion
    //#region 非活性
    // 詳細_事業者コードテキストコントロールを非活性にする
    isBopCodeDisabled() {
      return this.businessInfoArea.CompanyCodeCondition == 0 ? true : false;
    },
    // 詳細_事業者名テキストコントロールを非活性にする
    isBopNameDisabled() {
      return this.businessInfoArea.CompanyNameCondition == 0 ? true : false;
    },
    // 詳細_法人個人区分の設定
    isCorproationDivisionDisabled() {
      return this.businessInfoArea.BusinessOperatorType == 0 ? true : false;
    },
    // 詳細_決算日テキストコントロールを非活性にする
    isDetailDesignatedDateStartDisabled() {
      return this.businessInfoArea.KessanDateCondition == 0 ? true : false;
    },
    // 詳細_主担当者名テキストコントロールを非活性にする
    isManagerDisabled() {
      return this.businessInfoArea.managerSelected == 0 ||
        this.businessInfoArea.managerSelected == 100
        ? true
        : false;
    },
    // 詳細_事業者アカウントの設定
    isBusinessAccountDisabled() {
      return this.businessInfoArea.BopAccountCondition == 0 ? true : false;
    },
    // 詳細_事業者に対する機能利用権限の設定
    isBusinessFunctionReleaseDisabled() {
      return this.businessInfoArea.BopOpenFunctionCondition == 0 ? true : false;
    },
    // 詳細_申告書等テキストコントロールを非活性にする
    isTaxCategoryListDisabled() {
      return this.declarationFormInfoArea.TaxCategoryListCondition == 0
        ? true
        : false;
    },
    // 詳細_事業年度等（開始）の設定 法人
    isDetailBusinessYearStartFirDisabled() {
      return this.declarationFormInfoArea.fiscalYearStartCondition == 0
        ? true
        : false;
    },
    // 詳細_事業年度等（終了）の設定　法人
    isDetailBusinessYearEndFirDisabled() {
      return this.declarationFormInfoArea.JigyoNendoToCondition == 0
        ? true
        : false;
    },
    // 詳細_事業年度等（開始）の設定 個人
    isDetailBusinessYearStartFirDisabledKojin() {
      return this.declarationFormInfoArea.fiscalYearStartConditionKojin == 0
        ? true
        : false;
    },
    // 詳細_事業年度等（終了）の設定　個人
    isDetailBusinessYearEndFirDisabledKojin() {
      return this.declarationFormInfoArea.JigyoNendoToConditionKojin == 0
        ? true
        : false;
    },
    // 詳細_データ名称テキストコントロールを非活性にする
    isDataNameDisabled() {
      return this.declarationFormInfoArea.DataNameCondition == 0 ? true : false;
    },
    // 詳細_処理日時の設定
    isProcessingDateTimeStartDisabled() {
      return this.accessInfoArea.AccessDateCondition == 0 ? true : false;
    },
    // 詳細_処理データテキストコントロールを非活性にする
    isProcessingDataDisabled() {
      return this.accessInfoArea.processingDataCondition == 0 ? true : false;
    },
    // 詳細_事業者情報テキストコントロールを非活性にする
    isBopUserDisabled() {
      return this.accessInfoArea.bopUserCondition == 0 ? true : false;
    },
    // 詳細_ログインIDテキストコントロールを非活性にする
    isLoginInIDDisabled() {
      return this.accessInfoArea.LoginIDCondition == 0 ? true : false;
    },
    // 詳細_利用者名IDテキストコントロールを非活性にする
    isUserNameDisabled() {
      return this.accessInfoArea.UserNameCondition == 0 ? true : false;
    },
    // 詳細_IPアドレステキストコントロールを非活性にする
    isIPAddressDisabled() {
      return this.accessInfoArea.IPAddressCondition == 0 ? true : false;
    },
    //#endregion
    //#region 日付の表示制御
    //決算日
    isShowKessanDateFromDay() {
      return this.businessInfoArea.KessanDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
        ? false
        : true;
    },
    detailDesignatedDateEndFlag() {
      return this.businessInfoArea.KessanDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
        ? true
        : false;
    },
    //事業年度等（開始） 法人データ
    isShowfiscalYearStartFromDay() {
      return this.declarationFormInfoArea.fiscalYearStartCondition ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
        ? false
        : true;
    },
    detailBusinessYearStartSecFlag() {
      return this.declarationFormInfoArea.fiscalYearStartCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
        ? true
        : false;
    },
    isAccessDateTypeMonthShow() {
      return this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
        ? true
        : false;
    },
    //事業年度等（終了） 法人データ
    isShowJigyoNendoToDay() {
      return this.declarationFormInfoArea.JigyoNendoToCondition ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
        ? false
        : true;
    },
    detailBusinessYearEndSecFlag() {
      return this.declarationFormInfoArea.JigyoNendoToCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
        ? true
        : false;
    },
    //事業年度等（開始） 個人データ
    isShowFiscalYearStartFromDayKojin() {
      return this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
        ? false
        : true;
    },
    detailBusinessYearStartSecFlagKojin() {
      return this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
        ? true
        : false;
    },
    //事業年度等（終了） 個人データ
    isShowJigyoNendoToDayKojin() {
      return this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
        ? false
        : true;
    },
    detailBusinessYearEndSecFlagKojin() {
      return this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
        ? true
        : false;
    },
    //処理日時
    isShowAccessDateFromDay() {
      return this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
        ? false
        : true;
    },
    processingDateTimeEndFlag() {
      return this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
        ? true
        : false;
    },
    //#endregion
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),
    //#region 事業者情報エリアのチェンジイベント
    // **********************************************
    // 詳細フィルタ_事業者コードを取得
    // **********************************************
    handleBopCodeChange(e) {
      this.businessInfoArea.CompanyCodeCondition = e.target.value;
      if (this.businessInfoArea.CompanyCodeCondition == 0) {
        this.businessInfoArea.CompanyCode = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_事業者名を取得
    // **********************************************
    handleBopNameChange(e) {
      this.businessInfoArea.CompanyNameCondition = e.target.value;
      if (this.businessInfoArea.CompanyNameCondition == 0) {
        this.businessInfoArea.CompanyName = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_法人個人区分を取得
    // **********************************************
    handleCorproationDivisionChange(e) {
      this.businessInfoArea.BusinessOperatorType = e.target.value;
      if (this.businessInfoArea.BusinessOperatorType == 0) {
        this.businessInfoArea.corproationDivision = "";
      }
    },
    // **********************************************
    // 詳細_決算日を取得
    // **********************************************
    handleDetailDesignatedDateChange(e) {
      this.businessInfoArea.KessanDateCondition = e.target.value;
      this.businessInfoArea.KessanDateFromMonth = "";
      this.businessInfoArea.KessanDateFromDay = "";
      this.businessInfoArea.KessanDateToMonth = "";
      this.businessInfoArea.KessanDateToDay = "";
    },
    // **********************************************
    // 詳細フィルタ_主担当者名を取得
    // **********************************************
    handleManagerChange(e) {
      this.businessInfoArea.managerSelected = e.target.value;
      if (
        this.businessInfoArea.managerSelected == 0 ||
        this.businessInfoArea.managerSelected == 100
      ) {
        this.businessInfoArea.manager = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_事業者アカウントを取得
    // **********************************************
    handleBusinessAccountChange(e) {
      this.businessInfoArea.BopAccountCondition = e.target.value;
      if (this.businessInfoArea.BopAccountCondition == 0) {
        this.businessInfoArea.businessAccount = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_事業者に対する機能利用権限を取得
    // **********************************************
    handleBusinessFunctionReleaseChange(e) {
      this.businessInfoArea.BopOpenFunctionCondition = e.target.value;
      if (this.businessInfoArea.BopOpenFunctionCondition == 0) {
        this.businessInfoArea.businessFunctionRelease = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_事業者からの通知先を取得
    // **********************************************
    handleNotificationDestinationChange(e) {
      this.businessInfoArea.NotificationFromBopCondition = e.target.value;
      if (this.businessInfoArea.NotificationFromBopCondition == 0) {
        //this.businessInfoArea.businessFunctionRelease = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_申告書等を取得
    // **********************************************
    handleTaxCategoryListChange(e) {
      this.declarationFormInfoArea.TaxCategoryListCondition = e.target.value;
      if (this.declarationFormInfoArea.TaxCategoryListCondition == 0) {
        this.declarationFormInfoArea.TaxCategoryList = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（開始）を取得　法人
    // **********************************************
    handleDetailBusinessYearStartChange(e) {
      this.declarationFormInfoArea.fiscalYearStartCondition = e.target.value;
      this.declarationFormInfoArea.fiscalYearStartFromGengo = 0;
      this.declarationFormInfoArea.fiscalYearStartFromYear = "";
      this.declarationFormInfoArea.fiscalYearStartFromMonth = "";
      this.declarationFormInfoArea.fiscalYearStartFromDay = "";
      this.declarationFormInfoArea.fiscalYearStartToGengo = 0;
      this.declarationFormInfoArea.fiscalYearStartToYear = "";
      this.declarationFormInfoArea.fiscalYearStartToMonth = "";
      this.declarationFormInfoArea.fiscalYearStartToDay = "";
      // if (this.declarationFormInfoArea.fiscalYearStartCondition == 0) {
      //   this.declarationFormInfoArea.fiscalYearStartFromGengo = 0;
      //   this.declarationFormInfoArea.fiscalYearStartFromYear = "";
      //   this.declarationFormInfoArea.fiscalYearStartFromMonth = "";
      //   this.declarationFormInfoArea.fiscalYearStartFromDay = "";
      //   this.declarationFormInfoArea.fiscalYearStartToGengo = 0;
      //   this.declarationFormInfoArea.fiscalYearStartToYear = "";
      //   this.declarationFormInfoArea.fiscalYearStartToMonth = "";
      //   this.declarationFormInfoArea.fiscalYearStartToDay = "";
      // } else if (
      //   this.declarationFormInfoArea.fiscalYearStartCondition ==
      //   DETAIL_DESIGNATED_DATE_LIST[1].code
      // ) {
      //   this.declarationFormInfoArea.fiscalYearStartToGengo = 0;
      //   this.declarationFormInfoArea.fiscalYearStartToYear = "";
      //   this.declarationFormInfoArea.fiscalYearStartToMonth = "";
      //   this.declarationFormInfoArea.fiscalYearStartToDay = "";
      // } else if (
      //   this.declarationFormInfoArea.fiscalYearStartCondition ==
      //   DETAIL_DESIGNATED_DATE_LIST[2].code
      // ) {
      //   this.declarationFormInfoArea.fiscalYearStartFromDay = "";
      //   this.declarationFormInfoArea.fiscalYearStartToGengo = 0;
      //   this.declarationFormInfoArea.fiscalYearStartToYear = "";
      //   this.declarationFormInfoArea.fiscalYearStartToMonth = "";
      //   this.declarationFormInfoArea.fiscalYearStartToDay = "";
      // } else {
      // }
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（開始）Startを取得　法人
    // **********************************************
    handleDetailBusinessYearStartFirChange(e) {
      this.declarationFormInfoArea.fiscalYearStartFromGengo = e.target.value;
      //if (this.declarationFormInfoArea.fiscalYearStartFromGengo == 0) {
      this.declarationFormInfoArea.fiscalYearStartFromYear = "";
      this.declarationFormInfoArea.fiscalYearStartFromMonth = "";
      this.declarationFormInfoArea.fiscalYearStartFromDay = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（開始）Endを取得　法人
    // **********************************************
    handleDetailBusinessYearStartSecChange(e) {
      this.declarationFormInfoArea.fiscalYearStartToGengo = e.target.value;
      //if (this.declarationFormInfoArea.fiscalYearStartToGengo == 0) {
      this.declarationFormInfoArea.fiscalYearStartToYear = "";
      this.declarationFormInfoArea.fiscalYearStartToMonth = "";
      this.declarationFormInfoArea.fiscalYearStartToDay = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（終了）を取得　法人
    // **********************************************
    handleDetailBusinessYearEndChange(e) {
      this.declarationFormInfoArea.JigyoNendoToCondition = e.target.value;
      this.declarationFormInfoArea.JigyoNendoToGengo = 0;
      this.declarationFormInfoArea.JigyoNendoToYear = "";
      this.declarationFormInfoArea.JigyoNendoToMonth = "";
      this.declarationFormInfoArea.JigyoNendoToDay = "";
      this.declarationFormInfoArea.fiscalYearEndToGengo = 0;
      this.declarationFormInfoArea.fiscalYearEndToYear = "";
      this.declarationFormInfoArea.fiscalYearEndToMonth = "";
      this.declarationFormInfoArea.fiscalYearEndToDay = "";
      // if (this.declarationFormInfoArea.JigyoNendoToCondition == 0) {
      //   this.declarationFormInfoArea.JigyoNendoToGengo = 0;
      //   this.declarationFormInfoArea.JigyoNendoToYear = "";
      //   this.declarationFormInfoArea.JigyoNendoToMonth = "";
      //   this.declarationFormInfoArea.JigyoNendoToDay = "";
      //   this.declarationFormInfoArea.fiscalYearEndToGengo = 0;
      //   this.declarationFormInfoArea.fiscalYearEndToYear = "";
      //   this.declarationFormInfoArea.fiscalYearEndToMonth = "";
      //   this.declarationFormInfoArea.fiscalYearEndToDay = "";
      // } else if (
      //   this.declarationFormInfoArea.JigyoNendoToCondition ==
      //   DETAIL_DESIGNATED_DATE_LIST[1].code
      // ) {
      //   this.declarationFormInfoArea.fiscalYearEndToGengo = 0;
      //   this.declarationFormInfoArea.fiscalYearEndToYear = "";
      //   this.declarationFormInfoArea.fiscalYearEndToMonth = "";
      //   this.declarationFormInfoArea.fiscalYearEndToDay = "";
      // } else if (
      //   this.declarationFormInfoArea.JigyoNendoToCondition ==
      //   DETAIL_DESIGNATED_DATE_LIST[2].code
      // ) {
      //   this.declarationFormInfoArea.JigyoNendoToDay = "";
      //   this.declarationFormInfoArea.fiscalYearEndToGengo = 0;
      //   this.declarationFormInfoArea.fiscalYearEndToYear = "";
      //   this.declarationFormInfoArea.fiscalYearEndToMonth = "";
      //   this.declarationFormInfoArea.fiscalYearEndToDay = "";
      // } else {
      // }
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（終了）Startを取得　法人
    // **********************************************
    handleDetailBusinessYearEndFirChange(e) {
      this.declarationFormInfoArea.JigyoNendoToGengo = e.target.value;
      //if (this.declarationFormInfoArea.JigyoNendoToGengo == 0) {
      this.declarationFormInfoArea.JigyoNendoToYear = "";
      this.declarationFormInfoArea.JigyoNendoToMonth = "";
      this.declarationFormInfoArea.JigyoNendoToDay = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（終了）Endを取得　法人
    // **********************************************
    handleDetailBusinessYearEndSecChange(e) {
      this.declarationFormInfoArea.fiscalYearEndToGengo = e.target.value;
      //if (this.declarationFormInfoArea.fiscalYearEndToGengo == 0) {
      this.declarationFormInfoArea.fiscalYearEndToYear = "";
      this.declarationFormInfoArea.fiscalYearEndToMonth = "";
      this.declarationFormInfoArea.fiscalYearEndToDay = "";
      //}
    },

    // **********************************************
    // 詳細フィルタ_事業年度等（開始）を取得　個人
    // **********************************************
    handleDetailBusinessYearStartChangeKojin(e) {
      this.declarationFormInfoArea.fiscalYearStartConditionKojin =
        e.target.value;
      this.declarationFormInfoArea.fiscalYearStartFromGengoKojin = 0;
      this.declarationFormInfoArea.fiscalYearStartFromYearKojin = "";
      this.declarationFormInfoArea.fiscalYearStartFromMonthKojin = "";
      this.declarationFormInfoArea.fiscalYearStartFromDayKojin = "";
      this.declarationFormInfoArea.fiscalYearStartToGengoKojin = 0;
      this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
      this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
      this.declarationFormInfoArea.fiscalYearStartToDayKojin = "";
      // if (this.declarationFormInfoArea.fiscalYearStartConditionKojin == 0) {
      //   this.declarationFormInfoArea.fiscalYearStartFromGengoKojin = 0;
      //   this.declarationFormInfoArea.fiscalYearStartFromYearKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartFromMonthKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartFromDayKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartToGengoKojin = 0;
      //   this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartToDayKojin = "";
      // } else if (
      //   this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
      //   DETAIL_DESIGNATED_DATE_LIST[1].code
      // ) {
      //   this.declarationFormInfoArea.fiscalYearStartToGengoKojin = 0;
      //   this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartToDayKojin = "";
      // } else if (
      //   this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
      //   DETAIL_DESIGNATED_DATE_LIST[2].code
      // ) {
      //   this.declarationFormInfoArea.fiscalYearStartFromDayKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartToGengoKojin = 0;
      //   this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
      //   this.declarationFormInfoArea.fiscalYearStartToDayKojin = "";
      // } else {
      // }
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（開始）Startを取得　個人
    // **********************************************
    handleDetailBusinessYearStartFirChangeKojin(e) {
      this.declarationFormInfoArea.fiscalYearStartFromGengoKojin =
        e.target.value;
      //if (this.declarationFormInfoArea.fiscalYearStartFromGengoKojin == 0) {
      this.declarationFormInfoArea.fiscalYearStartFromYearKojin = "";
      this.declarationFormInfoArea.fiscalYearStartFromMonthKojin = "";
      this.declarationFormInfoArea.fiscalYearStartFromDayKojin = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（開始）Endを取得　個人
    // **********************************************
    handleDetailBusinessYearStartSecChangeKojin(e) {
      this.declarationFormInfoArea.fiscalYearStartToGengoKojin = e.target.value;
      //if (this.declarationFormInfoArea.fiscalYearStartToGengoKojin == 0) {
      this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
      this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
      this.declarationFormInfoArea.fiscalYearStartToDayKojin = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（終了）を取得　個人
    // **********************************************
    handleDetailBusinessYearEndChangeKojin(e) {
      this.declarationFormInfoArea.JigyoNendoToConditionKojin = e.target.value;
      this.declarationFormInfoArea.JigyoNendoToGengoKojin = 0;
      this.declarationFormInfoArea.JigyoNendoToYearKojin = "";
      this.declarationFormInfoArea.JigyoNendoToMonthKojin = "";
      this.declarationFormInfoArea.JigyoNendoToDayKojin = "";
      this.declarationFormInfoArea.fiscalYearEndToGengoKojin = 0;
      this.declarationFormInfoArea.fiscalYearEndToYearKojin = "";
      this.declarationFormInfoArea.fiscalYearEndToMonthKojin = "";
      this.declarationFormInfoArea.fiscalYearEndToDayKojin = "";
      // if (this.declarationFormInfoArea.JigyoNendoToConditionKojin == 0) {
      //   this.declarationFormInfoArea.JigyoNendoToGengoKojin = 0;
      //   this.declarationFormInfoArea.JigyoNendoToYearKojin = "";
      //   this.declarationFormInfoArea.JigyoNendoToMonthKojin = "";
      //   this.declarationFormInfoArea.JigyoNendoToDayKojin = "";
      //   this.declarationFormInfoArea.fiscalYearEndToGengoKojin = 0;
      //   this.declarationFormInfoArea.fiscalYearEndToYearKojin = "";
      //   this.declarationFormInfoArea.fiscalYearEndToMonthKojin = "";
      //   this.declarationFormInfoArea.fiscalYearEndToDayKojin = "";
      // } else if (
      //   this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
      //   DETAIL_DESIGNATED_DATE_LIST[1].code
      // ) {
      //   this.declarationFormInfoArea.fiscalYearEndToGengoKojin = 0;
      //   this.declarationFormInfoArea.fiscalYearEndToYearKojin = "";
      //   this.declarationFormInfoArea.fiscalYearEndToMonthKojin = "";
      //   this.declarationFormInfoArea.fiscalYearEndToDayKojin = "";
      // } else if (
      //   this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
      //   DETAIL_DESIGNATED_DATE_LIST[2].code
      // ) {
      //   this.declarationFormInfoArea.JigyoNendoToDayKojin = "";
      //   this.declarationFormInfoArea.fiscalYearEndToGengoKojin = 0;
      //   this.declarationFormInfoArea.fiscalYearEndToYearKojin = "";
      //   this.declarationFormInfoArea.fiscalYearEndToMonthKojin = "";
      //   this.declarationFormInfoArea.fiscalYearEndToDayKojin = "";
      // } else {
      // }
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（終了）Startを取得　個人
    // **********************************************
    handleDetailBusinessYearEndFirChangeKojin(e) {
      this.declarationFormInfoArea.JigyoNendoToGengoKojin = e.target.value;
      //if (this.declarationFormInfoArea.JigyoNendoToGengoKojin == 0) {
      this.declarationFormInfoArea.JigyoNendoToYearKojin = "";
      this.declarationFormInfoArea.JigyoNendoToMonthKojin = "";
      this.declarationFormInfoArea.JigyoNendoToDayKojin = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_事業年度等（終了）Endを取得　個人
    // **********************************************
    handleDetailBusinessYearEndSecChangeKojin(e) {
      this.declarationFormInfoArea.fiscalYearEndToGengoKojin = e.target.value;
      //if (this.declarationFormInfoArea.fiscalYearEndToGengoKojin == 0) {
      this.declarationFormInfoArea.fiscalYearEndToYearKojin = "";
      this.declarationFormInfoArea.fiscalYearEndToMonthKojin = "";
      this.declarationFormInfoArea.fiscalYearEndToDayKojin = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_データ名称を取得
    // **********************************************
    handleDataNameChange(e) {
      this.declarationFormInfoArea.DataNameCondition = e.target.value;
      if (this.declarationFormInfoArea.DataNameCondition == 0) {
        this.declarationFormInfoArea.DataName = "";
      }
    },
    //#endregion

    //#region アクセスログ情報エリアのチェンジイベント
    // **********************************************
    // 詳細フィルタ_処理日時を取得
    // **********************************************
    handleProcessingDateTimeChange(e) {
      this.accessInfoArea.AccessDateCondition = e.target.value;
      this.accessInfoArea.AccessDateFromYMD = "";
      this.accessInfoArea.AccessDateToYMD = "";
      this.accessInfoArea.AccessDateFromYM = "";
      this.$refs.accessDateFrom.value = "";
      this.$refs.accessDateTo.value = "";
      this.$refs.accessDateFromMonth.value = "";
      this.dateSplit();
    },
    // **********************************************
    // 詳細フィルタ_処理日時Startを取得
    // **********************************************
    handleProcessingDateTimeStartChange(e) {
      this.accessInfoArea.AccessDateFromGengo = e.target.value;
      //if (this.accessInfoArea.AccessDateFromGengo == 0) {
      this.accessInfoArea.AccessDateFromYear = "";
      this.accessInfoArea.AccessDateFromMonth = "";
      this.accessInfoArea.AccessDateFromDay = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_処理日時Endを取得
    // **********************************************
    handleProcessingDateTimeEndChange(e) {
      this.accessInfoArea.AccessDateToGengo = e.target.value;
      //if (this.accessInfoArea.AccessDateToGengo == 0) {
      this.accessInfoArea.AccessDateToYear = "";
      this.accessInfoArea.AccessDateToMonth = "";
      this.accessInfoArea.AccessDateToDay = "";
      //}
    },
    // **********************************************
    // 詳細フィルタ_処理データを取得
    // **********************************************
    handleProcessingDataChange(e) {
      this.accessInfoArea.processingDataCondition = e.target.value;
      if (this.accessInfoArea.processingDataCondition == 0) {
        this.accessInfoArea.processingData = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_事業者情報を取得
    // **********************************************
    handleBopUserChange(e) {
      this.accessInfoArea.bopUserCondition = e.target.value;
      if (this.accessInfoArea.bopUserCondition == 0) {
        this.accessInfoArea.bopUser = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_ログインIDを取得
    // **********************************************
    handleLoginInIDChange(e) {
      this.accessInfoArea.LoginIDCondition = e.target.value;
      if (this.accessInfoArea.LoginIDCondition == 0) {
        this.accessInfoArea.LoginID = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_利用者名IDを取得
    // **********************************************
    handleUserNameChange(e) {
      this.accessInfoArea.UserNameCondition = e.target.value;
      if (this.accessInfoArea.UserNameCondition == 0) {
        this.accessInfoArea.UserName = "";
      }
    },
    // **********************************************
    // 詳細フィルタ_IPアドレスを取得
    // **********************************************
    handleIPAddressChange(e) {
      this.accessInfoArea.IPAddressCondition = e.target.value;
      if (this.accessInfoArea.IPAddressCondition == 0) {
        this.accessInfoArea.IPAddress = "";
      }
    },
    // **********************************************
    // 処理日時で年月日を設定　DC05
    // **********************************************
    dateSplit() {
      let seirekiFrom = this.accessInfoArea.AccessDateFromYMD;
      let seirekiTo = this.accessInfoArea.AccessDateToYMD;
      let seirekiFromYM = this.accessInfoArea.AccessDateFromYM;
      this.accessInfoArea.AccessDateFromGengo = 0;
      this.accessInfoArea.AccessDateFromYear = "";
      this.accessInfoArea.AccessDateFromMonth = "";
      this.accessInfoArea.AccessDateFromDay = "";
      this.accessInfoArea.AccessDateToGengo = 0;
      this.accessInfoArea.AccessDateToYear = "";
      this.accessInfoArea.AccessDateToMonth = "";
      this.accessInfoArea.AccessDateToDay = "";
      if (seirekiFrom) {
        const seirekiFromYear = moment(seirekiFrom).year();
        const seirekiFromMon = moment(seirekiFrom).month() + 1;
        const seirekiFromDay = moment(seirekiFrom).date();

        var warekiFrom = yearToWareki(seirekiFromYear);

        this.accessInfoArea.AccessDateFromGengo = this.warekiCode(warekiFrom);

        this.accessInfoArea.AccessDateFromYear = warekiFrom.year;
        this.accessInfoArea.AccessDateFromMonth = seirekiFromMon;
        this.accessInfoArea.AccessDateFromDay = seirekiFromDay;
      }

      if (seirekiFromYM) {
        const seirekiFromYear2 = moment(seirekiFromYM).year();
        const seirekiFromMon2 = moment(seirekiFromYM).month() + 1;

        var warekiFrom2 = yearToWareki(seirekiFromYear2);

        this.accessInfoArea.AccessDateFromGengo = this.warekiCode(warekiFrom2);

        this.accessInfoArea.AccessDateFromYear = warekiFrom2.year;
        this.accessInfoArea.AccessDateFromMonth = seirekiFromMon2;
      }

      if (seirekiTo) {
        const seirekiToYear = moment(seirekiTo).year();
        const seirekiToMon = moment(seirekiTo).month() + 1;
        const seirekiToDay = moment(seirekiTo).date();
        const warekiTo = yearToWareki(seirekiToYear);
        this.accessInfoArea.AccessDateToGengo = this.warekiCode(warekiTo);
        this.accessInfoArea.AccessDateToYear = warekiTo.year;
        this.accessInfoArea.AccessDateToMonth = seirekiToMon;
        this.accessInfoArea.AccessDateToDay = seirekiToDay;
      }
    },

    //#endregion

    //#region 関数

    // **********************************************
    // すべての条件をクリア
    // **********************************************
    handleReset(saveFlg) {
      // this.errors = [];
      this.errorsClear();
      this.searchKey = "";

      //画面項目設定_事業者情報エリア
      this.businessInfoArea = {
        CompanyCodeCondition: 0,
        CompanyCode: "",
        isErrorBopCode: false,
        isErrorBopCodeMsg: [], //業者コード
        CompanyNameCondition: 0,
        CompanyName: "",
        isErrorBopName: false,
        isErrorBopNameMsg: [], //事業者名
        BusinessOperatorType: 0,
        corproationDivision: "",
        corproationDivisionFlag: true,
        isErrorCorproationDivision: false, //法人個人区分
        KessanDateCondition: 0,
        KessanDateFromMonth: "",
        KessanDateFromDay: "",
        KessanDateToMonth: "",
        KessanDateToDay: "",
        returnCodeKessanDate: 0,
        isErrorKessanDateFromMonth: false,
        isErrorKessanDateFromDay: false,
        isErrorKessanDateToMonth: false,
        isErrorKessanDateToDay: false,
        isErrorKessanDate: false,
        isErrorKessanDateMsg: [], //決算日
        managerSelected: 0,
        manager: "",
        returnCodeManager: 0,
        isErrorManager: false,
        isErrorManagerMsg: [], //主担当者名
        BopAccountCondition: 0,
        businessAccount: "",
        businessAccountFlag: true,
        isErrorBusinessAccount: false, //事業者アカウント
        BopOpenFunctionCondition: 0,
        businessFunctionRelease: "",
        businessFunctionReleaseFlag: true,
        isErrorBusinessFunctionRelease: false, //事業者に対する機能利用権限
        NotificationFromBopCondition: 0, //事業者からの通知先
      };
      //画面項目設定_申告書等情報エリア
      this.declarationFormInfoArea = {
        TaxCategoryListCondition: 0,
        TaxCategoryList: "",
        isErrorTaxCategoryList: false,
        isErrorTaxCategoryListMsg: [], //申告書等
        fiscalYearStartCondition: 0,
        fiscalYearStartFromGengo: 0,
        fiscalYearStartFromYear: "",
        fiscalYearStartFromMonth: "",
        fiscalYearStartFromDay: "",
        fiscalYearStartToGengo: 0,
        fiscalYearStartToYear: "",
        fiscalYearStartToMonth: "",
        fiscalYearStartToDay: "",
        isErrorFiscalYearStartFromYear: false,
        isErrorFiscalYearStartFromMonth: false,
        isErrorFiscalYearStartFromDay: false,
        isErrorFiscalYearStartToYear: false,
        isErrorFiscalYearStartToMonth: false,
        isErrorFiscalYearStartToDay: false,
        isErrorFiscalYearStart: false,
        isErrorFiscalYearStartMsg: [], //事業年度等（開始）法人
        JigyoNendoToCondition: 0,
        JigyoNendoToGengo: 0,
        JigyoNendoToYear: "",
        JigyoNendoToMonth: "",
        JigyoNendoToDay: "",
        fiscalYearEndToGengo: 0,
        fiscalYearEndToYear: "",
        fiscalYearEndToMonth: "",
        fiscalYearEndToDay: "",
        isErrorJigyoNendoToYear: false,
        isErrorJigyoNendoToMonth: false,
        isErrorJigyoNendoToDay: false,
        isErrorFiscalYearEndToYear: false,
        isErrorFiscalYearEndToMonth: false,
        isErrorFiscalYearEndToDay: false,
        isErrorFiscalYearEnd: false,
        isErrorFiscalYearEndMsg: [], //事業年度等（終了）法人
        fiscalYearStartConditionKojin: 0,
        fiscalYearStartFromGengoKojin: 0,
        fiscalYearStartFromYearKojin: "",
        fiscalYearStartFromMonthKojin: "",
        fiscalYearStartFromDayKojin: "",
        fiscalYearStartToGengoKojin: 0,
        fiscalYearStartToYearKojin: "",
        fiscalYearStartToMonthKojin: "",
        fiscalYearStartToDayKojin: "",
        isErrorFiscalYearStartFromYearKojin: false,
        isErrorFiscalYearStartFromMonthKojin: false,
        isErrorFiscalYearStartFromDayKojin: false,
        isErrorFiscalYearStartToYearKojin: false,
        isErrorFiscalYearStartToMonthKojin: false,
        isErrorFiscalYearStartToDayKojin: false,
        isErrorFiscalYearStartKojin: false,
        isErrorFiscalYearStartMsgKojin: [], //事業年度等（開始）個人
        JigyoNendoToConditionKojin: 0,
        JigyoNendoToGengoKojin: 0,
        JigyoNendoToYearKojin: "",
        JigyoNendoToMonthKojin: "",
        JigyoNendoToDayKojin: "",
        fiscalYearEndToGengoKojin: 0,
        fiscalYearEndToYearKojin: "",
        fiscalYearEndToMonthKojin: "",
        fiscalYearEndToDayKojin: "",
        isErrorJigyoNendoToYearKojin: false,
        isErrorJigyoNendoToMonthKojin: false,
        isErrorJigyoNendoToDayKojin: false,
        isErrorFiscalYearEndToYearKojin: false,
        isErrorFiscalYearEndToMonthKojin: false,
        isErrorFiscalYearEndToDayKojin: false,
        isErrorFiscalYearEndKojin: false,
        isErrorFiscalYearEndMsgKojin: [], //事業年度等（終了）個人
        DataKbn: [
          0, 1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 4,
          24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 5, 6, 7, 8, 9,
          38, 39, 40, 41, 99,
        ],
        returnCodeDataKbn: 0, //データ区分
        DataNameCondition: 0,
        DataName: "",
        isErrorDataName: false,
        isErrorDataNameMsg: [], //データ名称
        Status: [0, 1, 2, 5, 7, 10, 100],
        returnCodeStatus: 0, //書類収集状況
      };
      //画面項目設定_アクセスログ情報エリア
      this.accessInfoArea = {
        AccessDateCondition: 0,
        AccessDateFromGengo: 0,
        AccessDateFromYMD: "",
        AccessDateFromYM: "",
        AccessDateFromYear: "",
        AccessDateFromMonth: "",
        AccessDateFromDay: "",
        AccessDateToGengo: 0,
        AccessDateToYMD: "",
        AccessDateToYear: "",
        AccessDateToMonth: "",
        AccessDateToDay: "",
        returnCodeAccessDate: 0,
        isErrorAccessDateFromYear: false,
        isErrorAccessDateFromMonth: false,
        isErrorAccessDateFromDay: false,
        isErrorAccessDateToYear: false,
        isErrorAccessDateToMonth: false,
        isErrorAccessDateToDay: false,
        isErrorAccessDate: false,
        isErrorAccessDateMsg: [], //処理日時
        treatmentTarget: [2, 3, 99], //処理対象
        processingDataCondition: 0,
        processingData: "",
        isErrorProcessingData: false,
        isErrorProcessingDataMsg: [], //処理データ
        ProcessingDivision: [1, 2, 3, 4, 5, 99], //処理区分
        // ProcessingDivision: [99], //処理区分
        bopUserCondition: 0,
        bopUser: "",
        isErrorBopUser: false,
        isErrorBopUserMsg: [], //事業者情報
        LoginIDCondition: 0,
        LoginID: "",
        isErrorLoginInID: false,
        isErrorLoginInIDMsg: [], //ログインID
        UserNameCondition: 0,
        UserName: "",
        isErrorUserName: false,
        isErrorUserNameMsg: [], //利用者名ID
        IPAddressCondition: 0,
        IPAddress: "",
        isErrorIPAddress: false,
        isErrorIPAddressMsg: [], //IPアドレス
      };
      //画面項目設定_社員情報エリア
      this.memberInfoArea = {
        motoPageHandleShowBtn: false,
        belongingCodeCondition: 0,
        belongingCode: "",
        // isErrorBelongingCode: false,
        isErrorBelongingCodeMsg: [], //所属コード
        belongingCondition: 0,
        belonging: "",
        returnCodeBelonging: 0,
        // isErrorBelonging: false,
        isErrorBelongingMsg: [], //所属
        memberCodeCondition: 0,
        memberCode: "",
        // isErrorMemberCode: false,
        isErrorMemberCodeMsg: [], //社員コード
        memberNameCondition: 0,
        memberName: "",
        // isErrorMemberName: false,
        isErrorMemberNameMsg: [], //社員名
        currentSituationCondition: PRESENT_SITUATION_LIST[0].code,
        // currentSituation: "",
        returnCodeCurrentSituation: 0,
        // isErrorCurrentSituation: false,
        isErrorCurrentSituationMsg: [], //現況
        emailAddressCondition: 0,
        emailAddress: "",
        // isErrorEmailAddress: false,
        isErrorEmailAddressMsg: [], //メールアドレス
        accountStatusCondition: 0,
        accountStatus: "",
        // isErrorAccountStatus: false,
        isErrorAccountStatusMsg: [], //アカウント状態
      };
      this.accessInfoArea.ProcessingDivision =
        this.filterViewsDisplay?.DisplayFlagsProcessing?.ProcessingDivisionList;
      // フィルター条件の保存
      if (!saveFlg) {
        //事業年度リセット
        this.declarationyearReSetting();

        if (this.filterViewsDisplay?.DisplayFlagsProcessing?.DC05C08Model) {
          //操作日時リセット
          this.accessDateReSettiong(this.STDSDC05C08FilterInit.displayTarget);
        }
        if (this.filterViewsDisplay?.DisplayFlagsProcessing?.DC05C09Model) {
          //処理日時リセット
          this.accessDateReSettiong(this.STDSDC05C09FilterInit.displayTarget);
        }

        this.saveFilter();
      }
    },

    // **********************************************
    // 事業年度リセット
    // **********************************************
    declarationyearReSetting() {
      const { dateTimeHojin, dateTimeKojin } = this.twoYearSetting();

      const seirekiHojin = dateTimeHojin.split(this.dateConnectorDash);
      const seirekiFromHojin = seirekiHojin[0];
      var warekiFromHojin = yearToWareki(seirekiFromHojin);
      const seirekiToHojin = seirekiHojin[1];
      var warekiToHojin = yearToWareki(seirekiToHojin);

      const seirekiKojin = dateTimeKojin.split(this.dateConnectorDash);
      const seirekiFromKojin = seirekiKojin[0];
      var warekiFromKojin = yearToWareki(seirekiFromKojin);
      const seirekiToKojin = seirekiKojin[1];
      var warekiToKojin = yearToWareki(seirekiToKojin);

      this.declarationFormInfoArea.fiscalYearStartCondition =
        DETAIL_DESIGNATED_DATE_LIST[0].code;
      this.declarationFormInfoArea.fiscalYearStartFromGengo = 0;
      this.declarationFormInfoArea.fiscalYearStartFromYear = "";
      this.declarationFormInfoArea.fiscalYearStartFromMonth = "";
      this.declarationFormInfoArea.fiscalYearStartFromDay = "";
      this.declarationFormInfoArea.fiscalYearStartToGengo = 0;
      this.declarationFormInfoArea.fiscalYearStartToYear = "";
      this.declarationFormInfoArea.fiscalYearStartToMonth = "";
      this.declarationFormInfoArea.fiscalYearStartToDay = ""; //事業年度等（開始）法人
      this.declarationFormInfoArea.JigyoNendoToCondition =
        DETAIL_DESIGNATED_DATE_LIST[3].code;
      this.declarationFormInfoArea.JigyoNendoToGengo =
        this.warekiCode(warekiFromHojin);
      this.declarationFormInfoArea.JigyoNendoToYear = warekiFromHojin.year;
      this.declarationFormInfoArea.JigyoNendoToMonth = 4;
      this.declarationFormInfoArea.JigyoNendoToDay = 1;
      this.declarationFormInfoArea.fiscalYearEndToGengo =
        this.warekiCode(warekiToHojin);
      this.declarationFormInfoArea.fiscalYearEndToYear = warekiToHojin.year;
      this.declarationFormInfoArea.fiscalYearEndToMonth = 3;
      this.declarationFormInfoArea.fiscalYearEndToDay = 31; //事業年度等（終了）法人

      this.declarationFormInfoArea.fiscalYearStartConditionKojin =
        DETAIL_DESIGNATED_DATE_LIST[0].code;
      this.declarationFormInfoArea.fiscalYearStartFromGengoKojin = 0;
      this.declarationFormInfoArea.fiscalYearStartFromYearKojin = "";
      this.declarationFormInfoArea.fiscalYearStartFromMonthKojin = "";
      this.declarationFormInfoArea.fiscalYearStartFromDayKojin = "";
      this.declarationFormInfoArea.fiscalYearStartToGengoKojin = 0;
      this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
      this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
      this.declarationFormInfoArea.fiscalYearStartToDayKojin = ""; //事業年度等（開始）個人
      this.declarationFormInfoArea.JigyoNendoToConditionKojin =
        DETAIL_DESIGNATED_DATE_LIST[3].code;
      this.declarationFormInfoArea.JigyoNendoToGengoKojin =
        this.warekiCode(warekiFromKojin);
      this.declarationFormInfoArea.JigyoNendoToYearKojin = warekiFromKojin.year;
      this.declarationFormInfoArea.JigyoNendoToMonthKojin = 1;
      this.declarationFormInfoArea.JigyoNendoToDayKojin = 1;
      this.declarationFormInfoArea.fiscalYearEndToGengoKojin =
        this.warekiCode(warekiToKojin);
      this.declarationFormInfoArea.fiscalYearEndToYearKojin =
        warekiToKojin.year;
      this.declarationFormInfoArea.fiscalYearEndToMonthKojin = 12;
      this.declarationFormInfoArea.fiscalYearEndToDayKojin = 31; //事業年度等（終了）個人
    },

    // **********************************************
    // 処理日時/操作日時リセット
    // **********************************************
    accessDateReSettiong(displayTarget) {
      if (!displayTarget) return;
      const seireki = displayTarget.split(this.dateConnector);
      const seirekiFrom = seireki[0];
      const seirekiTo = seireki[1];

      this.accessInfoArea.AccessDateFromYMD =
        moment(seirekiFrom).format("YYYY/MM/DD");
      this.accessInfoArea.AccessDateToYMD =
        moment(seirekiTo).format("YYYY/MM/DD");

      const seirekiFromYear = moment(seirekiFrom).year();
      const seirekiFromMon = moment(seirekiFrom).month() + 1;
      const seirekiFromDay = moment(seirekiFrom).date();
      const seirekiToYear = moment(seirekiTo).year();
      const seirekiToMon = moment(seirekiTo).month() + 1;
      const seirekiToDay = moment(seirekiTo).date();

      var warekiFrom = yearToWareki(seirekiFromYear);
      var warekiTo = yearToWareki(seirekiToYear);

      this.accessInfoArea.AccessDateCondition =
        DETAIL_DESIGNATED_DATE_LIST[3].code;
      this.accessInfoArea.AccessDateFromGengo = this.warekiCode(warekiFrom);
      this.accessInfoArea.AccessDateToGengo = this.warekiCode(warekiTo);

      this.accessInfoArea.AccessDateFromYear = warekiFrom.year;
      this.accessInfoArea.AccessDateFromMonth = seirekiFromMon;
      this.accessInfoArea.AccessDateFromDay = seirekiFromDay;

      this.accessInfoArea.AccessDateToYear = warekiTo.year;
      this.accessInfoArea.AccessDateToMonth = seirekiToMon;
      this.accessInfoArea.AccessDateToDay = seirekiToDay;
    },

    // **********************************************
    // エラーメッセージクリア
    // **********************************************
    errorsClear() {
      this.errors = [];
      //事業者情報エリア
      this.businessInfoArea.isErrorBopCodeMsg = [];
      this.businessInfoArea.isErrorBopCode = false; //業者コード
      this.businessInfoArea.isErrorBopNameMsg = [];
      this.businessInfoArea.isErrorBopName = false; //事業者名
      //this.businessInfoArea.isErrorCorproationDivision = false; //法人個人区分
      this.businessInfoArea.isErrorKessanDateFromMonth = false;
      this.businessInfoArea.isErrorKessanDateFromDay = false;
      this.businessInfoArea.isErrorKessanDateToMonth = false;
      this.businessInfoArea.isErrorKessanDateToDay = false;
      this.businessInfoArea.isErrorKessanDateMsg = []; //決算日
      this.businessInfoArea.isErrorManager = false;
      this.businessInfoArea.isErrorManagerMsg = []; //主担当者名

      //申告書等情報エリア
      this.declarationFormInfoArea.isErrorTaxCategoryListMsg = [];
      this.declarationFormInfoArea.isErrorTaxCategoryList = false; //申告書等
      this.declarationFormInfoArea.isErrorFiscalYearStartFromYear = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartFromMonth = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartFromDay = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartToYear = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartToMonth = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartToDay = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartMsg = []; //事業年度等（開始）法人
      this.declarationFormInfoArea.isErrorJigyoNendoToYear = false;
      this.declarationFormInfoArea.isErrorJigyoNendoToMonth = false;
      this.declarationFormInfoArea.isErrorJigyoNendoToDay = false;
      this.declarationFormInfoArea.isErrorFiscalYearEndToYear = false;
      this.declarationFormInfoArea.isErrorFiscalYearEndToMonth = false;
      this.declarationFormInfoArea.isErrorFiscalYearEndToDay = false;
      this.declarationFormInfoArea.isErrorFiscalYearEndMsg = []; //事業年度等（終了）法人
      this.declarationFormInfoArea.isErrorFiscalYearStartFromYearKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartFromMonthKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartFromDayKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartToYearKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartToMonthKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartToDayKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearStartMsgKojin = []; //事業年度等（開始）個人
      this.declarationFormInfoArea.isErrorJigyoNendoToYearKojin = false;
      this.declarationFormInfoArea.isErrorJigyoNendoToMonthKojin = false;
      this.declarationFormInfoArea.isErrorJigyoNendoToDayKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearEndToYearKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearEndToMonthKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearEndToDayKojin = false;
      this.declarationFormInfoArea.isErrorFiscalYearEndMsgKojin = []; //事業年度等（終了）個人
      this.declarationFormInfoArea.isErrorDataName = false;
      this.declarationFormInfoArea.isErrorDataNameMsg = []; //データ名称

      //アクセスログ情報エリア
      this.accessInfoArea.isErrorAccessDateFromYear = false;
      this.accessInfoArea.isErrorAccessDateFromMonth = false;
      this.accessInfoArea.isErrorAccessDateFromDay = false;
      this.accessInfoArea.isErrorAccessDateToYear = false;
      this.accessInfoArea.isErrorAccessDateToMonth = false;
      this.accessInfoArea.isErrorAccessDateToDay = false;
      this.accessInfoArea.isErrorAccessDateMsg = []; //処理日時

      this.accessInfoArea.isErrorProcessingDataMsg = [];
      this.accessInfoArea.isErrorProcessingData = false; //処理データ
      this.accessInfoArea.isErrorBopUser = false;
      this.accessInfoArea.isErrorBopUserMsg = []; //事業者情報
      this.accessInfoArea.isErrorLoginInID = false;
      this.accessInfoArea.isErrorLoginInIDMsg = []; //ログインID
      this.accessInfoArea.isErrorUserName = false;
      this.accessInfoArea.isErrorUserNameMsg = []; //利用者名ID
      this.accessInfoArea.isErrorIPAddress = false;
      this.accessInfoArea.isErrorIPAddressMsg = []; //IPアドレス

      //社員情報エリア
      if (this.filterViewsDisplay.ClassificationControlMemberInfo) {
        this.$refs.STDSDC01C09SelectChangeFormBelongingCode.clearError();
        this.memberInfoArea.isErrorBelongingCodeMsg = []; //所属コード
        this.$refs.STDSDC01C09SelectChangeFormBelonging.clearError();
        this.memberInfoArea.isErrorBelongingMsg = []; //所属
        this.$refs.STDSDC01C09SelectChangeFormMemberCode.clearError();
        this.memberInfoArea.isErrorMemberCodeMsg = []; //社員コード
        this.$refs.STDSDC01C09SelectChangeFormMemberName.clearError();
        this.memberInfoArea.isErrorMemberNameMsg = []; //社員名
        this.$refs.STDSDC01C09SelectChangeFormCurrentSituation.clearError();
        this.memberInfoArea.isErrorCurrentSituationMsg = []; //現況
        this.$refs.STDSDC01C09SelectChangeFormEmailAddress.clearError();
        this.memberInfoArea.isErrorEmailAddressMsg = []; //メールアドレス
        this.$refs.STDSDC01C09SelectChangeFormAccountStatus.clearError();
        this.memberInfoArea.isErrorAccountStatusMsg = []; //アカウント状態
      }
    },
    // **********************************************
    // ダイアログで検索が選択された時の処理
    // **********************************************
    SearchBtn() {
      this.processDialogue(true);
      //this.saveFilter().then(() (=> {
      this.errorsClear();

      //事業者情報エリア
      if (this.filterViewsDisplay.ClassificationControlBusinessInfo) {
        this.businessInfoAreaCheck();
      }

      if (this.errors.length > 0) {
        //return;
      } else {
        //元画面の連動項目コードを設定
        if (this.kessanDateCopyPageId.includes(this.pageId)) {
          this.returnKessanDateSetting(); //決算日連動
        }
        if (this.personInChargeCopyPageId.includes(this.pageId)) {
          this.returnManagerSetting(); //主担当者連動
        }
      }

      //申告書等情報エリア
      if (this.filterViewsDisplay.ClassificationControlDeclarationInfo) {
        this.declarationFormInfoAreaCheck();
      }

      if (this.errors.length > 0) {
        //return;
      } else {
        //元画面の連動項目コードを設定
        if (this.declarationyearCopyPageId.includes(this.pageId)) {
          this.returnDeclarationyearSetting(); //事業年度連動
        }
        //this.returnDataKbnSetting(); //データ区分連動
        if (this.statusCopyPageId.includes(this.pageId)) {
          this.returnStatusSetting(); //収集状況連動
        }
      }

      //アクセスログ情報エリア
      if (this.filterViewsDisplay.ClassificationControlAccessInfo) {
        this.accessInfoAreaCheck();
      }

      if (this.errors.length > 0) {
        //return;
      } else {
        //元画面の連動項目コードを設定
        if (this.accessDateCopyPageId.includes(this.pageId)) {
          this.returnAccessDateSetting();
        }
      }

      //社員情報エリア
      if (this.filterViewsDisplay.ClassificationControlMemberInfo) {
        this.memberInfoAreaCheck();
      }

      if (this.errors.length > 0) {
        //return;
      } else {
        //元画面の連動項目コードを設定
        this.returnBelongingSetting(); //所属連動
        this.returnCurrentSituationSetting(); //現況連動
      }

      if (this.errors.length > 0) {
        this.errors = [];
        const msg = Common.createError(
          "MTCL1119",
          Common.getMessage("MTCL1119", [])
        );
        this.errors.push(msg);
        this.processDialogue(false);
        return;
      }
      this.saveFilter().then(() => {
        this.processDialogue(false);

        const params = {
          searchKey: this.searchKey,
          motoPageHandleShowBtn: this.motoPageHandleShowBtnSetting(), //元画面の詳細条件ボタン設定
          returnBopDataFilter: this.returnBopDataFilter(), //事業者情報 フィルタ条件
          returnDocumentFilter: this.returnDocumentFilter(), //申告書等情報 フィルタ条件
          returnAccessLogFilter: this.returnAccessLogFilter(), //アクセスログ情報 フィルタ条件
          returnEmployeeInfoFilter: this.returnEmployeeInfoFilter(), //社員情報 フィルタ条件
        };

        this.$emit("SearchBtn", params);
      });
    },
    // **********************************************
    // ダイアログでキャンセルが選択された時の処理
    // **********************************************
    CancelBtn() {
      this.processDialogue(true);
      let param = {};
      let keyWordFilterReset = "";
      let bopDataFilterReset = {};
      let documentFilterReset = {};
      let accessLogFilterReset = {};
      let employeeInfoFilterReset = {};
      let apiRequest;
      this.handleReset(true);
      switch (this.pageId) {
        case "STDSDC02C01":
          apiRequest = API_Initialize;
          break;
        case "STDSDC02C10":
          apiRequest = API_DisplayEmployeeInfo;
          param = $cookies.get("businessOperatorId");
          // apiRequest = API_GetCollectDataHeaderList;
          break;
        case "STDSDC03C01":
          apiRequest = API_GetCollectDataHeaderList;
          break;
        case "STDSDC03C03":
          apiRequest = API_DisplaySelectBopUserScreen;
          break;
        case "STDSDC04C01":
          apiRequest = API_DisplayCollectionDocumentsEditScene;
          break;
        case "STDSDC05C08":
          apiRequest = API_DisplayLoginHistory;
          break;
        case "STDSDC05C09":
          apiRequest = API_DisplayAccessLog;
          break;
        default:
      }
      // 詳細フィルターを取得する
      apiRequest(param).then((response) => {
        // 保存されているフィルタ条件の適用
        if (response.bopDataFilter && response.bopDataFilter.result != "0001") {
          bopDataFilterReset = response.bopDataFilter;
        }
        if (response.keywordFilter && response.keywordFilter.result != "0001") {
          keyWordFilterReset = response.keywordFilter.searchKey;
        }
        if (
          response.accessLogFilter &&
          response.accessLogFilter.result != "0001"
        ) {
          accessLogFilterReset = response.accessLogFilter;
        }
        if (
          response.documentFilter &&
          response.documentFilter.result != "0001"
        ) {
          documentFilterReset = response.documentFilter;
        }
        if (
          response.employeeInfoFilter &&
          response.employeeInfoFilter.result != "0001"
        ) {
          employeeInfoFilterReset = response.employeeInfoFilter;
        }
        this.keyWordFilterInitWatch(keyWordFilterReset);
        this.bopDataFilterInitWatch(bopDataFilterReset);
        this.documentFilterInitWatch(documentFilterReset);
        this.accessLogFilterInitWatch(accessLogFilterReset);
        this.employeeInfoFilterInitWatch(employeeInfoFilterReset);
        this.STDSDC02C01FilterInitWatch(this.STDSDC02C01FilterInit);
        this.STDSDC02C10FilterInitWatch(this.STDSDC02C10FilterInit);
        this.STDSDC03C01FilterInitWatch(this.STDSDC03C01FilterInit);
        this.STDSDC03C03FilterInitWatch(this.STDSDC03C03FilterInit);
        this.STDSDC04C01FilterInitWatch(this.STDSDC04C01FilterInit);
        this.STDSDC05C08FilterInitWatch(this.STDSDC05C08FilterInit);
        this.STDSDC05C09FilterInitWatch(this.STDSDC05C09FilterInit);
        this.processDialogue(false);
        this.$emit("CancelBtn");
      });
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.search.focus();
    },
    // **********************************************
    // 区分チェックボックスの値を取得
    // **********************************************
    handleClick(e, data, checkedList) {
      if (checkedList.some((e) => e == data.code)) {
        checkedList = checkedList.filter((e) => e != data.code);
      } else {
        checkedList.push(data.code);
      }

      // if (checkedList.includes(99) && checkedList.length > 1) {
      //   checkedList = checkedList.filter((e) => e != 99);
      // } else {
      //   checkedList.push(99);
      // }
    },
    // **********************************************
    // データ区分チェックボックスの値を取得
    // **********************************************
    handleClickDataType(e, data) {
      let checkedList = this.declarationFormInfoArea.DataKbn;
      if (checkedList.some((e) => e == data.code)) {
        //四半期試算の場合
        if (data.enumname == DATA_CLASSIFICATION_LIST[6].enumname) {
          this.dataTypeQuarterlyArray.forEach((item) => {
            if (checkedList.indexOf(item) >= 0) {
              checkedList.splice(checkedList.indexOf(item), 1);
            }
          });
        } else if (data.enumname == DATA_CLASSIFICATION_LIST[3].enumname) {
          //予定申告の場合
          this.dataTypeProvisionalArray.forEach((item) => {
            if (checkedList.indexOf(item) >= 0) {
              checkedList.splice(checkedList.indexOf(item), 1);
            }
          });
        } else if (data.enumname == DATA_CLASSIFICATION_LIST[4].enumname) {
          //中間申告の場合
          this.dataTypeInterimArray.forEach((item) => {
            if (checkedList.indexOf(item) >= 0) {
              checkedList.splice(checkedList.indexOf(item), 1);
            }
          });
        } else {
          checkedList = checkedList.filter((e) => e != data.code);
        }
      } else {
        //四半期試算の場合
        if (data.enumname == DATA_CLASSIFICATION_LIST[6].enumname) {
          checkedList = checkedList.concat(this.dataTypeQuarterlyArray);
        } else if (data.enumname == DATA_CLASSIFICATION_LIST[3].enumname) {
          //予定申告の場合
          checkedList = checkedList.concat(this.dataTypeProvisionalArray);
        } else if (data.enumname == DATA_CLASSIFICATION_LIST[4].enumname) {
          //中間申告の場合
          checkedList = checkedList.concat(this.dataTypeInterimArray);
        } else {
          checkedList.push(data.code);
        }
      }

      this.declarationFormInfoArea.DataKbn = checkedList;
    },
    // **********************************************
    // フィルタ_DB保存
    // **********************************************
    saveFilter() {
      const keyWordFilter = {
        searchKey: this.searchKey,
        pageID: this.pageId,
        //sessinID: this.$cookies.get("SessionID"),
      };

      //事業者情報
      const detailBopFilter = this.returnBopDataFilter();

      //申告書等情報
      const detailDocumentFilter = this.returnDocumentFilter();

      //アクセスログ情報
      const accessLogFilter = this.returnAccessLogFilter();

      //社員情報
      const employeeInfoFilter = this.returnEmployeeInfoFilter();
      //#region
      let params = _.cloneDeep({
        keyWordFilter: keyWordFilter,
        BopDataFilter: null,
        DocumentFilter: null,
        AccessLogFilter: null,
        EmployeeInfoFilter: null,
      });

      if (this.filterViewsDisplay.ClassificationControlBusinessInfo) {
        params.BopDataFilter = detailBopFilter;
      }

      if (this.filterViewsDisplay.ClassificationControlDeclarationInfo) {
        params.DocumentFilter = detailDocumentFilter;
      }

      if (this.filterViewsDisplay.ClassificationControlAccessInfo) {
        params.AccessLogFilter = accessLogFilter;
      }

      if (this.filterViewsDisplay.ClassificationControlMemberInfo) {
        params.EmployeeInfoFilter = employeeInfoFilter;
      }

      this.errors = [];

      return new Promise((resolve, reject) => {
        // フィルター条件保存処理
        API_SetFilter(params).then((response) => {
          // 正常終了の場合
          if (_.eq(response.result, "0000")) {
            resolve();
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
            reject();
          }
        });
      });
      //#endregion
    },

    //#endregion

    //#region 画面項目をバックエンド項目に設定

    // **********************************************
    // 画面項目をバックエンド項目に設定　事業者情報
    // **********************************************
    returnBopDataFilter() {
      return {
        pageId: this.pageId,
        businessOperatorCodeOption: this.businessInfoArea.CompanyCodeCondition,
        businessOperatorCode: this.businessInfoArea.CompanyCode, //業者コード
        businessOperatorNameOption: this.businessInfoArea.CompanyNameCondition,
        businessOperatorName: this.businessInfoArea.CompanyName, //事業者名
        businessOperatorType: this.businessInfoArea.BusinessOperatorType,
        //corproationDivision: this.businessInfoArea.corproationDivision, //法人個人区分
        accountClosingOption: this.businessInfoArea.KessanDateCondition,
        accountClosingFromMonth: this.businessInfoArea.KessanDateFromMonth,
        accountClosingFromDay: this.businessInfoArea.KessanDateFromDay,
        accountClosingToMonth: this.businessInfoArea.KessanDateToMonth,
        accountClosingToDay: this.businessInfoArea.KessanDateToDay,
        returnCodeKessanDate: this.businessInfoArea.returnCodeKessanDate, //決算日
        personInChargeOption: this.businessInfoArea.managerSelected,
        returnCodePersonInCharge: this.businessInfoArea.returnCodeManager,
        personInCharge: this.businessInfoArea.manager, //主担当者名
        bopAccountCondition: this.businessInfoArea.BopAccountCondition,
        //BusinessAccount: this.businessInfoArea.businessAccount, //事業者アカウント
        functionAuthorityCondition:
          this.businessInfoArea.BopOpenFunctionCondition,
        //businessFunctionRelease: this.businessInfoArea.businessFunctionRelease, //事業者に対する機能利用権限
        // notificationFromBopCondition:
        //   this.businessInfoArea.NotificationFromBopCondition, //事業者からの通知先
        motoPageHandleShowBtn: this.motoPageHandleShowBtnSetting(), //元画面の詳細条件ボタン設定
      };
    },
    // **********************************************
    // 画面項目をバックエンド項目に設定　申告書等情報
    // **********************************************
    returnDocumentFilter() {
      return {
        pageId: this.pageId,
        taxCategoryListCondition:
          this.declarationFormInfoArea.TaxCategoryListCondition,
        taxCategoryList: this.declarationFormInfoArea.TaxCategoryList, //申告書等
        returnCodeDeclarationyear:
          this.declarationFormInfoArea.returnCodeDeclarationyear,
        businessFiscalFromOption:
          this.declarationFormInfoArea.fiscalYearStartCondition,
        businessFiscalFromReki:
          this.declarationFormInfoArea.fiscalYearStartFromGengo,
        businessFiscalFromYear:
          this.declarationFormInfoArea.fiscalYearStartFromYear,
        businessFiscalFromMonth:
          this.declarationFormInfoArea.fiscalYearStartFromMonth,
        businessFiscalFromDay:
          this.declarationFormInfoArea.fiscalYearStartFromDay,
        fiscalYearStartToGengo:
          this.declarationFormInfoArea.fiscalYearStartToGengo,
        fiscalYearStartToYear:
          this.declarationFormInfoArea.fiscalYearStartToYear,
        fiscalYearStartToMonth:
          this.declarationFormInfoArea.fiscalYearStartToMonth,
        fiscalYearStartToDay: this.declarationFormInfoArea.fiscalYearStartToDay, //事業年度等（開始）法人
        businessFiscalToOption:
          this.declarationFormInfoArea.JigyoNendoToCondition,
        businessFiscalToReki: this.declarationFormInfoArea.JigyoNendoToGengo,
        businessFiscalToYear: this.declarationFormInfoArea.JigyoNendoToYear,
        businessFiscalToMonth: this.declarationFormInfoArea.JigyoNendoToMonth,
        businessFiscalToDay: this.declarationFormInfoArea.JigyoNendoToDay,
        fiscalYearEndToGengo: this.declarationFormInfoArea.fiscalYearEndToGengo,
        fiscalYearEndToYear: this.declarationFormInfoArea.fiscalYearEndToYear,
        fiscalYearEndToMonth: this.declarationFormInfoArea.fiscalYearEndToMonth,
        fiscalYearEndToDay: this.declarationFormInfoArea.fiscalYearEndToDay, //事業年度等（終了）法人
        businessFiscalFromOptionKojin:
          this.declarationFormInfoArea.fiscalYearStartConditionKojin,
        businessFiscalFromRekiKojin:
          this.declarationFormInfoArea.fiscalYearStartFromGengoKojin,
        businessFiscalFromYearKojin:
          this.declarationFormInfoArea.fiscalYearStartFromYearKojin,
        businessFiscalFromMonthKojin:
          this.declarationFormInfoArea.fiscalYearStartFromMonthKojin,
        businessFiscalFromDayKojin:
          this.declarationFormInfoArea.fiscalYearStartFromDayKojin,
        fiscalYearStartToGengoKojin:
          this.declarationFormInfoArea.fiscalYearStartToGengoKojin,
        fiscalYearStartToYearKojin:
          this.declarationFormInfoArea.fiscalYearStartToYearKojin,
        fiscalYearStartToMonthKojin:
          this.declarationFormInfoArea.fiscalYearStartToMonthKojin,
        fiscalYearStartToDayKojin:
          this.declarationFormInfoArea.fiscalYearStartToDayKojin, //事業年度等（開始）個人
        businessFiscalToOptionKojin:
          this.declarationFormInfoArea.JigyoNendoToConditionKojin,
        businessFiscalToRekiKojin:
          this.declarationFormInfoArea.JigyoNendoToGengoKojin,
        businessFiscalToYearKojin:
          this.declarationFormInfoArea.JigyoNendoToYearKojin,
        businessFiscalToMonthKojin:
          this.declarationFormInfoArea.JigyoNendoToMonthKojin,
        businessFiscalToDayKojin:
          this.declarationFormInfoArea.JigyoNendoToDayKojin,
        fiscalYearEndToGengoKojin:
          this.declarationFormInfoArea.fiscalYearEndToGengoKojin,
        fiscalYearEndToYearKojin:
          this.declarationFormInfoArea.fiscalYearEndToYearKojin,
        fiscalYearEndToMonthKojin:
          this.declarationFormInfoArea.fiscalYearEndToMonthKojin,
        fiscalYearEndToDayKojin:
          this.declarationFormInfoArea.fiscalYearEndToDayKojin, //事業年度等（終了）個人
        dataClassificationList: this.declarationFormInfoArea.DataKbn,
        returnCodeDataKbn: this.declarationFormInfoArea.returnCodeDataKbn, //データ区分
        dataNameOption: this.declarationFormInfoArea.DataNameCondition,
        dataName: this.declarationFormInfoArea.DataName, //データ名称
        statusList: this.declarationFormInfoArea.Status,
        returnCodeStatus: this.declarationFormInfoArea.returnCodeStatus, //書類収集状況
        motoPageHandleShowBtn: this.motoPageHandleShowBtnSetting(), //元画面の詳細条件ボタン設定
      };
    },
    // **********************************************
    // 画面項目をバックエンド項目に設定　アクセスログ情報
    // **********************************************
    returnAccessLogFilter() {
      return {
        pageId: this.pageId,
        returnCodeAccessDate: this.accessInfoArea.returnCodeAccessDate,
        accessDateTimeFromOption: this.accessInfoArea.AccessDateCondition,
        accessDateFromYMD: this.accessInfoArea.AccessDateFromYMD,
        accessDateFromYM: this.accessInfoArea.AccessDateFromYM,
        accessDateToYMD: this.accessInfoArea.AccessDateToYMD,
        accessDateTimeFromReki: this.accessInfoArea.AccessDateFromGengo,
        accessDateTimeFromYear: this.accessInfoArea.AccessDateFromYear,
        accessDateTimeFromMonth: this.accessInfoArea.AccessDateFromMonth,
        accessDateTimeFromDay: this.accessInfoArea.AccessDateFromDay,
        accessDateTimeToReki: this.accessInfoArea.AccessDateToGengo,
        accessDateTimeToYear: this.accessInfoArea.AccessDateToYear,
        accessDateTimeToMonth: this.accessInfoArea.AccessDateToMonth,
        accessDateTimeToDay: this.accessInfoArea.AccessDateToDay, //処理日時
        // processingTypeList: this.accessInfoArea.ProcessingType, //処理種別
        objectNameOption: this.accessInfoArea.processingDataCondition,
        objectName: this.accessInfoArea.processingData, //処理データ
        objectType: this.accessInfoArea.treatmentTarget, //処理対象
        processingDivisionList: this.accessInfoArea.ProcessingDivision, //処理区分
        bopUserOption: this.accessInfoArea.bopUserCondition,
        bopUser: this.accessInfoArea.bopUser, //事業者情報
        userIDOption: this.accessInfoArea.LoginIDCondition,
        userID: this.accessInfoArea.LoginID, //ログインID
        userNameOption: this.accessInfoArea.UserNameCondition,
        userName: this.accessInfoArea.UserName, //利用者名ID
        ipAddressOption: this.accessInfoArea.IPAddressCondition,
        ipAddress: this.accessInfoArea.IPAddress, //IPアドレス
        motoPageHandleShowBtn: this.motoPageHandleShowBtnSetting(), //元画面の詳細条件ボタン設定
      };
    },
    // **********************************************
    // 画面項目をバックエンド項目に設定　社員情報
    // **********************************************
    returnEmployeeInfoFilter() {
      return {
        pageId: this.pageId,
        belongingCodeCondition: this.memberInfoArea.belongingCodeCondition,
        belongingCode: this.memberInfoArea.belongingCode, //所属コード
        belongingCondition: this.memberInfoArea.belongingCondition,
        belonging: this.memberInfoArea.belonging,
        returnCodeBelonging: this.memberInfoArea.returnCodeBelonging, //所属
        memberCodeCondition: this.memberInfoArea.memberCodeCondition,
        memberCode: this.memberInfoArea.memberCode, //社員コード
        memberNameCondition: this.memberInfoArea.memberNameCondition,
        memberName: this.memberInfoArea.memberName, //社員名
        currentSituationCondition:
          this.memberInfoArea.currentSituationCondition,
        // currentSituation: this.memberInfoArea.currentSituation,
        returnCodeCurrentSituation:
          this.memberInfoArea.returnCodeCurrentSituation, //現況
        emailAddressCondition: this.memberInfoArea.emailAddressCondition,
        emailAddress: this.memberInfoArea.emailAddress, //メールアドレス
        accountStatusCondition: this.memberInfoArea.accountStatusCondition,
        accountStatus: this.memberInfoArea.accountStatus, //アカウント状態

        motoPageHandleShowBtn: this.memberInfoArea.motoPageHandleShowBtn, //元画面の詳細条件ボタン設定
      };
    },
    //#endregion

    //#region 項目連動

    // **********************************************
    // 決算日連動
    // **********************************************
    kessanDateSetting(newVal) {
      if (!newVal) return;
      var accountClosingMonth = newVal; //決算日

      //決算日・指定しないの場合
      if (accountClosingMonth == DETAIL_DESIGNATED_DATE_LIST[0].code) {
        this.businessInfoArea.KessanDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.businessInfoArea.KessanDateFromMonth = "";
        this.businessInfoArea.KessanDateFromDay = "";
      } else if (accountClosingMonth == this.settingCode) {
        //処理なし
      } else {
        this.businessInfoArea.KessanDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[2].code;
        this.businessInfoArea.KessanDateFromMonth = accountClosingMonth;
        this.businessInfoArea.KessanDateFromDay = "";
      }
      this.filterCopy();
    },
    // **********************************************
    // 元画面の連動項目コードを設定 決算日連動
    // **********************************************
    returnKessanDateSetting() {
      var returnCode = 0;
      //決算日・指定しないの場合
      if (
        this.businessInfoArea.KessanDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        returnCode = 0;
      } else if (
        this.businessInfoArea.KessanDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
      ) {
        returnCode = this.settingCode;
      } else {
        if (this.businessInfoArea.KessanDateFromDay != "") {
          returnCode = this.settingCode;
        } else {
          returnCode = this.businessInfoArea.KessanDateFromMonth;
        }
      }
      this.businessInfoArea.returnCodeKessanDate = Number(returnCode);
      //this.businessInfoArea.returnCodeKessanDate = returnCode;
    },

    // **********************************************
    //主担当者連動
    // **********************************************
    managerSetting(newVal) {
      if (!newVal) return;
      var managerOption = newVal; //主担当者名

      //主担当者名・指定しないの場合
      if (managerOption == DETAIL_BUSINESS_CODE_LIST[0].code) {
        this.businessInfoArea.managerSelected =
          DETAIL_BUSINESS_CODE_LIST[0].code;
        this.businessInfoArea.manager = "";
      } else if (managerOption == this.settingCode) {
        //詳細指定中
        //処理なし
      } else if (managerOption == DETAIL_BUSINESS_CODE_LIST[3].code) {
        //未設定
        this.businessInfoArea.managerSelected =
          DETAIL_BUSINESS_CODE_LIST[3].code;
        //処理なし
      } else {
        //画面項目.決算日条件=指定日　かつ　月項目あり、日項目なし
        this.businessInfoArea.managerSelected =
          DETAIL_BUSINESS_CODE_LIST[1].code;
        this.businessInfoArea.manager = managerOption;
      }

      //基本情報.ログインシステム=データ集配信
      // if (
      //   this.loginSystem == this.logininSystemStatus["CollectionDelivery"].text
      // ) {
      //   this.businessInfoArea.manager = ""; //空文字
      // }
      this.filterCopy();
    },
    // **********************************************
    //元画面の連動項目コードを設定 主担当者連動
    // **********************************************
    returnManagerSetting() {
      var returnCode = 0;
      //主担当者・指定しないの場合
      if (
        this.businessInfoArea.managerSelected ==
        DETAIL_BUSINESS_CODE_LIST[0].code
      ) {
        returnCode = DETAIL_BUSINESS_CODE_LIST[0].code;
      } else if (
        this.businessInfoArea.managerSelected ==
        DETAIL_BUSINESS_CODE_LIST[3].code
      ) {
        returnCode = DETAIL_BUSINESS_CODE_LIST[3].code;
      } else if (
        this.businessInfoArea.managerSelected ==
          DETAIL_BUSINESS_CODE_LIST[1].code ||
        this.businessInfoArea.managerSelected ==
          DETAIL_BUSINESS_CODE_LIST[2].code
      ) {
        returnCode = this.settingCode;
      }
      // XXX 仕様変更
      // } else {
      //   const personInChargeFlg = this.personInChargeList.filter(
      //     (item) => item.value === this.businessInfoArea.manager
      //   );
      //   if (personInChargeFlg.length <= 0) {
      //     returnCode = this.settingCode;
      //   } else {
      //     returnCode = this.businessInfoArea.manager;
      //   }
      // }
      this.businessInfoArea.returnCodeManager = returnCode;
    },
    // **********************************************
    //事業年度連動
    // **********************************************
    DeclarationyearSetting(newVal) {
      if (!newVal) return;
      const time = moment().format("YYYY/MM/DD");
      const Declarationyear = newVal; //事業年度

      //事業年度・指定しないの場合
      if (Declarationyear == DETAIL_DESIGNATED_DATE_LIST[0].code) {
        this.declarationFormInfoArea.fiscalYearStartCondition =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.declarationFormInfoArea.fiscalYearStartFromGengo = 0;
        this.declarationFormInfoArea.fiscalYearStartFromYear = "";
        this.declarationFormInfoArea.fiscalYearStartFromMonth = "";
        this.declarationFormInfoArea.fiscalYearStartFromDay = "";
        this.declarationFormInfoArea.fiscalYearStartToGengo = 0;
        this.declarationFormInfoArea.fiscalYearStartToYear = "";
        this.declarationFormInfoArea.fiscalYearStartToMonth = "";
        this.declarationFormInfoArea.fiscalYearStartToDay = ""; //事業年度等（開始）法人
        this.declarationFormInfoArea.JigyoNendoToCondition =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.declarationFormInfoArea.JigyoNendoToGengo = 0;
        this.declarationFormInfoArea.JigyoNendoToYear = "";
        this.declarationFormInfoArea.JigyoNendoToMonth = "";
        this.declarationFormInfoArea.JigyoNendoToDay = "";
        this.declarationFormInfoArea.fiscalYearEndToGengo = 0;
        this.declarationFormInfoArea.fiscalYearEndToYear = "";
        this.declarationFormInfoArea.fiscalYearEndToMonth = "";
        this.declarationFormInfoArea.fiscalYearEndToDay = ""; //事業年度等（終了）法人

        this.declarationFormInfoArea.fiscalYearStartConditionKojin =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.declarationFormInfoArea.fiscalYearStartFromGengoKojin = 0;
        this.declarationFormInfoArea.fiscalYearStartFromYearKojin = "";
        this.declarationFormInfoArea.fiscalYearStartFromMonthKojin = "";
        this.declarationFormInfoArea.fiscalYearStartFromDayKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToGengoKojin = 0;
        this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToDayKojin = ""; //事業年度等（開始）個人
        this.declarationFormInfoArea.JigyoNendoToConditionKojin =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.declarationFormInfoArea.JigyoNendoToGengoKojin = 0;
        this.declarationFormInfoArea.JigyoNendoToYearKojin = "";
        this.declarationFormInfoArea.JigyoNendoToMonthKojin = "";
        this.declarationFormInfoArea.JigyoNendoToDayKojin = "";
        this.declarationFormInfoArea.fiscalYearEndToGengoKojin = 0;
        this.declarationFormInfoArea.fiscalYearEndToYearKojin = "";
        this.declarationFormInfoArea.fiscalYearEndToMonthKojin = "";
        this.declarationFormInfoArea.fiscalYearEndToDayKojin = ""; //事業年度等（終了）個人
      } else if (Declarationyear == this.settingCode) {
        //詳細指定中
        //処理なし
      } else if ((Declarationyear + "").includes(this.dateConnectorDash)) {
        //直近2年分
        const { dateTimeHojin, dateTimeKojin } = this.twoYearSetting();

        const seirekiHojin = dateTimeHojin.split(this.dateConnectorDash);
        const seirekiFromHojin = seirekiHojin[0];
        var warekiFromHojin = yearToWareki(seirekiFromHojin);
        const seirekiToHojin = seirekiHojin[1];
        var warekiToHojin = yearToWareki(seirekiToHojin);

        const seirekiKojin = dateTimeKojin.split(this.dateConnectorDash);
        const seirekiFromKojin = seirekiKojin[0];
        var warekiFromKojin = yearToWareki(seirekiFromKojin);
        const seirekiToKojin = seirekiKojin[1];
        var warekiToKojin = yearToWareki(seirekiToKojin);

        this.declarationFormInfoArea.fiscalYearStartCondition =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.declarationFormInfoArea.fiscalYearStartFromGengo = 0;
        this.declarationFormInfoArea.fiscalYearStartFromYear = "";
        this.declarationFormInfoArea.fiscalYearStartFromMonth = "";
        this.declarationFormInfoArea.fiscalYearStartFromDay = "";
        this.declarationFormInfoArea.fiscalYearStartToGengo = 0;
        this.declarationFormInfoArea.fiscalYearStartToYear = "";
        this.declarationFormInfoArea.fiscalYearStartToMonth = "";
        this.declarationFormInfoArea.fiscalYearStartToDay = ""; //事業年度等（開始）法人
        this.declarationFormInfoArea.JigyoNendoToCondition =
          DETAIL_DESIGNATED_DATE_LIST[3].code;
        this.declarationFormInfoArea.JigyoNendoToGengo =
          this.warekiCode(warekiFromHojin);
        this.declarationFormInfoArea.JigyoNendoToYear = warekiFromHojin.year;
        this.declarationFormInfoArea.JigyoNendoToMonth = 4;
        this.declarationFormInfoArea.JigyoNendoToDay = 1;
        this.declarationFormInfoArea.fiscalYearEndToGengo =
          this.warekiCode(warekiToHojin);
        this.declarationFormInfoArea.fiscalYearEndToYear = warekiToHojin.year;
        this.declarationFormInfoArea.fiscalYearEndToMonth = 3;
        this.declarationFormInfoArea.fiscalYearEndToDay = 31; //事業年度等（終了）法人

        this.declarationFormInfoArea.fiscalYearStartConditionKojin =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.declarationFormInfoArea.fiscalYearStartFromGengoKojin = 0;
        this.declarationFormInfoArea.fiscalYearStartFromYearKojin = "";
        this.declarationFormInfoArea.fiscalYearStartFromMonthKojin = "";
        this.declarationFormInfoArea.fiscalYearStartFromDayKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToGengoKojin = 0;
        this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToDayKojin = ""; //事業年度等（開始）個人
        this.declarationFormInfoArea.JigyoNendoToConditionKojin =
          DETAIL_DESIGNATED_DATE_LIST[3].code;
        this.declarationFormInfoArea.JigyoNendoToGengoKojin =
          this.warekiCode(warekiFromKojin);
        this.declarationFormInfoArea.JigyoNendoToYearKojin =
          warekiFromKojin.year;
        this.declarationFormInfoArea.JigyoNendoToMonthKojin = 1;
        this.declarationFormInfoArea.JigyoNendoToDayKojin = 1;
        this.declarationFormInfoArea.fiscalYearEndToGengoKojin =
          this.warekiCode(warekiToKojin);
        this.declarationFormInfoArea.fiscalYearEndToYearKojin =
          warekiToKojin.year;
        this.declarationFormInfoArea.fiscalYearEndToMonthKojin = 12;
        this.declarationFormInfoArea.fiscalYearEndToDayKojin = 31; //事業年度等（終了）個人
      } else {
        const warekiPlus1 = yearToWareki(Number(Declarationyear) + 1);
        const wareki = yearToWareki(Declarationyear);

        this.declarationFormInfoArea.fiscalYearStartCondition =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.declarationFormInfoArea.fiscalYearStartFromGengo = 0;
        this.declarationFormInfoArea.fiscalYearStartFromYear = "";
        this.declarationFormInfoArea.fiscalYearStartFromMonth = "";
        this.declarationFormInfoArea.fiscalYearStartFromDay = "";
        this.declarationFormInfoArea.fiscalYearStartToGengo = 0;
        this.declarationFormInfoArea.fiscalYearStartToYear = "";
        this.declarationFormInfoArea.fiscalYearStartToMonth = "";
        this.declarationFormInfoArea.fiscalYearStartToDay = ""; //事業年度等（開始）法人
        this.declarationFormInfoArea.JigyoNendoToCondition =
          DETAIL_DESIGNATED_DATE_LIST[3].code;
        this.declarationFormInfoArea.JigyoNendoToGengo =
          this.warekiCode(wareki);
        this.declarationFormInfoArea.JigyoNendoToYear = wareki.year;
        this.declarationFormInfoArea.JigyoNendoToMonth = 4;
        this.declarationFormInfoArea.JigyoNendoToDay = 1;
        this.declarationFormInfoArea.fiscalYearEndToGengo =
          this.warekiCode(warekiPlus1);
        this.declarationFormInfoArea.fiscalYearEndToYear = warekiPlus1.year;
        this.declarationFormInfoArea.fiscalYearEndToMonth = 3;
        this.declarationFormInfoArea.fiscalYearEndToDay = 31; //事業年度等（終了）法人

        this.declarationFormInfoArea.fiscalYearStartConditionKojin =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.declarationFormInfoArea.fiscalYearStartFromGengoKojin = 0;
        this.declarationFormInfoArea.fiscalYearStartFromYearKojin = "";
        this.declarationFormInfoArea.fiscalYearStartFromMonthKojin = "";
        this.declarationFormInfoArea.fiscalYearStartFromDayKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToGengoKojin = 0;
        this.declarationFormInfoArea.fiscalYearStartToYearKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToMonthKojin = "";
        this.declarationFormInfoArea.fiscalYearStartToDayKojin = ""; //事業年度等（開始）個人
        this.declarationFormInfoArea.JigyoNendoToConditionKojin =
          DETAIL_DESIGNATED_DATE_LIST[3].code;
        this.declarationFormInfoArea.JigyoNendoToGengoKojin =
          this.warekiCode(wareki);
        this.declarationFormInfoArea.JigyoNendoToYearKojin = wareki.year;
        this.declarationFormInfoArea.JigyoNendoToMonthKojin = 1;
        this.declarationFormInfoArea.JigyoNendoToDayKojin = 1;
        this.declarationFormInfoArea.fiscalYearEndToGengoKojin =
          this.warekiCode(wareki);
        this.declarationFormInfoArea.fiscalYearEndToYearKojin = wareki.year;
        this.declarationFormInfoArea.fiscalYearEndToMonthKojin = 12;
        this.declarationFormInfoArea.fiscalYearEndToDayKojin = 31; //事業年度等（終了）個人
      }
      this.filterCopy();
    },
    // **********************************************
    //元画面の連動項目コードを設定 事業年度連動
    // **********************************************
    returnDeclarationyearSetting() {
      const time = moment().format("YYYY/MM/DD");
      let returnCode = 0;

      //申告年度・指定しないの場合
      if (
        this.declarationFormInfoArea.fiscalYearStartCondition == 0 &&
        this.declarationFormInfoArea.JigyoNendoToCondition == 0 &&
        this.declarationFormInfoArea.fiscalYearStartConditionKojin == 0 &&
        this.declarationFormInfoArea.JigyoNendoToConditionKojin == 0
      ) {
        returnCode = 0;
      } else if (
        this.declarationFormInfoArea.fiscalYearStartCondition == 0 &&
        this.declarationFormInfoArea.JigyoNendoToCondition ==
          DETAIL_DESIGNATED_DATE_LIST[3].code &&
        this.declarationFormInfoArea.fiscalYearStartConditionKojin == 0 &&
        this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
          DETAIL_DESIGNATED_DATE_LIST[3].code
      ) {
        let hojinStart = warekiToYear(
          this.declarationFormInfoArea.JigyoNendoToGengo,
          this.declarationFormInfoArea.JigyoNendoToYear
        );
        let hojinEnd = warekiToYear(
          this.declarationFormInfoArea.fiscalYearEndToGengo,
          this.declarationFormInfoArea.fiscalYearEndToYear
        );
        let kojinStart = warekiToYear(
          this.declarationFormInfoArea.JigyoNendoToGengoKojin,
          this.declarationFormInfoArea.JigyoNendoToYearKojin
        );
        let kojinEnd = warekiToYear(
          this.declarationFormInfoArea.fiscalYearEndToGengoKojin,
          this.declarationFormInfoArea.fiscalYearEndToYearKojin
        );
        let sysTime = moment().year();
        let sysTimePlus1 = moment().add(1, "years").year();
        let sysTimeMus1 = moment().add(-1, "years").year();
        let sysTimeMus2 = moment().add(-2, "years").year();

        //kbn.rtnCode   1⇒現在の日付が1/1日～7/31日の場合
        //              2⇒現在の日付が8/1日～12/31日の場合
        let kbn = this.twoYearSetting();

        if (
          hojinEnd == hojinStart + 1 &&
          kojinStart == hojinStart &&
          kojinEnd == hojinStart &&
          this.declarationFormInfoArea.JigyoNendoToMonth == 4 &&
          this.declarationFormInfoArea.JigyoNendoToDay == 1 &&
          this.declarationFormInfoArea.fiscalYearEndToMonth == 3 &&
          this.declarationFormInfoArea.fiscalYearEndToDay == 31 &&
          this.declarationFormInfoArea.JigyoNendoToMonthKojin == 1 &&
          this.declarationFormInfoArea.JigyoNendoToDayKojin == 1 &&
          this.declarationFormInfoArea.fiscalYearEndToMonthKojin == 12 &&
          this.declarationFormInfoArea.fiscalYearEndToDayKojin == 31
        ) {
          //システム年を和暦変換した年+年度
          const rtnFlg = kbn.dateTimeList.filter(
            (item) => item.code == hojinStart
          );
          if (rtnFlg.length > 0) {
            returnCode = Number(hojinStart);
          } else {
            returnCode = Number(this.settingCode);
          }
        } else if (
          kbn.rtnCode == 1 &&
          hojinStart == sysTimeMus2 &&
          hojinEnd == sysTimePlus1 &&
          kojinStart == sysTimeMus2 &&
          kojinEnd == sysTime &&
          this.declarationFormInfoArea.JigyoNendoToMonth == 4 &&
          this.declarationFormInfoArea.JigyoNendoToDay == 1 &&
          this.declarationFormInfoArea.fiscalYearEndToMonth == 3 &&
          this.declarationFormInfoArea.fiscalYearEndToDay == 31 &&
          this.declarationFormInfoArea.JigyoNendoToMonthKojin == 1 &&
          this.declarationFormInfoArea.JigyoNendoToDayKojin == 1 &&
          this.declarationFormInfoArea.fiscalYearEndToMonthKojin == 12 &&
          this.declarationFormInfoArea.fiscalYearEndToDayKojin == 31
        ) {
          //直近2年分
          //returnCode = `${sysTimeMus2}${this.dateConnectorDash}${sysTimePlus1}`;
          returnCode = this.twoYearSetting().motoPageSelectValue;
        } else if (
          kbn.rtnCode == 2 &&
          hojinStart == sysTimeMus1 &&
          hojinEnd == sysTimePlus1 &&
          kojinStart == sysTimeMus1 &&
          kojinEnd == sysTime &&
          this.declarationFormInfoArea.JigyoNendoToMonth == 4 &&
          this.declarationFormInfoArea.JigyoNendoToDay == 1 &&
          this.declarationFormInfoArea.fiscalYearEndToMonth == 3 &&
          this.declarationFormInfoArea.fiscalYearEndToDay == 31 &&
          this.declarationFormInfoArea.JigyoNendoToMonthKojin == 1 &&
          this.declarationFormInfoArea.JigyoNendoToDayKojin == 1 &&
          this.declarationFormInfoArea.fiscalYearEndToMonthKojin == 12 &&
          this.declarationFormInfoArea.fiscalYearEndToDayKojin == 31
        ) {
          //直近2年分
          //returnCode = `${sysTimeMus1}${this.dateConnectorDash}${sysTimePlus1}`;
          returnCode = this.twoYearSetting().motoPageSelectValue;
        } else {
          returnCode = Number(this.settingCode);
        }
      } else {
        returnCode = Number(this.settingCode);
      }

      this.declarationFormInfoArea.returnCodeDeclarationyear = returnCode;
    },
    // **********************************************
    //直近2年分
    // **********************************************
    twoYearSetting() {
      //let dateTime = { startDate: "", endDate: "" };
      let rtn = {
        rtnCode: 0,
        sysTime: 0,
        dateTimeHojin: 0,
        dateTimeKojin: 0,
        motoPageSelectValue: 0,
        dateTimeList: [],
      };
      const time = moment().format("YYYY/MM/DD");

      // 1/1日～7/31日
      const startFirstHalfYear = moment().format("YYYY/01/01");
      const endFirstHalfYear =
        moment().format("YYYY/07/") + moment("YYYY/07/").daysInMonth();

      // 8/1日～12/31日
      const startSecondtHalfYear = moment().format("YYYY/08/01");
      const endSecondHalfYear =
        moment().format("YYYY/12/") + moment("YYYY/12/").daysInMonth();

      // 現在の日付が1/1日～7/31日の場合
      if (
        moment(time).isBetween(
          startFirstHalfYear,
          endFirstHalfYear,
          undefined,
          "[]"
        )
      ) {
        rtn.dateTimeHojin = `${moment(time).year() - 2}${
          this.dateConnectorDash
        }${moment(time).year() + 1}`;
        rtn.dateTimeKojin = `${moment(time).year() - 2}${
          this.dateConnectorDash
        }${moment(time).year()}`;
        rtn.rtnCode = 1;
        rtn.sysTime = moment(time).year();
        rtn.motoPageSelectValue = `${moment(time).year() - 2}${
          this.dateConnectorDash
        }${moment(time).year() + 1}`;
        rtn.dateTimeList = [
          { code: 0, name: "指定しない" },
          {
            code: `${moment(time).year() - 2}/${moment(time).year() + 1}`,
            name: "直近2年分",
          },
          {
            code: moment(time).year() + 1,
          },
          {
            code: moment(time).year(),
          },
          {
            code: moment(time).year() - 1,
          },
          {
            code: moment(time).year() - 2,
          },
        ];
      }
      // 現在の日付が8/1日～12/31日の場合
      if (
        moment(time).isBetween(
          startSecondtHalfYear,
          endSecondHalfYear,
          undefined,
          "[]"
        )
      ) {
        rtn.dateTimeHojin = `${moment(time).year() - 1}${
          this.dateConnectorDash
        }${moment(time).year() + 1}`;
        rtn.dateTimeKojin = `${moment(time).year() - 1}${
          this.dateConnectorDash
        }${moment(time).year()}`;
        rtn.rtnCode = 2;
        rtn.sysTime = moment(time).year();
        rtn.motoPageSelectValue = `${moment(time).year() - 1}${
          this.dateConnectorDash
        }${moment(time).year() + 1}`;
        rtn.dateTimeList = [
          { code: 0, name: "指定しない" },
          {
            code: `${moment(time).year() - 1}/${moment(time).year() + 1}`,
            name: "直近2年分",
          },
          {
            code: moment(time).year() + 1,
          },
          { code: moment(time).year() },
          {
            code: moment(time).year() - 1,
          },
        ];
      }

      return rtn;
    },

    // **********************************************
    //収集状況連動
    // **********************************************
    StatusSetting(newVal) {
      if (!newVal) return;
      var documentStatus = newVal; //書類収集状況

      //書類収集状況、選択された書類収集状況リスト
      var documentStatuslist = [100];
      if (documentStatus == this.settingCode) {
        //指定しない
        this.declarationFormInfoArea.Status = [0, 1, 2, 5, 7, 10, 100];
      } else if (documentStatus == this.settingCodeCheckBox) {
        //詳細指定中
        //処理なし
      } else {
        documentStatuslist.push(Number(documentStatus));
        this.declarationFormInfoArea.Status = documentStatuslist;
      }
      this.filterCopy();
    },
    // **********************************************
    //元画面の連動項目コードを設定 収集状況連動
    // **********************************************
    returnStatusSetting() {
      let returnCode = 0;
      //収集状況、選択された区分リスト
      var datalist = this.declarationFormInfoArea.Status.filter(function (val) {
        return val != 100;
      });
      if (datalist.length == 1) {
        returnCode = datalist[0];
        if (
          this.documentsDropdownList &&
          this.documentsDropdownList.length > 0
        ) {
          let existInList = this.documentsDropdownList.some(
            (elem) => returnCode == elem.code
          );
          if (!existInList) {
            returnCode = this.settingCodeCheckBox;
          }
        }
      } else if (datalist.length == DOCUMENT_STATUS_LIST.length - 1) {
        returnCode = this.settingCode;
      } else {
        returnCode = this.settingCodeCheckBox;
      }
      this.declarationFormInfoArea.returnCodeStatus = Number(returnCode);
    },

    // **********************************************
    //操作日時連動
    // **********************************************
    OperationDateSetting(newVal) {
      if (!newVal) return;
      var AccessDate = newVal; //操作日時

      //操作日時・指定しないの場合
      if (AccessDate == DETAIL_DESIGNATED_DATE_LIST[0].code) {
        this.accessInfoArea.AccessDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.accessInfoArea.AccessDateFromYM = "";
        this.accessInfoArea.AccessDateFromYMD = "";
        this.accessInfoArea.AccessDateToYMD = "";
      } else if (AccessDate == this.settingCode) {
        //詳細指定中
        //処理なし
      } else if (AccessDate.includes(this.dateConnector)) {
        const seireki = AccessDate.split(this.dateConnector);
        const seirekiFrom = seireki[0];
        const seirekiTo = seireki[1];
        this.accessInfoArea.AccessDateFromYM = "";
        this.accessInfoArea.AccessDateFromYMD =
          moment(seirekiFrom).format("YYYY-MM-DD");
        this.accessInfoArea.AccessDateToYMD =
          moment(seirekiTo).format("YYYY-MM-DD");
        this.accessInfoArea.AccessDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[3].code;
      } else {
        this.accessInfoArea.AccessDateFromYMD =
          moment(AccessDate).format("YYYY-MM-01");
        this.accessInfoArea.AccessDateToYMD =
          moment(AccessDate).format("YYYY-MM-") +
          moment(AccessDate).daysInMonth();
        this.accessInfoArea.AccessDateFromYM = "";
        this.accessInfoArea.AccessDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[3].code;
      }
      this.dateSplit();
      this.filterCopy();
    },
    // **********************************************
    //表示対象/処理日時連動
    // **********************************************
    AccessDateSetting(newVal) {
      if (!newVal) return;
      var AccessDate = newVal; //表示対象

      //表示対象・指定しないの場合
      if (AccessDate == DETAIL_DESIGNATED_DATE_LIST[0].code) {
        this.accessInfoArea.AccessDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.accessInfoArea.AccessDateFromYM = "";
        this.accessInfoArea.AccessDateFromYMD = "";
        this.accessInfoArea.AccessDateToYMD = "";
      } else if (AccessDate == this.settingCode) {
        //詳細指定中
        //処理なし
      } else if (AccessDate.includes(this.dateConnector)) {
        const seireki = AccessDate.split(this.dateConnector);
        const seirekiFrom = seireki[0];
        const seirekiTo = seireki[1];
        this.accessInfoArea.AccessDateFromYM = "";
        this.accessInfoArea.AccessDateFromYMD =
          moment(seirekiFrom).format("YYYY-MM-DD");
        this.accessInfoArea.AccessDateToYMD =
          moment(seirekiTo).format("YYYY-MM-DD");
        this.accessInfoArea.AccessDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[3].code;
      } else {
        this.accessInfoArea.AccessDateFromYMD = "";
        this.accessInfoArea.AccessDateToYMD = "";
        this.accessInfoArea.AccessDateFromYM =
          moment(AccessDate).format("YYYY-MM");
        this.accessInfoArea.AccessDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[2].code;
      }
      this.dateSplit();
      this.filterCopy();
    },
    // **********************************************
    //元画面の連動項目コードを設定 処理日時連動
    // **********************************************
    returnAccessDateSetting() {
      let returnCode = 0;

      //表示対象・指定しないの場合
      if (
        this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        returnCode = 0;
      } else if (
        this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[1].code
      ) {
        returnCode = this.settingCode;
      } else if (
        this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
      ) {
        let checkFlg = this.oneMonthBefore();
        if (checkFlg != "") {
          const dateTimeListFormat = this.getDateTimeListFormat(
            this.dateTimeList
          );
          const dateListFlg1 = dateTimeListFormat.filter(
            (item) => item.code === checkFlg
          );
          if (dateListFlg1.length <= 0) {
            returnCode = this.settingCode;
          } else {
            returnCode = checkFlg;
          }
        } else {
          returnCode = this.settingCode;
        }
      } else if (
        this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
      ) {
        const accessDateFromYMFormat = moment(
          this.accessInfoArea.AccessDateFromYM
        ).format("YYYY/MM");
        const dateTimeListFormat = this.getDateTimeListFormat(
          this.dateTimeList
        );
        const dateListFlg = dateTimeListFormat.filter(
          (item) => item.code === accessDateFromYMFormat
        );
        if (dateListFlg.length <= 0) {
          returnCode = this.settingCode;
        } else {
          returnCode = accessDateFromYMFormat;
        }
      } else {
        returnCode = this.settingCode;
      }

      this.accessInfoArea.returnCodeAccessDate = returnCode;
    },
    // **********************************************
    //元画面の連動日時をフォーマット
    // **********************************************
    getDateTimeListFormat(dateTimeListFlg) {
      if (this.filterViewsDisplay.DisplayFlagsProcessing?.DC05C09Model) {
        return dateTimeListFlg.map((item) => {
          if (item[0] == "直近1か月") {
            return { value: item[0], code: `${item[1]}-${item[2]}` };
          } else {
            return { value: item[0], code: moment(item[1]).format("YYYY/MM") };
          }
        });
      } else {
        return dateTimeListFlg;
      }
    },
    // **********************************************
    //直近1か月
    // **********************************************
    oneMonthBefore() {
      const time = moment().format("YYYY/MM/DD");
      const fromSeirekiYear = warekiToYear(
        this.accessInfoArea.AccessDateFromGengo,
        this.accessInfoArea.AccessDateFromYear
      );
      const accessDateFromData = moment(
        new Date(
          fromSeirekiYear,
          this.accessInfoArea.AccessDateFromMonth - 1,
          this.accessInfoArea.AccessDateFromDay
        )
      );
      //accessDateFromData  = moment(accessDateFromData);
      const toSeirekiYear = warekiToYear(
        this.accessInfoArea.AccessDateToGengo,
        this.accessInfoArea.AccessDateToYear
      );
      const accessDateToData = moment(
        new Date(
          toSeirekiYear,
          this.accessInfoArea.AccessDateToMonth - 1,
          this.accessInfoArea.AccessDateToDay
        )
      );
      //accessDateToData  = moment(accessDateToData);

      // システム日付の1か月前
      const systemTimeOneMonBefore = moment()
        .add("month", -1)
        .add("days", +1)
        .format("YYYY/MM/DD");
      //システム日付
      const systemTime = moment().format("YYYY/MM/DD");

      if (
        systemTime == accessDateToData.format("YYYY/MM/DD") &&
        systemTimeOneMonBefore == accessDateFromData.format("YYYY/MM/DD")
      ) {
        //直近1か月
        return `${accessDateFromData.format("YYYY/MM/DD")}${
          this.dateConnector
        }${accessDateToData.format("YYYY/MM/DD")}`;
      } else if (
        fromSeirekiYear == toSeirekiYear &&
        this.accessInfoArea.AccessDateFromMonth ==
          this.accessInfoArea.AccessDateToMonth &&
        this.accessInfoArea.AccessDateFromDay == 1 &&
        this.accessInfoArea.AccessDateToDay == accessDateToData.daysInMonth()
      ) {
        //処理日時(自)を西暦変換し、yyyy年m月に変換した値
        return accessDateFromData.format("YYYY/MM");
      } else {
        //詳細指定中
        return "";
      }
    },

    // **********************************************
    //所属連動
    // **********************************************
    belongingSetting(newVal) {
      // if (!newVal) return;

      //所属・指定しないの場合
      if (newVal == DETAIL_BUSINESS_CODE_LIST[0].code) {
        this.memberInfoArea.belongingCondition =
          DETAIL_BUSINESS_CODE_LIST[0].code;
        this.memberInfoArea.belonging = "";
      } else if (newVal == this.settingCode) {
        //詳細指定中
        //処理なし
      } else if (newVal == DETAIL_BUSINESS_CODE_LIST[3].code) {
        //未設定
        //画面項目
        this.memberInfoArea.belongingCondition =
          DETAIL_BUSINESS_CODE_LIST[3].code;
        this.memberInfoArea.belonging = "";
      } else {
        //画面項目
        this.memberInfoArea.belongingCondition =
          DETAIL_BUSINESS_CODE_LIST[1].code;
        this.memberInfoArea.belonging = newVal;
      }
    },
    // **********************************************
    //元画面の連動項目コードを設定 所属連動
    // **********************************************
    returnBelongingSetting() {
      var returnCode = 0;
      //所属・指定しないの場合
      if (
        this.memberInfoArea.belongingCondition ==
          DETAIL_BUSINESS_CODE_LIST[0].code ||
        this.memberInfoArea.belongingCondition ==
          DETAIL_BUSINESS_CODE_LIST[3].code
      ) {
        returnCode = this.memberInfoArea.belongingCondition;
      } else if (
        this.memberInfoArea.belongingCondition ==
          DETAIL_BUSINESS_CODE_LIST[1].code ||
        this.memberInfoArea.belongingCondition ==
          DETAIL_BUSINESS_CODE_LIST[2].code
      ) {
        returnCode = this.settingCode;
        this.memberInfoArea.motoPageHandleShowBtn = true;
      }
      // } else {
      //   const belongingFlg = this.belongingList.filter(
      //     (item) => item.value === this.memberInfoArea.belonging
      //   );
      //   if (belongingFlg.length <= 0) {
      //     returnCode = this.settingCode;
      //   } else {
      //     returnCode = this.memberInfoArea.belonging;
      //   }
      // }
      this.memberInfoArea.returnCodeBelonging = returnCode;
    },

    // **********************************************
    //現況連動
    // **********************************************
    currentSituationSetting(newVal) {
      // if (!newVal) return;

      // this.memberInfoArea.currentSituationCondition = newVal;
      if (newVal == this.settingCode) {
        //詳細指定中
        //処理なし
      } else {
        //画面項目
        this.memberInfoArea.currentSituationCondition = newVal;
      }
    },
    // **********************************************
    //元画面の連動項目コードを設定 現況連動
    // **********************************************
    returnCurrentSituationSetting() {
      var returnCode = 0;
      //現況・指定しないの場合
      if (
        this.memberInfoArea.currentSituationCondition ==
        PRESENT_SITUATION_LIST[0].code
      ) {
        returnCode = PRESENT_SITUATION_LIST[0].code;
      } else {
        const currentSituationFlg = this.currentSituationList.filter(
          (item) => item.value == this.memberInfoArea.currentSituationCondition
        );
        if (currentSituationFlg.length <= 0) {
          returnCode = this.settingCode;
        } else {
          returnCode = currentSituationFlg[0].value;
        }
      }
      this.memberInfoArea.returnCodeCurrentSituation = returnCode;
    },

    //#endregion

    //#region watch関数

    // **********************************************
    // 画面項目制御フラグ設定
    // **********************************************
    filterViewsDisplayFlag(newVal) {
      this.filterViewsDisplay = FILTER_VIEWS_DISPLAY_FLAG_LIST.filter(
        (el) => el.pageId == this.pageId
      )[0];
      const ProcessingDivisionFlg =
        this.filterViewsDisplay?.DisplayFlagsProcessing?.ProcessingDivisionList;
      if (
        this.accessInfoArea.ProcessingDivision?.length >
        ProcessingDivisionFlg?.length
      ) {
        this.accessInfoArea.ProcessingDivision = ProcessingDivisionFlg;
      }

      switch (newVal) {
        //集配信の場合
        case Common.getSettingsValue("ApplicationDataCollection"):
          if (
            !this.yearendTaxAdjustment &&
            this.filterViewsDisplay.DisplayFlagsBusiness
          ) {
            this.filterViewsDisplay.DisplayFlagsBusiness.BusinessFunctionRelease = false; //事業者に対する機能利用権限
          }
          break;
        case Common.getSettingsValue("ApplicationFileManage"):
          //事業者情報
          if (this.filterViewsDisplay.ClassificationControlBusinessInfo) {
            this.filterViewsDisplay.DisplayFlagsBusiness.MainCharge = true; //主担当者名
            // this.filterViewsDisplay.DisplayFlagsBusiness.BusinessAccount = true; //事業者アカウント
            // this.filterViewsDisplay.DisplayFlagsBusiness.BusinessFunctionRelease = true; //事業者に対する機能利用権限
            // this.filterViewsDisplay.DisplayFlagsBusiness.BusinessNotificationDestination = true; //事業者からの通知先
          }
          //申告書等情報
          if (this.filterViewsDisplay.ClassificationControlDeclarationInfo) {
            this.filterViewsDisplay.DisplayFlagsDeclaration.CollectedDocumentinfo = true; //書類収集状況
          }
          break;
        default:
          this.filterViewsDisplay = {};
      }
    },
    keyWordFilterInitWatch(newVal) {
      if (this.searchKey !== newVal) {
        this.searchKey = newVal;
      }
    },
    // **********************************************
    //事業者
    // **********************************************
    bopDataFilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0 && newVal.result) {
        //事業者コード、条件
        this.businessInfoArea.CompanyCodeCondition =
          newVal.businessOperatorCodeOption;
        //事業者コード、テキスト
        this.businessInfoArea.CompanyCode = newVal.businessOperatorCode;

        //事業者名、条件
        this.businessInfoArea.CompanyNameCondition =
          newVal.businessOperatorNameOption;
        //事業者名、テキスト
        this.businessInfoArea.CompanyName = newVal.businessOperatorName;

        //法人個人区分、条件
        this.businessInfoArea.BusinessOperatorType =
          newVal.businessOperatorType;
        //法人個人区分、テキスト
        //this.businessInfoArea.corproationDivision = newVal.corproationDivision;

        //決算日、条件
        this.businessInfoArea.KessanDateCondition = newVal.accountClosingOption;
        //決算日、条件
        this.businessInfoArea.KessanDateFromMonth =
          newVal.accountClosingFromMonth;
        //決算日、条件
        this.businessInfoArea.KessanDateFromDay = newVal.accountClosingFromDay;
        //決算日、条件
        this.businessInfoArea.KessanDateToMonth = newVal.accountClosingToMonth;
        //決算日、条件
        this.businessInfoArea.KessanDateToDay = newVal.accountClosingToDay;

        //主担当者名、条件
        this.businessInfoArea.managerSelected = newVal.personInChargeOption;
        //主担当者名、テキスト
        this.businessInfoArea.manager = newVal.personInCharge;

        //事業者アカウント、条件
        // this.businessInfoArea.BopAccountCondition = newVal.bopAccountCondition;
        //事業者アカウント、テキスト
        //this.businessInfoArea.businessAccount = newVal.businessAccount;

        //事業者に対する機能利用権限、条件
        this.businessInfoArea.BopOpenFunctionCondition =
          newVal.functionAuthorityCondition;
        //事業者に対する機能利用権限、テキスト
        //this.businessInfoArea.businessFunctionRelease =
        //newVal.businessFunctionRelease;

        //事業者からの通知先、条件
        // this.businessInfoArea.NotificationFromBopCondition =
        //   newVal.notificationFromBopCondition;
      }
    },
    // **********************************************
    //申告書等情報
    // **********************************************
    documentFilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0 && newVal.result) {
        //申告書等、条件
        this.declarationFormInfoArea.TaxCategoryListCondition =
          newVal.taxCategoryListCondition;
        //申告書等、テキスト
        this.declarationFormInfoArea.TaxCategoryList = newVal.taxCategoryList;

        //#region 事業年度等_法人
        //事業年度等（開始）条件
        this.declarationFormInfoArea.fiscalYearStartCondition =
          newVal.businessFiscalFromOption;
        //事業年度等（開始）年号
        this.declarationFormInfoArea.fiscalYearStartFromGengo =
          newVal.businessFiscalFromReki;
        //事業年度等（開始）年
        this.declarationFormInfoArea.fiscalYearStartFromYear =
          newVal.businessFiscalFromYear;
        //事業年度等（開始）月
        this.declarationFormInfoArea.fiscalYearStartFromMonth =
          newVal.businessFiscalFromMonth;
        //事業年度等（開始）日
        this.declarationFormInfoArea.fiscalYearStartFromDay =
          newVal.businessFiscalFromDay;
        //事業年度等（開始）End年号
        this.declarationFormInfoArea.fiscalYearStartToGengo =
          newVal.fiscalYearStartToGengo;
        //事業年度等（開始）End年
        this.declarationFormInfoArea.fiscalYearStartToYear =
          newVal.fiscalYearStartToYear;
        //事業年度等（開始）End月
        this.declarationFormInfoArea.fiscalYearStartToMonth =
          newVal.fiscalYearStartToMonth;
        //事業年度等（開始）End日
        this.declarationFormInfoArea.fiscalYearStartToDay =
          newVal.fiscalYearStartToDay;

        //事業年度等（終了）条件
        this.declarationFormInfoArea.JigyoNendoToCondition =
          newVal.businessFiscalToOption;
        //事業年度等（終了）年号
        this.declarationFormInfoArea.JigyoNendoToGengo =
          newVal.businessFiscalToReki;
        //事業年度等（終了）年
        this.declarationFormInfoArea.JigyoNendoToYear =
          newVal.businessFiscalToYear;
        //事業年度等（終了）月
        this.declarationFormInfoArea.JigyoNendoToMonth =
          newVal.businessFiscalToMonth;
        //事業年度等（終了）日
        this.declarationFormInfoArea.JigyoNendoToDay =
          newVal.businessFiscalToDay;
        //事業年度等（終了）End年号
        this.declarationFormInfoArea.fiscalYearEndToGengo =
          newVal.fiscalYearEndToGengo;
        //事業年度等（終了）End年
        this.declarationFormInfoArea.fiscalYearEndToYear =
          newVal.fiscalYearEndToYear;
        //事業年度等（終了）End月
        this.declarationFormInfoArea.fiscalYearEndToMonth =
          newVal.fiscalYearEndToMonth;
        //事業年度等（終了）End日
        this.declarationFormInfoArea.fiscalYearEndToDay =
          newVal.fiscalYearEndToDay;
        //#endregion

        //#region 事業年度等_個人
        //事業年度等（開始）条件
        this.declarationFormInfoArea.fiscalYearStartConditionKojin =
          newVal.businessFiscalFromOptionKojin;
        //事業年度等（開始）年号
        this.declarationFormInfoArea.fiscalYearStartFromGengoKojin =
          newVal.businessFiscalFromRekiKojin;
        //事業年度等（開始）年
        this.declarationFormInfoArea.fiscalYearStartFromYearKojin =
          newVal.businessFiscalFromYearKojin;
        //事業年度等（開始）月
        this.declarationFormInfoArea.fiscalYearStartFromMonthKojin =
          newVal.businessFiscalFromMonthKojin;
        //事業年度等（開始）日
        this.declarationFormInfoArea.fiscalYearStartFromDayKojin =
          newVal.businessFiscalFromDayKojin;
        //事業年度等（開始）End年号
        this.declarationFormInfoArea.fiscalYearStartToGengoKojin =
          newVal.fiscalYearStartToGengoKojin;
        //事業年度等（開始）End年
        this.declarationFormInfoArea.fiscalYearStartToYearKojin =
          newVal.fiscalYearStartToYearKojin;
        //事業年度等（開始）End月
        this.declarationFormInfoArea.fiscalYearStartToMonthKojin =
          newVal.fiscalYearStartToMonthKojin;
        //事業年度等（開始）End日
        this.declarationFormInfoArea.fiscalYearStartToDayKojin =
          newVal.fiscalYearStartToDayKojin;

        //事業年度等（終了）条件
        this.declarationFormInfoArea.JigyoNendoToConditionKojin =
          newVal.businessFiscalToOptionKojin;
        //事業年度等（終了）年号
        this.declarationFormInfoArea.JigyoNendoToGengoKojin =
          newVal.businessFiscalToRekiKojin;
        //事業年度等（終了）年
        this.declarationFormInfoArea.JigyoNendoToYearKojin =
          newVal.businessFiscalToYearKojin;
        //事業年度等（終了）月
        this.declarationFormInfoArea.JigyoNendoToMonthKojin =
          newVal.businessFiscalToMonthKojin;
        //事業年度等（終了）日
        this.declarationFormInfoArea.JigyoNendoToDayKojin =
          newVal.businessFiscalToDayKojin;
        //事業年度等（終了）End年号
        this.declarationFormInfoArea.fiscalYearEndToGengoKojin =
          newVal.fiscalYearEndToGengoKojin;
        //事業年度等（終了）End年
        this.declarationFormInfoArea.fiscalYearEndToYearKojin =
          newVal.fiscalYearEndToYearKojin;
        //事業年度等（終了）End月
        this.declarationFormInfoArea.fiscalYearEndToMonthKojin =
          newVal.fiscalYearEndToMonthKojin;
        //事業年度等（終了）End日
        this.declarationFormInfoArea.fiscalYearEndToDayKojin =
          newVal.fiscalYearEndToDayKojin;
        //#endregion

        //データ区分、選択された区分リスト
        this.declarationFormInfoArea.DataKbn = newVal.dataClassificationList;

        //データ名称、条件
        this.declarationFormInfoArea.DataNameCondition = newVal.dataNameOption;
        //データ名称、テキスト
        this.declarationFormInfoArea.DataName = newVal.dataName;

        //書類収集状況、選択された書類収集状況リスト
        this.declarationFormInfoArea.Status = newVal.statusList;
      }
    },
    // **********************************************
    //アクセスログ情報
    // **********************************************
    accessLogFilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0 && newVal.result) {
        //処理日時（開始）、条件
        this.accessInfoArea.AccessDateCondition =
          newVal.accessDateTimeFromOption;
        //処理日時（開始）、年号
        this.accessInfoArea.AccessDateFromGengo = newVal.accessDateTimeFromReki;
        //処理日時（開始）、年
        this.accessInfoArea.AccessDateFromYear = newVal.accessDateTimeFromYear;
        //処理日時（開始）、月
        this.accessInfoArea.AccessDateFromMonth =
          newVal.accessDateTimeFromMonth;
        //処理日時（開始）、日
        this.accessInfoArea.AccessDateFromDay = newVal.accessDateTimeFromDay;
        //処理日時（終了）、年号
        this.accessInfoArea.AccessDateToGengo = newVal.accessDateTimeToReki;
        // 処理日時（終了）、年
        this.accessInfoArea.AccessDateToYear = newVal.accessDateTimeToYear;
        //処理日時（終了）、月
        this.accessInfoArea.AccessDateToMonth = newVal.accessDateTimeToMonth;
        //処理日時（終了）、日
        this.accessInfoArea.AccessDateToDay = newVal.accessDateTimeToDay;
        if (newVal.accessDateFromYMD) {
          this.accessInfoArea.AccessDateFromYMD = newVal.accessDateFromYMD;
        }
        if (newVal.accessDateFromYM) {
          this.accessInfoArea.AccessDateFromYM = newVal.accessDateFromYM;
        }
        if (newVal.accessDateToYMD) {
          this.accessInfoArea.AccessDateToYMD = newVal.accessDateToYMD;
        }
        // //処理種別
        // this.accessInfoArea.ProcessingType = newVal.processingTypeList;

        //処理データ、条件
        this.accessInfoArea.processingDataCondition = newVal.objectNameOption;
        //処理データ、テキスト
        this.accessInfoArea.processingData = newVal.objectName;

        //処理対象
        this.accessInfoArea.treatmentTarget = newVal.objectType;

        //処理区分
        this.accessInfoArea.ProcessingDivision = newVal.processingDivisionList;
        //事業者情報、条件
        this.accessInfoArea.bopUserCondition = newVal.bopUserOption;
        //事業者情報、テキスト
        this.accessInfoArea.bopUser = newVal.bopUser;
        //ログインID/事業者ID、条件
        this.accessInfoArea.LoginIDCondition = newVal.userIDOption;
        //ログインID/事業者ID、テキスト
        this.accessInfoArea.LoginID = newVal.userID;

        //利用者名、条件
        this.accessInfoArea.UserNameCondition = newVal.userNameOption;
        //利用者名、テキスト
        this.accessInfoArea.UserName = newVal.userName;

        //IPアドレス、条件
        this.accessInfoArea.IPAddressCondition = newVal.ipAddressOption;
        //IPアドレス、テキスト
        this.accessInfoArea.IPAddress = newVal.ipAddress;
      }
    },
    // **********************************************
    //社員情報
    // **********************************************
    employeeInfoFilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0 && newVal.result) {
        //所属コード、条件
        this.memberInfoArea.belongingCodeCondition =
          newVal.belongingCodeCondition;
        //所属コード、テキスト
        this.memberInfoArea.belongingCode = newVal.belongingCode;

        //所属、条件
        this.memberInfoArea.belongingCondition = newVal.belongingCondition;
        //所属、テキスト
        this.memberInfoArea.belonging = newVal.belonging;

        //社員コード、条件
        this.memberInfoArea.memberCodeCondition = newVal.memberCodeCondition;
        //社員コード、テキスト
        this.memberInfoArea.memberCode = newVal.memberCode;

        //社員名、条件
        this.memberInfoArea.memberNameCondition = newVal.memberNameCondition;
        //社員名、テキスト
        this.memberInfoArea.memberName = newVal.memberName;

        //現況、条件
        this.memberInfoArea.currentSituationCondition =
          newVal.currentSituationCondition;
        //現況、テキスト
        // this.memberInfoArea.currentSituation = newVal.currentSituation;

        //メールアドレス、条件
        this.memberInfoArea.emailAddressCondition =
          newVal.emailAddressCondition;
        //メールアドレス、テキスト
        this.memberInfoArea.emailAddress = newVal.emailAddress;

        //アカウント状態、条件
        this.memberInfoArea.accountStatusCondition =
          newVal.accountStatusCondition;
        //アカウント状態、テキスト
        this.memberInfoArea.accountStatus = newVal.accountStatus;
      }
    },
    // **********************************************
    //STDSDC02C01共通フィルタ
    // **********************************************
    STDSDC02C01FilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        //決算日連動
        this.kessanDateSetting(newVal.accountClosingMonth);

        //主担当者連動
        this.personInChargeList = newVal.personInChargeList;
        this.managerSetting(newVal.personInCharge);
      }
    },
    // **********************************************
    //STDSDC02C10共通フィルタ
    // **********************************************
    STDSDC02C10FilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        //所属連動
        this.belongingList = newVal.belongingList;
        this.belongingSetting(newVal.belongs);

        //現況連動
        this.currentSituationList = newVal.currentSituationList;
        this.currentSituationSetting(newVal.currentSituationCondition);
      }
    },
    // **********************************************
    //STDSDC03C01共通フィルタ
    // **********************************************
    STDSDC03C01FilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        //事業年度連動
        this.DeclarationyearSetting(newVal.businessYear);

        //データ区分連動
        //this.DataKbnSetting(newVal.dataClassification);

        //主担当者連動
        this.personInChargeList = newVal.personInChargeList;
        this.managerSetting(newVal.personInCharge);
      }
    },
    // **********************************************
    //STDSDC03C03共通フィルタ
    // **********************************************
    STDSDC03C03FilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        //決算日連動
        this.kessanDateSetting(newVal.accountClosingMonth);

        //主担当者連動
        this.personInChargeList = newVal.personInChargeList;
        this.managerSetting(newVal.personInCharge);
      }
    },
    // **********************************************
    //STDSDC04C01共通フィルタ
    // **********************************************
    STDSDC04C01FilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        //主担当者連動
        this.personInChargeList = newVal.personInChargeList;
        this.managerSetting(newVal.personInCharge);
        //事業年度連動
        this.DeclarationyearSetting(newVal.businessYear);
        //データ区分連動
        //this.DataKbnSetting(newVal.dataClassification);
        //収集状況
        this.documentsDropdownList = newVal.documentsDropdownList;
        this.StatusSetting(newVal.documentStatus);
      }
    },
    // **********************************************
    //STDSDC05C08共通フィルタ
    // **********************************************
    STDSDC05C08FilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        //操作日時
        this.dateTimeList = newVal.dateTimeList;
        this.OperationDateSetting(newVal.displayTarget);
      }
    },
    // **********************************************
    //STDSDC05C09共通フィルタ
    // **********************************************
    STDSDC05C09FilterInitWatch(newVal, oldVal) {
      if (
        newVal &&
        Object.keys(newVal).length > 0 &&
        !_.isEqual(newVal, oldVal)
      ) {
        //表示対象/処理日時
        this.dateTimeList = newVal.dateTimeList;
        this.AccessDateSetting(newVal.displayTarget);
      }
    },
    //#endregion

    //#region 画面項目チェック

    // **********************************************
    //画面項目設定_事業者情報エリアチェック
    // **********************************************
    businessInfoAreaCheck() {
      // 事業者コードが「指定しない」以外の場合フィルタする
      if (
        this.businessInfoArea.CompanyCodeCondition !=
        DETAIL_BUSINESS_CODE_LIST[0].code
      ) {
        // 事業者コード 日付以外(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.businessInfoArea.CompanyCodeCondition,
          this.businessInfoArea.CompanyCode,
          "事業者コード"
        );

        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.errors.push(msg);
          this.businessInfoArea.isErrorBopCodeMsg.push(msg);
          this.businessInfoArea.isErrorBopCode = true;
          //return;
        }
      }
      // 事業者名が「指定しない」以外の場合フィルタする
      if (
        this.businessInfoArea.CompanyNameCondition !=
        DETAIL_BUSINESS_CODE_LIST[0].code
      ) {
        // 事業者名 日付以外(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.businessInfoArea.CompanyNameCondition,
          this.businessInfoArea.CompanyName,
          "事業者名"
        );

        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.errors.push(msg);
          this.businessInfoArea.isErrorBopName = true;
          this.businessInfoArea.isErrorBopNameMsg.push(msg);
          //return;
        }
      }

      // 決算日が「指定しない」以外の場合フィルタする
      if (
        this.businessInfoArea.KessanDateCondition !=
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        if (
          this.businessInfoArea.KessanDateCondition ==
          DETAIL_DESIGNATED_DATE_LIST[2].code
        ) {
          var msg = this.checkFilterMStart(
            this.businessInfoArea.KessanDateCondition,
            this.businessInfoArea.KessanDateFromMonth,
            "決算日"
          );
          if (msg != "") {
            this.errors.push(msg);
            this.businessInfoArea.isErrorKessanDateFromMonth = true;
            this.businessInfoArea.isErrorKessanDateMsg.push(msg);
          }
        } else {
          // 決算日のチェック
          var msg = this.checkFilterDateMD(
            this.businessInfoArea.KessanDateCondition,
            this.businessInfoArea.KessanDateFromMonth,
            this.businessInfoArea.KessanDateFromDay,
            this.businessInfoArea.KessanDateToMonth,
            this.businessInfoArea.KessanDateToDay,
            "決算日"
          );
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "" && msg != "YearendStraddle") {
            this.errors.push(msg);
            this.businessInfoArea.isErrorKessanDateMsg.push(msg);
            if (
              this.detailDuringDateSelected ==
                DETAIL_DESIGNATED_DATE_LIST[1].code ||
              this.detailDuringDateSelected ==
                DETAIL_DESIGNATED_DATE_LIST[2].code
            ) {
              this.businessInfoArea.isErrorKessanDateFromMonth = true;
              this.businessInfoArea.isErrorKessanDateFromDay = true;
            } else {
              this.businessInfoArea.isErrorKessanDateFromMonth = true;
              this.businessInfoArea.isErrorKessanDateFromDay = true;
              this.businessInfoArea.isErrorKessanDateToMonth = true;
              this.businessInfoArea.isErrorKessanDateToDay = true;
            }
            //return;
          }
        }
      }
      // 主担当者名が「指定しない」以外の場合フィルタする
      if (
        this.businessInfoArea.managerSelected !=
          DETAIL_BUSINESS_CODE_LIST[0].code &&
        this.businessInfoArea.managerSelected !=
          DETAIL_BUSINESS_CODE_LIST[3].code &&
        this.filterViewsDisplay.DisplayFlagsBusiness.MainCharge
      ) {
        // 主担当者名 日付以外(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.businessInfoArea.managerSelected,
          this.businessInfoArea.manager,
          "主担当者"
        );

        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.errors.push(msg);
          this.businessInfoArea.isErrorManagerMsg.push(msg);
          this.businessInfoArea.isErrorManager = true;
          //return;
        }
      }
    },
    // **********************************************
    //画面項目設定_申告書等情報エリアチェック
    // **********************************************
    declarationFormInfoAreaCheck() {
      // 申告書等が「指定しない」以外の場合フィルタする
      if (
        this.declarationFormInfoArea.TaxCategoryListCondition !=
        DETAIL_BUSINESS_CODE_LIST[0].code
      ) {
        // 申告書等 日付以外(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.declarationFormInfoArea.TaxCategoryListCondition,
          this.declarationFormInfoArea.TaxCategoryList,
          "申告書等"
        );

        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.errors.push(msg);
          this.declarationFormInfoArea.isErrorTaxCategoryListMsg.push(msg);
          this.declarationFormInfoArea.isErrorTaxCategoryList = true;
          //return;
        }
      }
      //#region 事業年度等_法人
      // 事業年度等（開始）
      // 「指定しない」以外の場合
      if (
        this.declarationFormInfoArea.fiscalYearStartCondition !=
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        if (
          this.declarationFormInfoArea.fiscalYearStartCondition ==
          DETAIL_DESIGNATED_DATE_LIST[2].code
        ) {
          // フィルター入力チェック
          var msg = "";

          msg = this.checkFilterDateYM(
            this.declarationFormInfoArea.fiscalYearStartCondition,
            this.declarationFormInfoArea.fiscalYearStartFromGengo,
            this.declarationFormInfoArea.fiscalYearStartFromYear,
            this.declarationFormInfoArea.fiscalYearStartFromMonth,
            "事業年度等（開始）"
          );
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            this.declarationFormInfoArea.isErrorFiscalYearStartFromYear = true;
            this.declarationFormInfoArea.isErrorFiscalYearStartFromMonth = true;
            this.errors.push(msg);
            this.declarationFormInfoArea.isErrorFiscalYearStartMsg.push(msg);
          }
        } else {
          // フィルター入力チェック
          var msg = "";
          if (
            this.declarationFormInfoArea.fiscalYearStartCondition ==
            DETAIL_DESIGNATED_DATE_LIST[1].code
          ) {
            msg = this.checkFilterDate(
              this.declarationFormInfoArea.fiscalYearStartCondition,
              this.declarationFormInfoArea.fiscalYearStartFromGengo,
              this.declarationFormInfoArea.fiscalYearStartFromYear,
              this.declarationFormInfoArea.fiscalYearStartFromMonth,
              this.declarationFormInfoArea.fiscalYearStartFromDay,
              "事業年度等（開始）"
            );
          }
          if (
            this.declarationFormInfoArea.fiscalYearStartCondition ==
            DETAIL_DESIGNATED_DATE_LIST[3].code
          ) {
            msg = this.checkFilterDateYMD(
              this.declarationFormInfoArea.fiscalYearStartCondition,
              this.declarationFormInfoArea.fiscalYearStartFromGengo,
              this.declarationFormInfoArea.fiscalYearStartFromYear,
              this.declarationFormInfoArea.fiscalYearStartFromMonth,
              this.declarationFormInfoArea.fiscalYearStartFromDay,
              this.declarationFormInfoArea.fiscalYearStartToGengo,
              this.declarationFormInfoArea.fiscalYearStartToYear,
              this.declarationFormInfoArea.fiscalYearStartToMonth,
              this.declarationFormInfoArea.fiscalYearStartToDay,
              "事業年度等（開始）",
              "指定期間"
            );
          }
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            if (
              this.declarationFormInfoArea.fiscalYearStartCondition ==
                DETAIL_DESIGNATED_DATE_LIST[1].code ||
              this.declarationFormInfoArea.fiscalYearStartCondition ==
                DETAIL_DESIGNATED_DATE_LIST[2].code
            ) {
              this.declarationFormInfoArea.isErrorFiscalYearStartFromYear = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartFromMonth = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartFromDay = true;
            }
            if (
              this.declarationFormInfoArea.fiscalYearStartCondition ==
              DETAIL_DESIGNATED_DATE_LIST[3].code
            ) {
              this.declarationFormInfoArea.isErrorFiscalYearStartFromYear = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartFromMonth = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartFromDay = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartToYear = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartToMonth = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartToDay = true;
            }
            this.errors.push(msg);
            this.declarationFormInfoArea.isErrorFiscalYearStartMsg.push(msg);
            //return;
          }
        }
      }

      // 事業年度等（終了）
      // 「指定しない」以外の場合
      if (
        this.declarationFormInfoArea.JigyoNendoToCondition !=
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        if (
          this.declarationFormInfoArea.JigyoNendoToCondition ==
          DETAIL_DESIGNATED_DATE_LIST[2].code
        ) {
          // フィルター入力チェック
          var msg = "";

          msg = this.checkFilterDateYM(
            this.declarationFormInfoArea.JigyoNendoToCondition,
            this.declarationFormInfoArea.JigyoNendoToGengo,
            this.declarationFormInfoArea.JigyoNendoToYear,
            this.declarationFormInfoArea.JigyoNendoToMonth,
            "事業年度等（終了）"
          );
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            this.declarationFormInfoArea.isErrorJigyoNendoToYear = true;
            this.declarationFormInfoArea.isErrorJigyoNendoToMonth = true;
            this.errors.push(msg);
            this.declarationFormInfoArea.isErrorFiscalYearEndMsg.push(msg);
          }
        } else {
          // フィルター入力チェック
          var msg = "";
          if (
            this.declarationFormInfoArea.JigyoNendoToCondition ==
              DETAIL_DESIGNATED_DATE_LIST[1].code ||
            this.declarationFormInfoArea.JigyoNendoToCondition ==
              DETAIL_DESIGNATED_DATE_LIST[2].code
          ) {
            msg = this.checkFilterDate(
              this.declarationFormInfoArea.JigyoNendoToCondition,
              this.declarationFormInfoArea.JigyoNendoToGengo,
              this.declarationFormInfoArea.JigyoNendoToYear,
              this.declarationFormInfoArea.JigyoNendoToMonth,
              this.declarationFormInfoArea.JigyoNendoToDay,
              "事業年度等（終了）"
            );
          }
          if (
            this.declarationFormInfoArea.JigyoNendoToCondition ==
            DETAIL_DESIGNATED_DATE_LIST[3].code
          ) {
            msg = this.checkFilterDateYMD(
              this.declarationFormInfoArea.JigyoNendoToCondition,
              this.declarationFormInfoArea.JigyoNendoToGengo,
              this.declarationFormInfoArea.JigyoNendoToYear,
              this.declarationFormInfoArea.JigyoNendoToMonth,
              this.declarationFormInfoArea.JigyoNendoToDay,
              this.declarationFormInfoArea.fiscalYearEndToGengo,
              this.declarationFormInfoArea.fiscalYearEndToYear,
              this.declarationFormInfoArea.fiscalYearEndToMonth,
              this.declarationFormInfoArea.fiscalYearEndToDay,
              "事業年度等（終了）",
              "指定期間"
            );
          }
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            if (
              this.declarationFormInfoArea.JigyoNendoToCondition ==
                DETAIL_DESIGNATED_DATE_LIST[1].code ||
              this.declarationFormInfoArea.JigyoNendoToCondition ==
                DETAIL_DESIGNATED_DATE_LIST[2].code
            ) {
              this.declarationFormInfoArea.isErrorJigyoNendoToYear = true;
              this.declarationFormInfoArea.isErrorJigyoNendoToMonth = true;
              this.declarationFormInfoArea.isErrorJigyoNendoToDay = true;
            }
            if (
              this.declarationFormInfoArea.JigyoNendoToCondition ==
              DETAIL_DESIGNATED_DATE_LIST[3].code
            ) {
              this.declarationFormInfoArea.isErrorJigyoNendoToYear = true;
              this.declarationFormInfoArea.isErrorJigyoNendoToMonth = true;
              this.declarationFormInfoArea.isErrorJigyoNendoToDay = true;
              this.declarationFormInfoArea.isErrorFiscalYearEndToYear = true;
              this.declarationFormInfoArea.isErrorFiscalYearEndToMonth = true;
              this.declarationFormInfoArea.isErrorFiscalYearEndToDay = true;
            }
            this.errors.push(msg);
            this.declarationFormInfoArea.isErrorFiscalYearEndMsg.push(msg);
            //return;
          }
        }
      }
      //#endregion

      //#region 事業年度等_個人
      // 事業年度等（開始）
      // 「指定しない」以外の場合
      if (
        this.declarationFormInfoArea.fiscalYearStartConditionKojin !=
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        if (
          this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
          DETAIL_DESIGNATED_DATE_LIST[2].code
        ) {
          // フィルター入力チェック
          var msg = "";

          msg = this.checkFilterDateYM(
            this.declarationFormInfoArea.fiscalYearStartConditionKojin,
            this.declarationFormInfoArea.fiscalYearStartFromGengoKojin,
            this.declarationFormInfoArea.fiscalYearStartFromYearKojin,
            this.declarationFormInfoArea.fiscalYearStartFromMonthKojin,
            "事業年度等（開始）"
          );

          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            this.declarationFormInfoArea.isErrorFiscalYearStartFromYearKojin = true;
            this.declarationFormInfoArea.isErrorFiscalYearStartFromMonthKojin = true;
            this.errors.push(msg);
            this.declarationFormInfoArea.isErrorFiscalYearStartMsgKojin.push(
              msg
            );
          }
        } else {
          // フィルター入力チェック
          var msg = "";
          if (
            this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
              DETAIL_DESIGNATED_DATE_LIST[1].code ||
            this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
              DETAIL_DESIGNATED_DATE_LIST[2].code
          ) {
            msg = this.checkFilterDate(
              this.declarationFormInfoArea.fiscalYearStartConditionKojin,
              this.declarationFormInfoArea.fiscalYearStartFromGengoKojin,
              this.declarationFormInfoArea.fiscalYearStartFromYearKojin,
              this.declarationFormInfoArea.fiscalYearStartFromMonthKojin,
              this.declarationFormInfoArea.fiscalYearStartFromDayKojin,
              "事業年度等（開始）"
            );
          }
          if (
            this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
            DETAIL_DESIGNATED_DATE_LIST[3].code
          ) {
            msg = this.checkFilterDateYMD(
              this.declarationFormInfoArea.fiscalYearStartConditionKojin,
              this.declarationFormInfoArea.fiscalYearStartFromGengoKojin,
              this.declarationFormInfoArea.fiscalYearStartFromYearKojin,
              this.declarationFormInfoArea.fiscalYearStartFromMonthKojin,
              this.declarationFormInfoArea.fiscalYearStartFromDayKojin,
              this.declarationFormInfoArea.fiscalYearStartToGengoKojin,
              this.declarationFormInfoArea.fiscalYearStartToYearKojin,
              this.declarationFormInfoArea.fiscalYearStartToMonthKojin,
              this.declarationFormInfoArea.fiscalYearStartToDayKojin,
              "事業年度等（開始）",
              "指定期間"
            );
          }
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            if (
              this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
                DETAIL_DESIGNATED_DATE_LIST[1].code ||
              this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
                DETAIL_DESIGNATED_DATE_LIST[2].code
            ) {
              this.declarationFormInfoArea.isErrorFiscalYearStartFromYearKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartFromMonthKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartFromDayKojin = true;
            }
            if (
              this.declarationFormInfoArea.fiscalYearStartConditionKojin ==
              DETAIL_DESIGNATED_DATE_LIST[3].code
            ) {
              this.declarationFormInfoArea.isErrorFiscalYearStartFromYearKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartFromMonthKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartFromDayKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartToYearKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartToMonthKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearStartToDayKojin = true;
            }
            this.errors.push(msg);
            this.declarationFormInfoArea.isErrorFiscalYearStartMsgKojin.push(
              msg
            );
            //return;
          }
        }
      }

      // 事業年度等（終了）
      // 「指定しない」以外の場合
      if (
        this.declarationFormInfoArea.JigyoNendoToConditionKojin !=
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        if (
          this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
          DETAIL_DESIGNATED_DATE_LIST[2].code
        ) {
          // フィルター入力チェック
          var msg = "";

          msg = this.checkFilterDateYM(
            this.declarationFormInfoArea.JigyoNendoToConditionKojin,
            this.declarationFormInfoArea.JigyoNendoToGengoKojin,
            this.declarationFormInfoArea.JigyoNendoToYearKojin,
            this.declarationFormInfoArea.JigyoNendoToMonthKojin,
            "事業年度等（終了）"
          );

          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            this.declarationFormInfoArea.isErrorJigyoNendoToYearKojin = true;
            this.declarationFormInfoArea.isErrorJigyoNendoToMonthKojin = true;
            this.errors.push(msg);
            this.declarationFormInfoArea.isErrorFiscalYearEndMsgKojin.push(msg);
          }
        } else {
          // フィルター入力チェック
          var msg = "";
          if (
            this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
              DETAIL_DESIGNATED_DATE_LIST[1].code ||
            this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
              DETAIL_DESIGNATED_DATE_LIST[2].code
          ) {
            msg = this.checkFilterDate(
              this.declarationFormInfoArea.JigyoNendoToConditionKojin,
              this.declarationFormInfoArea.JigyoNendoToGengoKojin,
              this.declarationFormInfoArea.JigyoNendoToYearKojin,
              this.declarationFormInfoArea.JigyoNendoToMonthKojin,
              this.declarationFormInfoArea.JigyoNendoToDayKojin,
              "事業年度等（終了）"
            );
          }
          if (
            this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
            DETAIL_DESIGNATED_DATE_LIST[3].code
          ) {
            msg = this.checkFilterDateYMD(
              this.declarationFormInfoArea.JigyoNendoToConditionKojin,
              this.declarationFormInfoArea.JigyoNendoToGengoKojin,
              this.declarationFormInfoArea.JigyoNendoToYearKojin,
              this.declarationFormInfoArea.JigyoNendoToMonthKojin,
              this.declarationFormInfoArea.JigyoNendoToDayKojin,
              this.declarationFormInfoArea.fiscalYearEndToGengoKojin,
              this.declarationFormInfoArea.fiscalYearEndToYearKojin,
              this.declarationFormInfoArea.fiscalYearEndToMonthKojin,
              this.declarationFormInfoArea.fiscalYearEndToDayKojin,
              "事業年度等（終了）",
              "指定期間"
            );
          }
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            if (
              this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
                DETAIL_DESIGNATED_DATE_LIST[1].code ||
              this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
                DETAIL_DESIGNATED_DATE_LIST[2].code
            ) {
              this.declarationFormInfoArea.isErrorJigyoNendoToYearKojin = true;
              this.declarationFormInfoArea.isErrorJigyoNendoToMonthKojin = true;
              this.declarationFormInfoArea.isErrorJigyoNendoToDayKojin = true;
            }
            if (
              this.declarationFormInfoArea.JigyoNendoToConditionKojin ==
              DETAIL_DESIGNATED_DATE_LIST[3].code
            ) {
              this.declarationFormInfoArea.isErrorJigyoNendoToYearKojin = true;
              this.declarationFormInfoArea.isErrorJigyoNendoToMonthKojin = true;
              this.declarationFormInfoArea.isErrorJigyoNendoToDayKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearEndToYearKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearEndToMonthKojin = true;
              this.declarationFormInfoArea.isErrorFiscalYearEndToDayKojin = true;
            }
            this.errors.push(msg);
            this.declarationFormInfoArea.isErrorFiscalYearEndMsgKojin.push(msg);
            //return;
          }
        }
      }
      //#endregion

      // データ名称
      if (
        this.declarationFormInfoArea.DataNameCondition !=
        DETAIL_BUSINESS_CODE_LIST[0].code
      ) {
        // データ名称 日付以外(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.declarationFormInfoArea.DataNameCondition,
          this.declarationFormInfoArea.DataName,
          "データ名称"
        );

        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.errors.push(msg);
          this.declarationFormInfoArea.isErrorDataNameMsg.push(msg);
          this.declarationFormInfoArea.isErrorDataName = true;
          //return;
        }
      }
    },
    // **********************************************
    //画面項目設定_アクセスログ情報エリアチェック
    // **********************************************
    accessInfoAreaCheck() {
      // 操作日時
      // 存在しない日時チェック
      let accessDateName =
        this.filterViewsDisplay?.DisplayFlagsProcessing?.dateNameText;
      let isInvalid = {};
      //指定日の場合
      if (
        this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[1].code
      ) {
        isInvalid = this.checkInvalidDateByTypeOfDate(
          this.$refs.accessDateFrom,
          accessDateName
        );
        // 入力チェック異常の場合、エラーメッセージ表示
        if (isInvalid.isError) {
          this.accessInfoArea.isErrorAccessDateFromYear = true;
          this.accessInfoArea.isErrorAccessDateFromMonth = true;
          this.accessInfoArea.isErrorAccessDateFromDay = true;
          this.errors.push(isInvalid.msg);
          this.accessInfoArea.isErrorAccessDateMsg.push(isInvalid.msg);
          //return;
        }
      }
      //指定期間の場合
      if (
        this.accessInfoArea.AccessDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
      ) {
        isInvalid = this.checkInvalidDate(
          this.$refs.accessDateFrom,
          this.$refs.accessDateTo,
          accessDateName
        );
        // 入力チェック異常の場合、エラーメッセージ表示
        if (isInvalid.isError) {
          this.accessInfoArea.isErrorAccessDateFromYear = true;
          this.accessInfoArea.isErrorAccessDateFromMonth = true;
          this.accessInfoArea.isErrorAccessDateFromDay = true;
          this.accessInfoArea.isErrorAccessDateToYear = true;
          this.accessInfoArea.isErrorAccessDateToMonth = true;
          this.accessInfoArea.isErrorAccessDateToDay = true;
          this.errors.push(isInvalid.msg);
          this.accessInfoArea.isErrorAccessDateMsg.push(isInvalid.msg);
          //return;
        }
      }
      // 「指定しない」以外の場合
      if (
        this.accessInfoArea.AccessDateCondition !=
          DETAIL_DESIGNATED_DATE_LIST[0].code &&
        !isInvalid.isError
      ) {
        if (
          this.accessInfoArea.AccessDateCondition ==
          DETAIL_DESIGNATED_DATE_LIST[2].code
        ) {
          // フィルター入力チェック
          var msg = "";

          msg = this.checkFilterDateYM(
            this.accessInfoArea.AccessDateCondition,
            this.accessInfoArea.AccessDateFromGengo,
            this.accessInfoArea.AccessDateFromYear,
            this.accessInfoArea.AccessDateFromMonth,
            accessDateName
          );
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "") {
            this.accessInfoArea.isErrorAccessDateFromYear = true;
            this.accessInfoArea.isErrorAccessDateFromMonth = true;
            this.errors.push(msg);
            this.accessInfoArea.isErrorAccessDateMsg.push(msg);
            //return;
          }
        } else {
          // フィルター入力チェック
          var msg = "";
          if (
            this.accessInfoArea.AccessDateCondition ==
            DETAIL_DESIGNATED_DATE_LIST[1].code
          ) {
            msg = this.checkFilterDate(
              this.accessInfoArea.AccessDateCondition,
              this.accessInfoArea.AccessDateFromGengo,
              this.accessInfoArea.AccessDateFromYear,
              this.accessInfoArea.AccessDateFromMonth,
              this.accessInfoArea.AccessDateFromDay,
              accessDateName
            );
            // 入力チェック異常の場合、エラーメッセージ表示
            if (msg != "") {
              this.accessInfoArea.isErrorAccessDateFromYear = true;
              this.accessInfoArea.isErrorAccessDateFromMonth = true;
              this.accessInfoArea.isErrorAccessDateFromDay = true;
              this.errors.push(msg);
              this.accessInfoArea.isErrorAccessDateMsg.push(msg);
              //return;
            }
          }
          if (
            this.accessInfoArea.AccessDateCondition ==
            DETAIL_DESIGNATED_DATE_LIST[3].code
          ) {
            msg = this.checkFilterDateYMD(
              this.accessInfoArea.AccessDateCondition,
              this.accessInfoArea.AccessDateFromGengo,
              this.accessInfoArea.AccessDateFromYear,
              this.accessInfoArea.AccessDateFromMonth,
              this.accessInfoArea.AccessDateFromDay,
              this.accessInfoArea.AccessDateToGengo,
              this.accessInfoArea.AccessDateToYear,
              this.accessInfoArea.AccessDateToMonth,
              this.accessInfoArea.AccessDateToDay,
              accessDateName,
              "指定期間"
            );
            // 入力チェック異常の場合、エラーメッセージ表示
            if (msg != "") {
              this.accessInfoArea.isErrorAccessDateFromYear = true;
              this.accessInfoArea.isErrorAccessDateFromMonth = true;
              this.accessInfoArea.isErrorAccessDateFromDay = true;
              this.accessInfoArea.isErrorAccessDateToYear = true;
              this.accessInfoArea.isErrorAccessDateToMonth = true;
              this.accessInfoArea.isErrorAccessDateToDay = true;
              this.errors.push(msg);
              this.accessInfoArea.isErrorAccessDateMsg.push(msg);
              //return;
            }
          }

          if (
            this.accessInfoArea.AccessDateCondition ==
              DETAIL_DESIGNATED_DATE_LIST[3].code &&
            msg == ""
          ) {
            msg = this.checkFilterDateYMDOneMonth(
              this.accessInfoArea.AccessDateCondition,
              this.accessInfoArea.AccessDateFromGengo,
              this.accessInfoArea.AccessDateFromYear,
              this.accessInfoArea.AccessDateFromMonth,
              this.accessInfoArea.AccessDateFromDay,
              this.accessInfoArea.AccessDateToGengo,
              this.accessInfoArea.AccessDateToYear,
              this.accessInfoArea.AccessDateToMonth,
              this.accessInfoArea.AccessDateToDay,
              accessDateName,
              "指定期間"
            );
            // 入力チェック異常の場合、エラーメッセージ表示
            if (msg != "") {
              if (
                this.accessInfoArea.AccessDateCondition ==
                DETAIL_DESIGNATED_DATE_LIST[3].code
              ) {
                this.accessInfoArea.isErrorAccessDateFromYear = true;
                this.accessInfoArea.isErrorAccessDateFromMonth = true;
                this.accessInfoArea.isErrorAccessDateFromDay = true;
                this.accessInfoArea.isErrorAccessDateToYear = true;
                this.accessInfoArea.isErrorAccessDateToMonth = true;
                this.accessInfoArea.isErrorAccessDateToDay = true;
                this.errors.push(msg);
                this.accessInfoArea.isErrorAccessDateMsg.push(msg);
              }
              //return;
            }
          }
        }
      }
      // 処理データ
      var msg = Validation.checkFilterWithOutSpace(
        this.accessInfoArea.processingDataCondition,
        this.accessInfoArea.processingData,
        "処理データ"
      );

      // 入力チェック異常の場合、エラーメッセージ表示
      if (msg != "") {
        this.accessInfoArea.isErrorProcessingData = true;
        this.errors.push(msg);
        this.accessInfoArea.isErrorProcessingDataMsg.push(msg);
        //return;
      }

      // ログインID/事業者ID
      var msg = Validation.checkFilterWithOutSpace(
        this.accessInfoArea.LoginIDCondition,
        this.accessInfoArea.LoginID,
        "ログインID"
      );
      // 入力チェック異常の場合、エラーメッセージ表示
      if (msg != "") {
        this.accessInfoArea.isErrorLoginInID = true;
        this.errors.push(msg);
        this.accessInfoArea.isErrorLoginInIDMsg.push(msg);
        //return;
      }

      // 事業者情報
      var msg = Validation.checkFilterWithOutSpace(
        this.accessInfoArea.bopUserCondition,
        this.accessInfoArea.bopUser,
        "事業者情報"
      );
      // 入力チェック異常の場合、エラーメッセージ表示
      if (msg != "") {
        this.accessInfoArea.isErrorBopUser = true;
        this.errors.push(msg);
        this.accessInfoArea.isErrorBopUserMsg.push(msg);
        //return;
      }

      // 利用者名
      var msg = Validation.checkFilterWithOutSpace(
        this.accessInfoArea.UserNameCondition,
        this.accessInfoArea.UserName,
        "利用者名"
      );
      // 入力チェック異常の場合、エラーメッセージ表示
      if (msg != "") {
        this.accessInfoArea.isErrorUserName = true;
        this.errors.push(msg);
        this.accessInfoArea.isErrorUserNameMsg.push(msg);
        //return;
      }

      // IPアドレス
      var msg = Validation.checkFilterWithOutSpace(
        this.accessInfoArea.IPAddressCondition,
        this.accessInfoArea.IPAddress,
        "IPアドレス"
      );
      // 入力チェック異常の場合、エラーメッセージ表示
      if (msg != "") {
        this.accessInfoArea.isErrorIPAddress = true;
        this.errors.push(msg);
        this.accessInfoArea.isErrorIPAddressMsg.push(msg);
        //return;
      }
    },
    // **********************************************
    //画面項目設定_社員情報エリアチェック
    // **********************************************
    memberInfoAreaCheck() {
      let isInvalid = {};
      this.memberInfoArea.motoPageHandleShowBtn = false;
      //所属コード
      isInvalid =
        this.$refs.STDSDC01C09SelectChangeFormBelongingCode.handleCheckAll();
      // 入力チェック異常の場合、エラーメッセージ表示
      if (isInvalid.isError) {
        this.errors.push(isInvalid.errorMsg);
        this.memberInfoArea.isErrorBelongingCodeMsg.push(isInvalid.errorMsg);
      } else {
        this.memberInfoArea.belongingCodeCondition = isInvalid.selectItem;
        this.memberInfoArea.belongingCode = isInvalid.inputItem;
      }

      if (isInvalid.isItemChange) {
        this.memberInfoArea.motoPageHandleShowBtn = true;
      }

      // 所属
      isInvalid =
        this.$refs.STDSDC01C09SelectChangeFormBelonging.handleCheckAll();
      // 入力チェック異常の場合、エラーメッセージ表示
      if (isInvalid.isError) {
        this.errors.push(isInvalid.errorMsg);
        this.memberInfoArea.isErrorBelongingMsg.push(isInvalid.errorMsg);
      } else {
        this.memberInfoArea.belongingCondition = isInvalid.selectItem;
        this.memberInfoArea.belonging = isInvalid.inputItem;
      }

      // if (isInvalid.isItemChange) {
      //   this.memberInfoArea.motoPageHandleShowBtn = true;
      // }

      // 社員コード
      isInvalid =
        this.$refs.STDSDC01C09SelectChangeFormMemberCode.handleCheckAll();
      // 入力チェック異常の場合、エラーメッセージ表示
      if (isInvalid.isError) {
        this.errors.push(isInvalid.errorMsg);
        this.memberInfoArea.isErrorMemberCodeMsg.push(isInvalid.errorMsg);
      } else {
        this.memberInfoArea.memberCodeCondition = isInvalid.selectItem;
        this.memberInfoArea.memberCode = isInvalid.inputItem;
      }

      if (isInvalid.isItemChange) {
        this.memberInfoArea.motoPageHandleShowBtn = true;
      }

      // 社員名
      isInvalid =
        this.$refs.STDSDC01C09SelectChangeFormMemberName.handleCheckAll();
      // 入力チェック異常の場合、エラーメッセージ表示
      if (isInvalid.isError) {
        this.errors.push(isInvalid.errorMsg);
        this.memberInfoArea.isErrorMemberNameMsg.push(isInvalid.errorMsg);
      } else {
        this.memberInfoArea.memberNameCondition = isInvalid.selectItem;
        this.memberInfoArea.memberName = isInvalid.inputItem;
      }

      if (isInvalid.isItemChange) {
        this.memberInfoArea.motoPageHandleShowBtn = true;
      }

      // 現況
      isInvalid =
        this.$refs.STDSDC01C09SelectChangeFormCurrentSituation.handleCheckAll();
      // 入力チェック異常の場合、エラーメッセージ表示
      if (isInvalid.isError) {
        this.errors.push(isInvalid.errorMsg);
        this.memberInfoArea.isErrorCurrentSituationMsg.push(isInvalid.errorMsg);
      } else {
        this.memberInfoArea.currentSituationCondition = isInvalid.selectItem;
        // this.memberInfoArea.currentSituation = isInvalid.inputItem;
      }

      // if (isInvalid.isItemChange) {
      //   this.memberInfoArea.motoPageHandleShowBtn = true;
      // }

      // メールアドレス
      isInvalid =
        this.$refs.STDSDC01C09SelectChangeFormEmailAddress.handleCheckAll();
      // 入力チェック異常の場合、エラーメッセージ表示
      if (isInvalid.isError) {
        this.errors.push(isInvalid.errorMsg);
        this.memberInfoArea.isErrorEmailAddressMsg.push(isInvalid.errorMsg);
      } else {
        this.memberInfoArea.emailAddressCondition = isInvalid.selectItem;
        this.memberInfoArea.emailAddress = isInvalid.inputItem;
      }

      if (isInvalid.isItemChange) {
        this.memberInfoArea.motoPageHandleShowBtn = true;
      }

      // アカウント状態
      isInvalid =
        this.$refs.STDSDC01C09SelectChangeFormAccountStatus.handleCheckAll();
      // 入力チェック異常の場合、エラーメッセージ表示
      if (isInvalid.isError) {
        this.errors.push(isInvalid.errorMsg);
        this.memberInfoArea.isErrorAccountStatusMsg.push(isInvalid.errorMsg);
      } else {
        this.memberInfoArea.accountStatusCondition = isInvalid.selectItem;
        this.memberInfoArea.accountStatus = isInvalid.inputItem;
      }

      if (isInvalid.isItemChange) {
        this.memberInfoArea.motoPageHandleShowBtn = true;
      }
    },

    // **********************************************
    //条件が「指定期間」は条件値(自)から(至)は１ヶ月
    // **********************************************以内
    checkFilterDateYMDOneMonth(
      selected,
      yearSSelected,
      yearS,
      monthS,
      dayS,
      yearESelected,
      yearE,
      monthE,
      dayE,
      label,
      label2
    ) {
      var rtnS = Validation.verifyDate(yearS, monthS, dayS);
      if (!rtnS) {
        return Common.createError(
          "MTCL1011",
          Common.getMessage("MTCL1011", [label])
        );
      }
      var rtnE = Validation.verifyDate(yearE, monthE, dayE);
      if (!rtnE) {
        return Common.createError(
          "MTCL1011",
          Common.getMessage("MTCL1011", [label])
        );
      }
      var dateS = new Date(
        warekiToYear(yearSSelected, yearS),
        monthS - 1,
        dayS
      );
      var dateE = new Date(
        warekiToYear(yearESelected, yearE),
        monthE - 1,
        dayE
      );
      //1月チェック
      var monthDays = moment(dateE).diff(moment(dateS), "days");
      if (monthDays > 30) {
        return Common.createError(
          "MTCL1077",
          Common.getMessage("MTCL1077", [label])
        );
      }
      // var monthDiff = moment(dateE).diff(moment(dateS), "month");
      // if (monthDiff > 0) {
      //   return Common.createError(
      //     "MTCL1077",
      //     Common.getMessage("MTCL1077", [label])
      //   );
      // }
      //条件値(自)＞(至)チェック
      if (dateS > dateE) {
        return Common.createError(
          "MTCL1046",
          Common.getMessage("MTCL1046", [label2])
        );
      }
      return "";
    },
    //#endregion

    //#region Validation.js dateFormat.js

    // **********************************************
    //{ code: 0, name: '令和' },{ code: 1, name: '平成' }
    // **********************************************
    warekiCode(wareki) {
      if (wareki.name == YEAR_LIST[0].name) {
        return YEAR_LIST[0].code;
      } else {
        return YEAR_LIST[1].code;
      }
    },

    // **********************************************
    // 存在しない日時チェック
    // **********************************************
    checkInvalidDate(dateFrom, dateTo, label) {
      let rtn = { msg: "", isError: false };
      if (dateFrom) {
        rtn = this.checkInvalidDateByTypeOfDate(dateFrom, label);
        if (rtn.isError) return rtn;
      }
      if (dateTo) {
        rtn = this.checkInvalidDateByTypeOfDate(dateTo, label);
        if (rtn.isError) return rtn;
      }
      return rtn;
    },
    checkInvalidDateByTypeOfDate(dateParam, label) {
      let rtn = { msg: "", isError: false };
      if (dateParam.validity.valid && dateParam.value == "") {
        rtn.msg = Common.createError(
          "MTCL1001",
          Common.getMessage("MTCL1001", [label])
        );
        rtn.isError = true;
      } else if (!dateParam.validity.valid && dateParam.value == "") {
        rtn.msg = Common.createError(
          "MTCL1011",
          Common.getMessage("MTCL1011", [label])
        );
        rtn.isError = true;
      }
      return rtn;
    },

    /**
     * 日付(開始・終了なし)　年項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} yearSelected 年号
     * @param {*} year 年
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterYear(selected, yearSelected, year, label) {
      // 「指定しない」以外の場合
      if (selected != 0) {
        // 非空、半角数字チェック
        // 年（ある場合のみ）
        if (yearSelected != null) {
          if (year == "") {
            return Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", [label])
            );
          }
        }

        if (yearSelected != null) {
          // 和暦年判定
          if (!warekiYearChk(yearSelected, year)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
        }
      }
      return "";
    },
    /**
     * 日付(開始・終了なし)　月日項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} month 月
     * @param {*} day 日
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterMDStart(selected, month, day, label) {
      // 「指定しない」以外の場合
      if (selected != 0) {
        // 非空、半角数字チェック
        // 月
        if (month == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }
        // 日
        if (day == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }
        // 月チェック
        if (!Validation.isMonth(month)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
        // 日
        if (day != "") {
          // 日チェック
          if (!this.verifyDate(month, day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }

          // 月日
          if (!isDate(2000, month, day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
        }
      }
      return "";
    },

    /**
     * 日付(開始・終了なし)　月日項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} month 月
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterMStart(selected, month, label) {
      // 「指定しない」以外の場合
      if (selected != 0) {
        // 非空、半角数字チェック
        // 月
        if (month == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }
        // 月チェック
        if (!Validation.isMonth(month)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
      }
      return "";
    },

    /**
     * 日付(開始・終了あり)　月日項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} monthS 月（開始）
     * @param {*} dayS 日（開始）
     * @param {*} monthE 月（終了）
     * @param {*} dayE 日（終了）
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterDateMD(selected, monthS, dayS, monthE, dayE, label) {
      var rtnS = this.checkFilterMDStart(selected, monthS, dayS, label);
      if (rtnS != "") {
        return rtnS;
      }
      if (selected == DETAIL_DESIGNATED_DATE_LIST[3].code) {
        var rtnE = this.checkFilterMDStart(selected, monthE, dayE, label);
        if (rtnE != "") {
          return rtnE;
        }
        if (Number(monthS) > Number(monthE)) {
          return "YearendStraddle";
        } else if (monthS == monthE) {
          if (dayS > dayE) {
            return "YearendStraddle";
          }
        }
      }
      return "";
    },

    /**
     * 日付正誤チェック　月日項目
     * @param {number} month 月
     * @param {number} day 日
     * @returns チェック結果 true  : チェックOK / false : チェックNG
     */
    verifyDate(month, day) {
      if (month > 12 || month < 1) return false;

      if (day > 31 || day < 1) return false;

      if ((month == 4 || month == 6 || month == 9 || month == 11) && day > 30)
        return false;

      if (month == 2) {
        if (day > 29) return false;
      }

      return true;
    },
    /**
     * 日付(開始・終了なし)　年月項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} yearSelected 年号
     * @param {*} year 年
     * @param {*} month 月
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterDateYM(selected, yearSelected, year, month, label) {
      // 「指定しない」以外の場合
      if (selected != 0) {
        // 非空、半角数字チェック
        // 年（ある場合のみ）
        if (yearSelected != null) {
          if (year == "") {
            return Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", [label])
            );
          }
        }
        // 月
        if (month == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }

        // 月チェック
        if (!Validation.isMonth(month)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
      }
      return "";
    },
    /**
     * 日付(開始・終了なし)　年月日項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} yearSelected 年号
     * @param {*} year 年
     * @param {*} month 月
     * @param {*} day 日
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterDate(selected, yearSelected, year, month, day, label) {
      // 「指定しない」以外の場合
      if (selected != 0) {
        // 非空、半角数字チェック
        // 年（ある場合のみ）
        if (yearSelected != null) {
          if (year == "") {
            return Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", [label])
            );
          }
        }
        // 月
        if (month == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }
        // 日
        if (day == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }

        if (yearSelected != null) {
          // 和暦→西暦
          const tmpYear = warekiToYear(yearSelected, year);
          // 月チェック
          if (!verifyMonth(month)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
          // 日付チェック
          if (!isDate(tmpYear, month, day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
          // 和暦（平成⇔令和）閾値チェック
          if (!warekisikiiChk(yearSelected, year, month, day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
        } else {
          // 月チェック
          if (!Validation.isMonth(month)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
          // 日チェック
          if (!Validation.isDay(day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }

          // 月日
          if (!isDate(2000, month, day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
        }

        //　年月日チェック（閏年含む）
        if (year != "" && month != "" && day != "") {
          if (Validation.checkDate(year, month, day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
        }
      }
      return "";
    },
    /**
     * 日付(開始・終了あり)　年月日項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} yearSSelected 年号（開始）
     * @param {*} yearS 年（開始）
     * @param {*} monthS 月（開始）
     * @param {*} dayS 日（開始）
     * @param {*} yearESelected 年号（終了）
     * @param {*} yearE 年（終了）
     * @param {*} monthE 月（終了）
     * @param {*} dayE 日（終了）
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterDateYMD(
      selected,
      yearSSelected,
      yearS,
      monthS,
      dayS,
      yearESelected,
      yearE,
      monthE,
      dayE,
      label,
      label2
    ) {
      var rtnS = this.checkFilterDate(
        selected,
        yearSSelected,
        yearS,
        monthS,
        dayS,
        label
      );
      if (rtnS != "") {
        return rtnS;
      }
      var rtnE = this.checkFilterDate(
        selected,
        yearESelected,
        yearE,
        monthE,
        dayE,
        label
      );
      if (rtnE != "") {
        return rtnE;
      }
      var dateS = new Date(
        warekiToYear(yearSSelected, yearS),
        monthS - 1,
        dayS
      );
      var dateE = new Date(
        warekiToYear(yearESelected, yearE),
        monthE - 1,
        dayE
      );
      if (dateS > dateE) {
        return Common.createError(
          "MTCL1046",
          Common.getMessage("MTCL1046", [label2])
        );
      }
      return "";
    },
    //#endregion

    // **********************************************
    //#region　元画面の詳細条件ボタン設定
    // **********************************************
    motoPageHandleShowBtnSetting() {
      this.filterCopy();
      let rtnFlg = false;
      const displayFlg = FILTER_VIEWS_DISPLAY_FLAG_LIST.filter(
        (el) => el.pageId == this.pageId
      )[0];
      if (displayFlg.ClassificationControlBusinessInfo) {
        rtnFlg = this.objKeyValueIsSame(
          this.businessInfoAreaCopy,
          this.businessInfoArea
        );
        if (rtnFlg) return rtnFlg;
        if (
          this.businessInfoArea.returnCodeKessanDate == this.settingCode ||
          this.businessInfoArea.returnCodeManager == this.settingCode
        ) {
          rtnFlg = true;
        }
        if (rtnFlg) return rtnFlg;
      }
      if (displayFlg.ClassificationControlDeclarationInfo) {
        rtnFlg = this.objKeyValueIsSame(
          this.declarationFormInfoAreaCopy,
          this.declarationFormInfoArea
        );
        if (rtnFlg) return rtnFlg;
        if (
          this.declarationFormInfoArea.returnCodeDeclarationyear ==
            this.settingCode ||
          this.declarationFormInfoArea.returnCodeManager == this.settingCode ||
          this.declarationFormInfoArea.returnCodeDataKbn == this.settingCode ||
          this.declarationFormInfoArea.returnCodeStatus ==
            this.settingCodeCheckBox
        ) {
          rtnFlg = true;
        }
        if (rtnFlg) return rtnFlg;
      }
      if (displayFlg.ClassificationControlAccessInfo) {
        rtnFlg = this.objKeyValueIsSame(
          this.accessInfoAreaCopy,
          this.accessInfoArea
        );
        if (rtnFlg) return rtnFlg;
        if (this.accessInfoArea.returnCodeAccessDate == this.settingCode) {
          rtnFlg = true;
        }
        if (rtnFlg) return rtnFlg;
      }
      if (displayFlg.ClassificationControlMemberInfo) {
        return this.memberInfoArea.motoPageHandleShowBtn;
      }
      return rtnFlg;
    },

    // **********************************************
    //二つのobjの値が等しいかどうかを確認
    // **********************************************
    objKeyValueIsSame(obj1, obj2) {
      let keysOne = Object.keys(obj1);
      let keysTwo = Object.keys(obj2);
      let rtnFlg = true;

      for (let key of keysOne) {
        if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
          if (
            !(
              obj1[key].length == obj2[key].length &&
              obj1[key].every((a) => obj2[key].some((b) => a == b)) &&
              obj2[key].every((c) => obj1[key].some((d) => c == d))
            )
          ) {
            rtnFlg = false;
            break;
          }
        } else {
          if (String(obj1[key]) !== String(obj2[key])) {
            rtnFlg = false;
            break;
          }
        }
      }

      return !rtnFlg;
    },

    filterCopy() {
      const {
        KessanDateCondition,
        KessanDateFromMonth,
        KessanDateFromDay,
        KessanDateToMonth,
        KessanDateToDay,
        returnCodeKessanDate,
      } = this.businessInfoArea;
      if (this.kessanDateCopyPageId.includes(this.pageId)) {
        this.businessInfoAreaCopy = {
          ...this.businessInfoAreaCopy,
          ...{
            KessanDateCondition,
            KessanDateFromMonth,
            KessanDateFromDay,
            KessanDateToMonth,
            KessanDateToDay,
            returnCodeKessanDate,
          },
        };
      }
      const { managerSelected, manager, returnCodeManager } =
        this.businessInfoArea;
      if (this.personInChargeCopyPageId.includes(this.pageId)) {
        this.businessInfoAreaCopy = {
          ...this.businessInfoAreaCopy,
          ...{
            managerSelected,
            manager,
            returnCodeManager,
          },
        };
      }

      const {
        returnCodeDeclarationyear,
        fiscalYearStartCondition,
        fiscalYearStartFromGengo,
        fiscalYearStartFromYear,
        fiscalYearStartFromMonth,
        fiscalYearStartFromDay,
        fiscalYearStartToGengo,
        fiscalYearStartToYear,
        fiscalYearStartToMonth,
        fiscalYearStartToDay,
        JigyoNendoToCondition,
        JigyoNendoToGengo,
        JigyoNendoToYear,
        JigyoNendoToMonth,
        JigyoNendoToDay,
        fiscalYearEndToGengo,
        fiscalYearEndToYear,
        fiscalYearEndToMonth,
        fiscalYearEndToDay,
        fiscalYearStartConditionKojin,
        fiscalYearStartFromGengoKojin,
        fiscalYearStartFromYearKojin,
        fiscalYearStartFromMonthKojin,
        fiscalYearStartFromDayKojin,
        fiscalYearStartToGengoKojin,
        fiscalYearStartToYearKojin,
        fiscalYearStartToMonthKojin,
        fiscalYearStartToDayKojin,
        JigyoNendoToConditionKojin,
        JigyoNendoToGengoKojin,
        JigyoNendoToYearKojin,
        JigyoNendoToMonthKojin,
        JigyoNendoToDayKojin,
        fiscalYearEndToGengoKojin,
        fiscalYearEndToYearKojin,
        fiscalYearEndToMonthKojin,
        fiscalYearEndToDayKojin,
      } = this.declarationFormInfoArea;
      if (this.declarationyearCopyPageId.includes(this.pageId)) {
        this.declarationFormInfoAreaCopy = {
          ...this.declarationFormInfoAreaCopy,
          ...{
            returnCodeDeclarationyear,
            fiscalYearStartCondition,
            fiscalYearStartFromGengo,
            fiscalYearStartFromYear,
            fiscalYearStartFromMonth,
            fiscalYearStartFromDay,
            fiscalYearStartToGengo,
            fiscalYearStartToYear,
            fiscalYearStartToMonth,
            fiscalYearStartToDay,
            JigyoNendoToCondition,
            JigyoNendoToGengo,
            JigyoNendoToYear,
            JigyoNendoToMonth,
            JigyoNendoToDay,
            fiscalYearEndToGengo,
            fiscalYearEndToYear,
            fiscalYearEndToMonth,
            fiscalYearEndToDay,
            fiscalYearStartConditionKojin,
            fiscalYearStartFromGengoKojin,
            fiscalYearStartFromYearKojin,
            fiscalYearStartFromMonthKojin,
            fiscalYearStartFromDayKojin,
            fiscalYearStartToGengoKojin,
            fiscalYearStartToYearKojin,
            fiscalYearStartToMonthKojin,
            fiscalYearStartToDayKojin,
            JigyoNendoToConditionKojin,
            JigyoNendoToGengoKojin,
            JigyoNendoToYearKojin,
            JigyoNendoToMonthKojin,
            JigyoNendoToDayKojin,
            fiscalYearEndToGengoKojin,
            fiscalYearEndToYearKojin,
            fiscalYearEndToMonthKojin,
            fiscalYearEndToDayKojin,
          },
        };
      }
      const { Status, returnCodeStatus } = this.declarationFormInfoArea;
      if (this.statusCopyPageId.includes(this.pageId)) {
        this.declarationFormInfoAreaCopy = {
          ...this.declarationFormInfoAreaCopy,
          ...{
            Status,
            returnCodeStatus,
          },
        };
      }

      const {
        AccessDateCondition,
        AccessDateFromGengo,
        AccessDateFromYMD,
        AccessDateFromYM,
        AccessDateFromYear,
        AccessDateFromMonth,
        AccessDateFromDay,
        AccessDateToGengo,
        AccessDateToYMD,
        AccessDateToYear,
        AccessDateToMonth,
        AccessDateToDay,
        returnCodeAccessDate,
      } = this.accessInfoArea;
      if (this.accessDateCopyPageId.includes(this.pageId)) {
        this.accessInfoAreaCopy = {
          ...this.accessInfoAreaCopy,
          ...{
            AccessDateCondition,
            AccessDateFromGengo,
            AccessDateFromYMD,
            AccessDateFromYM,
            AccessDateFromYear,
            AccessDateFromMonth,
            AccessDateFromDay,
            AccessDateToGengo,
            AccessDateToYMD,
            AccessDateToYear,
            AccessDateToMonth,
            AccessDateToDay,
            returnCodeAccessDate,
          },
        };
      }
    },
    //#endregion
  },
};
</script>

<style scoped>
.popup p:empty + .frm-row.frm-row-margin-top {
  margin-top: 20px;
}
#treatmentTarget label:nth-child(2) {
  width: 100px;
}
#ProcessingPartition label:nth-child(2) {
  width: 100px;
}
</style>
